{
  "enums": {
    "cfdi": {
      "cancellation_reason": {
        "01": "Se emitió con errores y ya la sustituiste por otra",
        "02": "Se emitió con errores y no hay factura que la sustituya",
        "03": "No se llevó a cabo la operación",
        "04": "Venta nominativa que ya estaba en la factura global"
      },
      "payment_form": {
        "01": "Efectivo",
        "02": "Cheque nominativo",
        "03": "Transferencia electrónica",
        "04": "Tarjeta de crédito",
        "28": "Tarjeta de débito",
        "99": "Por definir"
      },
      "payment_method": {
        "PPD": "Pago en parcialidades o diferido",
        "PUE": "Pago en una sola exhibición"
      },
      "tax_regime": {
        "601": "General de ley personas morales",
        "603": "Personas morales con fines no lucrativos",
        "605": "Sueldos y salarios e ingresos asimilados a salarios",
        "606": "Arrendamiento",
        "607": "Régimen de enajenación o adquisición de bienes",
        "608": "Demás ingresos",
        "610": "Residentes en el extranjero sin establecimiento permanente en México",
        "611": "Ingresos por dividendos — socios y accionistas",
        "612": "Personas físicas con actividades empresariales y profesionales",
        "614": "Ingresos por intereses",
        "615": "Régimen de los ingresos por obtención de premios",
        "616": "Sin obligaciones fiscales",
        "620": "Sociedades cooperativas de producción que difieren sus ingresos",
        "621": "Incorporación fiscal",
        "622": "Actividades agrícolas, ganaderas, silvícolas y pesqueras",
        "623": "Opcional para grupos de sociedades",
        "624": "Coordinados",
        "625": "Actividades empresariales con ingresos por plataformas tecnológicas",
        "626": "Régimen simplificado de confianza — RESICO"
      },
      "usage": {
        "CP01": "Pagos — complemento de una factura a crédito",
        "G01": "Compra de mercancía para el negocio",
        "G02": "Devoluciones, descuentos o bonificaciones",
        "G03": "Gastos en general — lo normal para un consumo",
        "S01": "Sin efectos fiscales — público en general"
      }
    },
    "location": {
      "bill": {
        "status": {
          "awaiting_payment": "Esperando pago",
          "cancelled": "Cancelada",
          "closed": "Cerrada",
          "open": "Abierta",
          "paid": "Pagada"
        }
      },
      "bill_join_request": {
        "status": {
          "approved": "Aprobada",
          "canceled": "Cancelada",
          "pending": "Pendiente",
          "rejected": "Rechazada"
        }
      },
      "cancellation_reason": {
        "bill_closed_pending": "Quedó pendiente al cerrar la cuenta",
        "diner_left": "El comensal se fue",
        "duplicate_order": "Pedido duplicado",
        "kitchen_cannot_prepare": "Cocina no lo puede preparar",
        "staff_error": "Error del personal",
        "test_order": "Pedido de prueba",
        "wrong_order": "Se capturó mal"
      },
      "category": {
        "status": {
          "active": "Activa",
          "forgiven": "Condonada",
          "inactive": "Inactiva"
        }
      },
      "channel": {
        "platform": {
          "didi_food": "DiDi Food",
          "rappi": "Rappi",
          "uber_eats": "Uber Eats"
        }
      },
      "channel_order": {
        "status": {
          "accepted": "Aceptada",
          "failed": "Falló",
          "received": "Recibida",
          "rejected": "Rechazada"
        }
      },
      "coupon_status": {
        "active": "Activo",
        "exhausted": "Agotado",
        "expired": "Expirado",
        "revoked": "Revocado"
      },
      "courier": {
        "status": {
          "available": "Disponible",
          "off_shift": "Fuera de turno",
          "on_delivery": "En reparto"
        }
      },
      "delivery": {
        "failure_reason": {
          "courier_incident": "Incidente del repartidor",
          "customer_refused": "El cliente la rechazó",
          "nobody_home": "Nadie abrió",
          "wrong_address": "Dirección equivocada"
        },
        "status": {
          "assigned": "Asignada",
          "delivered": "Entregada",
          "failed": "Falló",
          "pending": "Sin asignar",
          "picked_up": "En camino"
        }
      },
      "discount_kind": {
        "courtesy": "Cortesía",
        "fixed_amount": "Monto fijo",
        "percentage": "Porcentaje"
      },
      "discount_reason": {
        "kitchen_error": "Error de cocina",
        "loyalty_gesture": "Gesto de lealtad",
        "manager_courtesy": "Cortesía de la casa",
        "marketing_promotion": "Promoción",
        "price_match": "Igualación de precio",
        "service_recovery": "Compensación por servicio",
        "staff_meal": "Comida de personal"
      },
      "discount_source": {
        "coupon": "Cupón",
        "manual": "Aplicado por una persona",
        "promotion": "Promoción automática"
      },
      "discount_status": {
        "applied": "Aplicado",
        "pending": "Por autorizar",
        "rejected": "Rechazado",
        "superseded": "Reemplazado por un descuento manual",
        "voided": "Cancelado"
      },
      "extra": {
        "status": {
          "active": "Activo",
          "inactive": "Inactivo",
          "sold_out": "Agotado"
        }
      },
      "feature": {
        "cash_register": "Caja y turnos",
        "cfdi_invoicing": "Facturación CFDI",
        "daily_report_email": "Reporte diario por correo",
        "discounts": "Descuentos y cortesías",
        "dynamic_invites": "Invitación con QR del mesero",
        "external_channels": "Apps de reparto",
        "inventory": "Inventario",
        "item_stock": "Existencias por platillo",
        "kds": "Pantalla de cocina",
        "loyalty": "Clientes y lealtad",
        "multi_location": "Varias sucursales",
        "own_delivery": "Reparto propio",
        "pickup_orders": "Pedidos para llevar",
        "promotions": "Promociones y cupones",
        "public_menu": "Menú público",
        "purchasing": "Compras y proveedores",
        "receipt_printing": "Impresión de comandas y tickets",
        "refunds": "Reembolsos",
        "sales_reports": "Reportes de ventas",
        "tax_profiles": "Impuestos",
        "tip_policies": "Propinas",
        "waiter_call": "Llamar al mesero"
      },
      "feature_description": {
        "cash_register": "Abre y cierra turnos, registra entradas y salidas de efectivo y saca cortes X y Z.",
        "cfdi_invoicing": "Timbra facturas CFDI 4.0 y deja que tu comensal se autofacture.",
        "daily_report_email": "Manda cada mañana las ventas del día anterior al correo de tus gerentes.",
        "discounts": "Aplica descuentos y cortesías en la mesa, dejando registrado quién y por qué.",
        "dynamic_invites": "Permite que el mesero genere un QR temporal para sentar a un comensal. Con esto apagado, los comensales entran con el QR impreso de la mesa y tú autorizas.",
        "external_channels": "Recibe pedidos de Uber Eats, Rappi y DiDi Food en el mismo tablero.",
        "inventory": "Lleva existencias de insumos, recetas por platillo y mermas.",
        "item_stock": "Cuenta cuántas porciones de cada platillo puedes vender hoy y deja de ofrecerlo cuando se acaben.",
        "kds": "Muestra las comandas en una pantalla para cocina y barra, sin papel.",
        "loyalty": "Guarda a tus clientes frecuentes, acumula sellos y toma reservaciones.",
        "multi_location": "Agrupa esta sucursal con otras bajo una misma organización.",
        "own_delivery": "Reparte con tus propios repartidores y define tus zonas de entrega.",
        "pickup_orders": "Permite que tus comensales pidan por adelantado y pasen a recoger.",
        "promotions": "Programa promociones por horario y reparte cupones con código, sin que nadie tenga que aplicarlos.",
        "public_menu": "Publica tu menú en una página abierta para que la encuentren en buscadores.",
        "purchasing": "Registra proveedores, órdenes de compra y el costo de cada platillo.",
        "receipt_printing": "Manda comandas a cocina y tickets al comensal desde tus impresoras.",
        "refunds": "Devuelve un cobro con motivo obligatorio y traza completa.",
        "sales_reports": "Consulta ventas, mix de producto y control del turno.",
        "tax_profiles": "Elige tu régimen fiscal y las tasas que aplican en tu sucursal, y desglósalas en el ticket.",
        "tip_policies": "Define los porcentajes que se le sugieren al comensal y cómo se reparte la propina.",
        "waiter_call": "Permite que tus comensales llamen a un mesero desde su mesa."
      },
      "feature_group": {
        "expansion": "Crecimiento",
        "finance": "Dinero e impuestos",
        "operation": "Operación del turno",
        "service": "Atención a comensales",
        "supply": "Insumos y compras"
      },
      "invite": {
        "service_type": {
          "delivery": "Entrega",
          "eat_in": "Comer aquí",
          "pick_up": "Recoger",
          "take_out": "Para llevar"
        },
        "status": {
          "active": "Activa",
          "exhausted": "Agotada",
          "expired": "Expirada",
          "revoked": "Revocada"
        }
      },
      "invoice": {
        "kind": {
          "bill": "Factura de una cuenta",
          "global": "Factura global del día",
          "payment_complement": "Complemento de pago"
        },
        "status": {
          "cancellation_pending": "Esperando que el receptor acepte la cancelación",
          "cancelled": "Cancelada",
          "failed": "Falló el timbrado",
          "pending": "Por timbrar",
          "stamped": "Timbrada"
        }
      },
      "item": {
        "station": {
          "bar": "Barra",
          "cashier": "Caja",
          "dessert": "Postres",
          "kitchen": "Cocina"
        },
        "status": {
          "active": "Activo",
          "inactive": "Inactivo",
          "sold_out": "Agotado"
        }
      },
      "loyalty_entry": {
        "reason": {
          "expiry": "Vencimiento",
          "manual_adjustment": "Ajuste manual",
          "purchase": "Compra",
          "redemption": "Canje",
          "welcome_bonus": "Bono de bienvenida"
        }
      },
      "onboarding_requirement": {
        "address": "Dirección",
        "menu": "Menú",
        "operating_hours": "Horarios de operación",
        "payment_methods": "Al menos un método de pago habilitado",
        "payment_methods_confirmation": "Confirmación de métodos de pago para comensales",
        "stations": "Estaciones",
        "stripe_connect": "Stripe Connect listo para cobrar",
        "subscription": "Suscripción activa",
        "tables": "Mesas"
      },
      "order": {
        "paid_via": {
          "cash": "Efectivo",
          "digital_in_app": "Pago digital",
          "physical_card_terminal": "Tarjeta física"
        },
        "payment_status": {
          "locked": "En cobro",
          "paid": "Pagado",
          "unpaid": "Pendiente de pago"
        },
        "service_type": {
          "delivery": "Entrega",
          "eat_in": "Comer aquí",
          "pick_up": "Recoger",
          "take_out": "Para llevar"
        },
        "status": {
          "cancelled": "Cancelado",
          "completed": "Completado",
          "in_progress": "En Progreso",
          "no_show": "No se presentó",
          "pending": "Pendiente",
          "picked_up": "Entregado",
          "ready": "Listo",
          "ready_for_pickup": "Listo para pickup"
        }
      },
      "payment_attempt": {
        "payment_method": {
          "cash": "Efectivo",
          "digital_in_app": "Pago digital",
          "physical_card_terminal": "Tarjeta física"
        },
        "status": {
          "canceled": "Cancelado",
          "failed": "Fallido",
          "pending": "Pendiente",
          "processing": "Procesando",
          "requires_action": "Requiere acción",
          "succeeded": "Exitoso"
        }
      },
      "payment_provider_account": {
        "status": {
          "disabled": "Deshabilitada",
          "pending_onboarding": "Onboarding pendiente",
          "ready": "Lista",
          "restricted": "Restringida"
        }
      },
      "payment_transaction": {
        "status": {
          "canceled": "Cancelada",
          "checkout_ready": "Checkout listo",
          "failed": "Fallida",
          "partially_refunded": "Parcialmente reembolsada",
          "pending": "Pendiente",
          "processing": "Procesando",
          "refunded": "Reembolsada",
          "requires_action": "Requiere acción",
          "succeeded": "Exitosa"
        }
      },
      "promotion_kind": {
        "fixed_amount": "Monto fijo",
        "percentage": "Porcentaje"
      },
      "promotion_scope": {
        "bill": "Toda la cuenta",
        "categories": "Categorías elegidas",
        "items": "Platillos elegidos"
      },
      "promotion_status": {
        "active": "Activa",
        "archived": "Archivada",
        "draft": "Borrador"
      },
      "purchase": {
        "status": {
          "cancelled": "Cancelada",
          "draft": "Borrador",
          "received": "Recibida"
        }
      },
      "purchase_cancel_reason": {
        "duplicate_purchase": "Pedido duplicado al proveedor",
        "no_longer_needed": "Ya no se necesita",
        "ordered_by_mistake": "Se pidió por error",
        "price_changed": "El precio cambió",
        "supplier_cannot_deliver": "El proveedor no puede surtir"
      },
      "refund_reason": {
        "diner_changed_mind": "El comensal cambió de opinión",
        "duplicate_charge": "Cobro duplicado",
        "kitchen_error": "Error de cocina",
        "order_never_delivered": "El pedido nunca se entregó",
        "price_correction": "Corrección de precio",
        "service_error": "Error de servicio",
        "wrong_item": "Platillo equivocado"
      },
      "reopen_reason": {
        "additional_order": "El comensal pidió algo más",
        "closed_by_mistake": "Se cerró por error",
        "discount_correction": "Faltó aplicar un descuento",
        "payment_correction": "Corrección de cobro"
      },
      "reservation": {
        "status": {
          "booked": "Apartada",
          "cancelled": "Cancelada",
          "completed": "Completada",
          "no_show": "No llegó",
          "seated": "Sentada"
        }
      },
      "status": {
        "active": "Activa",
        "inactive": "Inactiva",
        "suspended": "Suspendida"
      },
      "stock_movement": {
        "reason": {
          "count_correction": "Ajuste por conteo",
          "purchase": "Compra",
          "recipe_consumption": "Consumo por receta",
          "theft": "Robo",
          "transfer_out": "Traspaso a otra sucursal",
          "waste": "Merma"
        }
      },
      "supply": {
        "unit": {
          "gram": "Gramos",
          "kilogram": "Kilogramos",
          "liter": "Litros",
          "milliliter": "Mililitros",
          "piece": "Piezas"
        }
      },
      "table": {
        "status": {
          "available": "Disponible",
          "disabled": "No disponible",
          "occupied": "Ocupada",
          "reserved": "Reservada"
        }
      },
      "tax_regime": {
        "mx": "México — IVA e IEPS",
        "us": "Estados Unidos — sales tax"
      },
      "user": {
        "role": {
          "bartender": "Bartender",
          "cashier": "Caja",
          "cook": "Cocina",
          "manager": "Gerente",
          "waiter": "Mesero"
        }
      },
      "visit": {
        "status": {
          "active": "Activa",
          "closed": "Cerrada"
        }
      }
    },
    "organization_membership": {
      "role": {
        "admin": "Administrador",
        "owner": "Propietario"
      }
    },
    "payments": {
      "stripe_webhook_event": {
        "status": {
          "failed": "Fallido",
          "processed": "Procesado",
          "received": "Recibido"
        }
      }
    }
  },
  "notifications": {
    "staff": {
      "bill_closed": {
        "message": "La cuenta #%{bill_id} se cerró.",
        "title": "Cuenta cerrada"
      },
      "bill_join_request": {
        "message": "Hay una solicitud nueva para la cuenta #%{bill_id}.",
        "title": "Solicitud para unirse a cuenta"
      },
      "entry_requested": {
        "message": "%{name} pide entrar en %{table}.",
        "title": "Alguien quiere entrar a una mesa"
      },
      "entry_requested_no_table": {
        "message": "%{name} pide entrar.",
        "title": "Alguien quiere entrar a una mesa"
      },
      "item_stock_depleted": {
        "message": "%{item} ya no está disponible para pedir.",
        "title": "Se acabó un platillo"
      },
      "item_stock_low": {
        "message": "Te quedan %{count} de %{item}.",
        "title": "Se está acabando un platillo"
      },
      "order_accepted": {
        "message": "La comanda #%{order_id} inició preparación.",
        "title": "Comanda aceptada"
      },
      "order_created": {
        "message": "Se registró la comanda #%{order_id}.",
        "title": "Nueva comanda"
      },
      "order_ready": {
        "message": "La comanda #%{order_id} está lista.",
        "title": "Comanda lista"
      },
      "payment_failed": {
        "message": "Falló un pago para la cuenta #%{bill_id}.",
        "title": "Pago fallido"
      },
      "payment_succeeded": {
        "message": "Se confirmó un pago para la cuenta #%{bill_id}.",
        "title": "Pago exitoso"
      },
      "service_reactivated": {
        "message": "La sucursal volvió a estado activo.",
        "title": "Operación reactivada"
      },
      "service_suspension": {
        "message": "La sucursal fue suspendida por cuenta impaga.",
        "title": "Operación suspendida"
      }
    },
    "user": {
      "bill_closed": {
        "message": "Tu cuenta #%{bill_id} quedó cerrada. ¡Gracias por tu visita!",
        "title": "Cerramos tu cuenta"
      },
      "entry_requested": {
        "message": "%{name} pide autorización para unirse a tu mesa.",
        "title": "Alguien quiere unirse"
      },
      "join_request_updated": {
        "message": "Tu solicitud para la cuenta #%{bill_id} cambió a %{status}.",
        "title": "Solicitud actualizada"
      },
      "order_created": {
        "message": "Tu orden #%{order_id} fue registrada.",
        "title": "Orden recibida"
      },
      "order_status_changed": {
        "message": "La orden #%{order_id} cambió a %{status}.",
        "title": "Estado de orden actualizado"
      },
      "payment_failed": {
        "message": "El pago de tu cuenta #%{bill_id} no se pudo completar.",
        "title": "Pago fallido"
      },
      "payment_succeeded": {
        "message": "Se confirmó el pago de tu cuenta #%{bill_id}.",
        "title": "Pago confirmado"
      },
      "waiter_call_acknowledged": {
        "message": "Ya tomamos tu llamada. En un momento alguien llega a tu mesa.",
        "title": "Un mesero va en camino"
      }
    }
  },
  "ui": {
    "admin": {
      "events": {
        "actor": {
          "system": "Sistema"
        },
        "headers": {
          "actor": "Autor",
          "added": "Agregado",
          "location": "Sucursal"
        }
      },
      "jobs": {
        "errors": {
          "invalid_arguments": "Argumentos inválidos para %{class_name}: %{message}",
          "invalid_json": "Argumentos JSON inválidos.",
          "job_not_allowed": "Job no permitido: %{class_name}",
          "json_shape": "El JSON debe ser un objeto o un arreglo.",
          "keywords_not_accepted": "%{class_name} no acepta argumentos con nombre. Esperados: %{expected}",
          "missing_core_table": "No se encontró la tabla %{table}. Verifica la conexión de Solid Queue y corre las migraciones de queue.",
          "missing_keywords": "Faltan argumentos obligatorios de %{class_name}: %{keywords}. Esperados: %{expected}",
          "missing_tables": "Faltan tablas de Solid Queue: %{tables}",
          "mixed_signature": "%{class_name} mezcla argumentos posicionales y con nombre; no se puede encolar desde este formulario. Firma: %{expected}",
          "positional_not_accepted": "%{class_name} no acepta argumentos posicionales. Esperados: %{expected}",
          "queue_database_unavailable": "Verifica que la base de datos de queue esté configurada y migrada.",
          "serialization_failed": "No se pudieron serializar los argumentos: %{message}",
          "unknown_keywords": "Argumentos no reconocidos por %{class_name}: %{keywords}. Esperados: %{expected}",
          "wrong_arity": "%{class_name} espera %{expected} argumentos posicionales, se recibieron %{given}."
        },
        "no_arguments": "Sin argumentos",
        "no_message": "Sin mensaje",
        "schema": {
          "blocked_executions": "Jobs bloqueados por límites de concurrencia.",
          "claimed_executions": "Jobs en ejecución tomados por un proceso activo.",
          "failed_executions": "Jobs fallidos con error serializado.",
          "jobs": "Registro de jobs creados y su estado final (finished_at).",
          "pauses": "Colas pausadas manualmente.",
          "processes": "Workers y dispatchers con heartbeat.",
          "ready_executions": "Jobs listos para ser tomados por un worker.",
          "recurring_tasks": "Tareas recurrentes declaradas en Solid Queue.",
          "scheduled_executions": "Jobs programados para ejecutarse en el futuro."
        },
        "select_job": "Selecciona un job."
      },
      "users": {
        "confirmed": "Confirmado",
        "last_activity": "Última actividad"
      }
    },
    "app": {
      "name": "Menny"
    },
    "auth": {
      "admin": {
        "blurb": "Operación, cobros y sucursales en un solo lugar.",
        "headline": "Todo el sistema, a la vista."
      },
      "staff": {
        "blurb": "Entra y sigue donde lo dejaste.",
        "headline": "Aquí empieza el turno."
      },
      "titles": {
        "admin_sign_in": "Iniciar sesión · Admin",
        "staff_invite": "Invitación a un restaurante",
        "staff_password_edit": "Nueva contraseña · Staff",
        "staff_password_new": "Recuperar contraseña · Staff",
        "staff_sign_in": "Iniciar sesión · Staff",
        "user_password_edit": "Nueva contraseña",
        "user_password_new": "Recuperar contraseña",
        "user_sign_in": "Iniciar sesión",
        "user_sign_up": "Crea tu cuenta"
      },
      "user": {
        "blurb": "Tu cuenta sigue abierta donde la dejaste.",
        "headline": "Pide y paga desde tu mesa."
      }
    },
    "billing": {
      "location_status": {
        "in_production": "En producción",
        "pending_configuration": "Configuración pendiente"
      },
      "seat_requested": "Estamos cobrando esta sucursal. En cuanto entre el pago, abre sola.",
      "settings_updated": "Configuración de cobranza actualizada.",
      "stripe": {
        "charges_payouts_ready": "Cargos y payouts habilitados.",
        "confirmed": "Confirmada",
        "digital_requirements_missing": "Todavía faltan requisitos para cobrar digital.",
        "no_connected_account": "Sin cuenta conectada",
        "no_enabled_methods": "Sin métodos habilitados",
        "none": "Ninguno",
        "not_connected": "Todavía no conectada",
        "pending": "Pendiente",
        "ready_to_charge": "Listo para cobrar",
        "requires_action": "Requiere acción",
        "restricted": "Restringido",
        "unconfigured": "Sin configurar"
      },
      "stripe_status_refresh_failed": "No pudimos actualizar el estado de Stripe. Intenta de nuevo en un momento.",
      "stripe_status_refreshed": "Actualizamos el estado de tu cuenta de Stripe."
    },
    "bills": {
      "label": "Cuenta #%{id}",
      "label_with_status_and_total": "Cuenta #%{id} · %{status} · %{total}"
    },
    "cfdi": {
      "errors": {
        "already_cancelled": "Esta factura ya está cancelada.",
        "already_invoiced": "Esta cuenta ya tiene una factura vigente. Cancélala antes de emitir otra.",
        "attempts_exhausted": "Ya lo intentamos varias veces y no se pudo. Contacta a soporte para revisarlo contigo.",
        "bill_not_paid": "Solo puedes facturar una cuenta que ya esté pagada.",
        "cancel_not_allowed": "El SAT no deja cancelar esta factura. Si ya pasó el plazo, tienes que emitir una nota de crédito.",
        "cancel_reason_required": "Elige un motivo de cancelación del catálogo del SAT.",
        "cancel_requires_acceptance": "Tu cliente tiene que aceptar la cancelación. Ya se la pedimos y te avisamos en cuanto responda.",
        "cancellation_rejected": "El SAT rechazó la cancelación. Revisa el motivo y vuelve a intentarlo.",
        "duplicate_document": "Esta cuenta ya tiene una factura timbrada. Búscala en el historial en lugar de generar otra.",
        "feature_off": "Este restaurante no tiene la facturación CFDI activada.",
        "invalid_document": "La factura lleva datos que el SAT no acepta. Revisa los datos fiscales del restaurante y vuelve a intentarlo.",
        "invalid_usage": "Ese uso de CFDI no se puede elegir aquí.",
        "invoice_cancelled": "Esta factura ya se canceló, así que no se puede timbrar.",
        "issuer_certificate_expired": "El certificado de sello de tu restaurante ya venció. Renuévalo con el SAT y cárgalo con tu proveedor de timbrado.",
        "month_closed": "Ya pasó el mes en que se pagó esta cuenta, así que no se puede facturar de forma individual.",
        "no_tax_profile": "Todavía no cargas los datos fiscales de tu restaurante. Complétalos para poder facturar.",
        "not_retryable": "Esta factura no se puede volver a intentar hasta que corrijas lo que la detuvo.",
        "not_stamped": "Esta factura todavía no se timbra, así que no hay nada que cancelar.",
        "nothing_to_invoice": "Esta cuenta no tiene nada que facturar.",
        "pac_insufficient_credit": "Se te acabaron los timbres con tu proveedor. Compra más para poder seguir facturando.",
        "pac_rate_limited": "Mandamos demasiadas facturas de golpe. Lo volvemos a intentar solos en unos minutos.",
        "pac_timeout": "El proveedor de timbrado no respondió a tiempo. Lo volvemos a intentar solos, no tienes que hacer nada.",
        "pac_unauthorized": "El proveedor de timbrado rechazó tu conexión. Revisa la llave de tu PAC en los datos fiscales del restaurante.",
        "pac_unavailable": "El SAT o tu proveedor de timbrado están caídos. Lo volvemos a intentar solos, no tienes que hacer nada.",
        "receiver_rfc_unknown": "El SAT no reconoce el RFC que te dieron. Pídeselo otra vez a tu cliente y revisa que no le falte una letra.",
        "substitute_required": "Escribe el folio de la factura que reemplaza a ésta.",
        "unbalanced_document": "Las cifras de la factura no cuadran. Contacta a soporte antes de volver a intentarlo.",
        "unknown": "No pudimos timbrar la factura. Contacta a soporte con la clave %{code}.",
        "unmapped_tax": "No sabemos qué impuesto del SAT es %{names}. Renómbralo a IVA o IEPS en la configuración de impuestos.",
        "unspecified": "No pudimos timbrar la factura y el proveedor no dijo por qué. Vuelve a intentarlo en unos minutos."
      },
      "global_concepto": "Venta al público en general — cuenta #%{bill_id}",
      "pac_environment": {
        "production": "Producción",
        "sandbox": "Pruebas"
      }
    },
    "common": {
      "actions": {
        "back": "Volver",
        "cancel": "Cancelar",
        "close": "Cerrar",
        "confirm": "Confirmar",
        "delete": "Eliminar",
        "edit": "Editar",
        "save": "Guardar",
        "save_changes": "Guardar cambios"
      },
      "bill": {
        "one": "cuenta",
        "other": "cuentas"
      },
      "false": "No",
      "free": "Gratis",
      "item": {
        "one": "producto",
        "other": "productos"
      },
      "item_count": {
        "one": "producto",
        "other": "productos"
      },
      "no_activity": "Sin actividad",
      "no_message": "Sin mensaje",
      "no_table": "Sin mesa",
      "no_waiter": "Sin mesero",
      "not_available": "—",
      "order": {
        "one": "comanda",
        "other": "comandas"
      },
      "order_count": {
        "one": "comanda",
        "other": "comandas"
      },
      "person": {
        "one": "persona",
        "other": "personas"
      },
      "table": {
        "one": "mesa",
        "other": "mesas"
      },
      "true": "Sí",
      "unassigned": "Sin asignar",
      "unknown": "Desconocido"
    },
    "dashboard": {
      "quick_stats": {
        "active_orders": {
          "description": "Comandas en flujo de preparación o entrega.",
          "label": "Comandas activas"
        },
        "open_bills": {
          "description": "Cuentas aún no cerradas.",
          "label": "Cuentas abiertas"
        },
        "pending_payments": {
          "description": "Intentos de cobro en estado pendiente.",
          "label": "Cobros pendientes"
        },
        "ready_orders": {
          "description": "Comandas listas para mesa o pickup.",
          "label": "Listas para entregar"
        }
      }
    },
    "email_verification": {
      "code": {
        "change_email": "Usar otro correo",
        "code_label": "Código de verificación",
        "description": "Enviamos un código de %{length} dígitos a %{email}.",
        "expiry_hint": "El código expira en %{minutes} minutos.",
        "no_email_hint": "¿No te llegó? Revisa tu carpeta de spam.",
        "resend": "Enviar otro código",
        "submit": "Verificar correo",
        "submit_processing": "Verificando",
        "title": "Escribe tu código"
      },
      "details": {
        "change_email": "Cambiar",
        "verified_badge": "Correo verificado"
      },
      "send": {
        "description": "Te enviamos un código para confirmar que la dirección es tuya. Todavía no creamos ninguna cuenta.",
        "email_label": "Correo electrónico",
        "email_placeholder": "m@ejemplo.com",
        "submit": "Enviar código",
        "submit_processing": "Enviando",
        "title": "Verifica tu correo"
      }
    },
    "errors": {
      "admin_location_delete_failed": "No se pudo eliminar la sucursal.",
      "admin_location_update_failed": "No se pudo actualizar la sucursal.",
      "already_registered_account": "Ya tienes una cuenta registrada.",
      "anonymous_users_only": "Solo los usuarios anónimos pueden completar registro",
      "array_attribute_required": "debe ser un arreglo",
      "bill_already_splitting": "Esta cuenta ya se está dividiendo.",
      "bill_already_status": "La cuenta ya está %{status}.",
      "bill_blocking_orders": {
        "one": "Hay %{count} comanda en proceso que no puede abandonarse.",
        "other": "Hay %{count} comandas en proceso que no pueden abandonarse."
      },
      "bill_has_orders": "No se puede eliminar la cuenta porque tiene comandas asociadas.",
      "bill_invite_same_location": "Bill e invitación deben pertenecer a la misma sucursal",
      "bill_is_being_split": "La mesa está dividiendo la cuenta; no se pueden pagar productos por separado.",
      "bill_missing_for_location": "La cuenta no existe o no pertenece a la sucursal actual.",
      "bill_missing_or_not_open": "La cuenta no existe o ya no está abierta.",
      "bill_must_be_closed_to_cancel": "La cuenta debe estar cerrada para cancelarse.",
      "bill_must_be_closed_to_reopen": "La cuenta debe estar cerrada para reabrirse.",
      "bill_must_be_open_to_charge": "La cuenta debe estar abierta para cobrar.",
      "bill_must_belong_to_selected_table": "debe pertenecer a la mesa seleccionada",
      "bill_no_unpaid_items": "La cuenta ya no tiene productos pendientes por cobrar.",
      "bill_not_available_to_charge": "La cuenta no está disponible para cobrar.",
      "bill_not_open_or_missing": "no existe o no está abierta",
      "bill_payment_forbidden": "No tienes permisos para cobrar esta cuenta.",
      "bill_reopen_pending_payment": "no puede reabrirse mientras existe un cobro en curso",
      "bill_selected_closed": "La cuenta seleccionada ya se cerró.",
      "bill_selected_unavailable": "La cuenta seleccionada no está disponible.",
      "bill_selection_required": "no pudo resolverse: la mesa tiene más de una cuenta abierta. Resuélvelas desde Cuentas antes de agregar productos.",
      "bill_split_outstanding": "La mesa está dividiendo la cuenta. Cancela la división antes de cerrarla.",
      "bill_split_outstanding_cancel": "La mesa está dividiendo la cuenta. Cancela la división antes de cancelar la cuenta.",
      "bill_split_outstanding_reopen": "La mesa está dividiendo la cuenta. Cancela la división antes de reabrirla.",
      "cancel_reason_invalid": "Ese motivo de cancelación no existe.",
      "cannot_revoke_self": "No puedes revocar tu propio acceso de administrador.",
      "cash_amount_invalid": "Escribe un monto válido, por ejemplo 1250.50.",
      "cash_amount_negative": "El monto no puede ser negativo.",
      "cash_amount_not_positive": "El monto tiene que ser mayor a cero.",
      "cash_movement_kind_invalid": "Ese tipo de movimiento no existe.",
      "cash_movement_reason_invalid": "Ese motivo de movimiento no existe.",
      "cash_movement_reason_not_manual": "Ese movimiento no se registra a mano. Haz el reembolso desde la cuenta para que quede la traza completa.",
      "cash_register_permission_required": "No tienes permisos para operar la caja.",
      "category_delete_failed": "No se pudo eliminar la categoría.",
      "central_item_other_organization": "Ese platillo no pertenece a tu organización.",
      "central_item_update_failed": "No pudimos guardar el platillo central.",
      "central_price_failed": "No pudimos aplicar el precio. Ninguna sucursal cambió.",
      "cfdi_substitute_required": "es obligatorio cuando cancelas por sustitución: escribe el folio de la factura que reemplaza a ésta",
      "channel_other_location": "Ese canal no pertenece a este restaurante.",
      "channel_update_failed": "No pudimos actualizar el canal.",
      "checkout_session_missing": "Este cobro no tiene una sesión de pago activa.",
      "counter_customer_name_required": "Escribe el nombre de quien recoge el pedido.",
      "coupon_already_redeemed": "Ese cupón ya se usó.",
      "coupon_delete_failed": "Ese cupón ya se usó, así que no se puede borrar. Revócalo para que deje de funcionar.",
      "coupon_expired": "Ese cupón ya venció.",
      "coupon_line_already_discounted": "Esa cuenta ya tiene un descuento aplicado.",
      "coupon_not_found": "Ese código no existe en este restaurante.",
      "coupon_not_redeemable": "Ese cupón ya no se puede usar.",
      "coupon_nothing_to_discount": "Ese cupón no aplica a lo que traes en el carrito.",
      "coupon_other_location": "Ese cupón es de otra sucursal.",
      "coupon_outside_window": "Ese cupón no aplica a esta hora.",
      "coupon_promotion_inactive": "La promoción de ese cupón ya no está activa.",
      "coupon_redemption_count_max": "Ese cupón ya llegó a su límite de usos.",
      "coupon_revoked": "Ese cupón fue cancelado.",
      "courier_delete_failed": "No pudimos eliminar al repartidor.",
      "courier_on_delivery": "No puedes cambiarle el turno a alguien que trae un pedido.",
      "courier_other_location": "Ese repartidor no pertenece a este restaurante.",
      "courier_update_failed": "No pudimos guardar al repartidor.",
      "current_password_invalid": "La contraseña actual es incorrecta",
      "customer_insufficient_points": "El cliente no tiene tantos puntos.",
      "customer_not_identifiable": "Necesitas al menos un nombre, teléfono, correo o cuenta.",
      "customer_other_location": "Ese cliente no pertenece a este restaurante.",
      "customer_points_invalid": "Los puntos tienen que ser un número positivo.",
      "delivery_illegal_transition": "Esa entrega ya no está en ese estado. Recarga la pantalla.",
      "delivery_other_location": "Esa entrega no pertenece a este restaurante.",
      "delivery_reason_required": "Dinos qué pasó para poder marcarla como fallida.",
      "digital_checkout_only": "Solo los cobros digitales usan Stripe Checkout.",
      "digital_payment_requires_stripe": "Stripe Connect debe estar listo para habilitar pagos digitales.",
      "digital_payment_resolution_forbidden": "Los cobros digitales se resuelven desde Stripe.",
      "diner_has_other_active_bill": "El comensal ya tiene otra cuenta activa.",
      "diner_name_required": "Escribe tu nombre para unirte a la mesa.",
      "discount_actor_required": "Un descuento manual tiene que quedar a nombre de quien lo aplicó.",
      "discount_already_applied": "Ese producto ya tiene un descuento. Quítalo antes de aplicar otro.",
      "discount_amount_not_positive": "El descuento tiene que ser mayor a cero.",
      "discount_authorization_required": "Solo un gerente puede autorizar o rechazar un descuento.",
      "discount_bill_cancelled": "Esta cuenta está cancelada.",
      "discount_bill_not_open": "Esta cuenta ya no está abierta, así que no admite descuentos.",
      "discount_exceeds_line": "El descuento no puede ser mayor al precio del producto.",
      "discount_kind_invalid": "Ese tipo de descuento no existe.",
      "discount_line_cancelled": "Ese producto está cancelado.",
      "discount_line_locked": "Ese producto está apartado por un cobro en curso.",
      "discount_line_other_bill": "Ese producto no está en esta cuenta.",
      "discount_line_paid": "Ese producto ya se pagó.",
      "discount_not_pending": "Ese descuento ya se resolvió.",
      "discount_nothing_to_discount": "No queda nada por descontar en esta cuenta.",
      "discount_other_location": "Esa cuenta es de otra sucursal.",
      "discount_payment_in_flight": "Hay un cobro en curso: espera a que termine antes de aplicar el descuento.",
      "discount_permission_required": "No tienes permisos para aplicar descuentos.",
      "discount_promotion_required": "Un descuento automático tiene que decir de qué promoción salió.",
      "discount_reason_invalid": "Ese motivo de descuento no existe.",
      "discount_split_settling": "Esta cuenta ya empezó a dividirse y alguien pagó su parte. Ya no puedes cambiar el monto.",
      "dish_unavailable": "Ese platillo ya no está disponible.",
      "email_address_invalid": "Escribe un correo electrónico válido.",
      "email_verification_required": "Verifica tu correo antes de crear tu cuenta.",
      "empty_order_items": "Debes agregar al menos un producto",
      "entry_request_already_resolved": "Alguien más ya respondió esta solicitud.",
      "entry_request_already_seated_elsewhere": "Ya tienes una mesa abierta en %{table}. Cierra tu cuenta antes de cambiarte de mesa.",
      "entry_request_approve_forbidden": "No puedes autorizar esta entrada.",
      "entry_request_expired": "Tu solicitud venció. Puedes pedirlo otra vez.",
      "entry_request_missing": "La solicitud de entrada ya no existe.",
      "entry_request_not_rejected": "Esa solicitud no fue rechazada.",
      "entry_request_pending_cap_reached": "Ya hay demasiadas personas esperando para entrar en esta mesa. Pídele a alguien del restaurante que te ayude a entrar.",
      "entry_request_refused_cooldown": "Ya te dijeron que no. Pídele a alguien en la mesa que te deje entrar.",
      "entry_request_requires_static_invite": "solo aplica a un QR de mesa impreso",
      "entry_request_table_unavailable": "Esta mesa no está en servicio ahora mismo.",
      "entry_request_too_many_attempts": "Hubo demasiadas solicitudes con este código. Espera unos minutos o pídele ayuda a alguien del restaurante.",
      "expire_requires_digital": "Solo los pagos digitales tienen sesión que expirar.",
      "extra_attachable_type_invalid": "Los extras no se pueden asociar a ese registro",
      "extra_group_max_below_min": "El máximo de selecciones no puede ser menor al mínimo",
      "extra_location_mismatch": "El extra debe pertenecer a la misma sucursal que su grupo",
      "extra_rules_violated": "Los extras seleccionados no cumplen las opciones requeridas",
      "extras_reorder_failed": "No pudimos guardar el nuevo orden. Recarga e inténtalo de nuevo.",
      "feature_not_available": "Esta función no está disponible para tu restaurante.",
      "feature_unknown": "Esa función no existe.",
      "google_auth_failed": "No pudimos iniciar tu sesión con Google. Intenta de nuevo.",
      "hard_destroy_not_allowed": "Este registro no se puede eliminar de forma permanente; usa la eliminación reversible.",
      "idempotency_key_conflict": "La clave de idempotencia ya está asociada a otra cuenta.",
      "image_format_invalid": "must be a valid image format (JPEG, PNG, GIF, WebP)",
      "image_too_large": "must be less than 10MB",
      "invalid_credentials": "Correo electrónico o contraseña incorrectos.",
      "invalid_modifiers": "contiene opciones inválidas o no disponibles",
      "invalid_order_status": "Ese estado no existe.",
      "invalid_payment_method": "Método de pago inválido.",
      "invalid_resolution_status": "estado de resolución inválido",
      "invalid_time_zone": "no es una zona horaria válida",
      "invalid_user": "Usuario inválido",
      "invite_exhausted": "La invitación alcanzó su límite de usos.",
      "invite_expired": "La invitación expiró.",
      "invite_missing_or_invalid": "La invitación no existe o ya no es válida.",
      "invite_revoke_forbidden": "No tienes permisos para revocar esta invitación.",
      "invite_revoked": "La invitación fue revocada.",
      "invite_unavailable": "La invitación ya no está disponible.",
      "invite_used_count_max": "debe ser menor o igual a max_uses",
      "invoice_missing_for_location": "Esa factura no pertenece a este restaurante.",
      "item_delete_failed": "No se pudo eliminar el producto.",
      "item_extras_update_failed": "No se pudieron guardar los grupos de extras. Inténtalo de nuevo.",
      "item_inactive": "está inactivo",
      "item_inactive_unavailable": "está inactivo",
      "item_not_found": "no existe",
      "item_out_of_stock": "ya no tiene existencias",
      "item_out_of_stock_unavailable": "se quedó sin existencias",
      "item_sold_out": "está marcado como agotado",
      "item_sold_out_unavailable": "está marcado como agotado",
      "item_stock_already_counted": "Ese platillo ya está en la lista de existencias.",
      "item_stock_other_location": "Ese platillo es de otra sucursal.",
      "item_stock_update_failed": "No se pudieron actualizar las existencias.",
      "items_already_paid": "Algunos productos seleccionados ya fueron pagados.",
      "items_locked_for_payment": "Algunos productos seleccionados ya están en otro cobro en curso.",
      "join_bill_not_found": "No se encontró la cuenta para unirse.",
      "last_manager_required": "Debe existir al menos un gerente activo",
      "last_manager_required_in_location": "Debe existir al menos un gerente activo en la sucursal.",
      "launch_missing_requirements": "Faltan requisitos para salir a producción: %{requirements}",
      "launched_location_requires_payment_method": "Una sucursal en producción debe mantener al menos un método de pago habilitado.",
      "location_description_too_long": "No puede tener más de %{max} caracteres.",
      "location_feature_unavailable": "Esa función no está prendida en tu restaurante.",
      "location_not_found": "Sucursal no encontrada",
      "location_not_live": "Este restaurante todavía no está disponible en Menny.",
      "location_slug_invalid": "Usa minúsculas, números y guiones, de al menos 3 caracteres.",
      "location_slug_just_taken": "Alguien más acaba de tomar esa dirección. Prueba con otra.",
      "location_slug_unavailable": "Esa dirección no está disponible. Elige otra.",
      "manage_bills_forbidden": "No tienes permisos para gestionar cuentas.",
      "manager_access_required": "Solo los gerentes pueden acceder a esta sección.",
      "modifiers_array": "must be an array",
      "no_authenticated_actor": "No hay actor autenticado para registrar el cobro.",
      "no_open_shift": "Abre la caja antes de registrar un cobro en efectivo o con terminal.",
      "no_open_shift_for_movement": "Abre la caja antes de registrar una entrada o salida de efectivo.",
      "no_open_shift_for_order": "Abre la caja antes de tomar una comanda.",
      "nothing_to_divide": "No hay productos por pagar para dividir.",
      "open_bill_required": "Necesitas una cuenta abierta para hacer esto.",
      "operation_suspended": "Operación suspendida por cuenta impaga.",
      "operation_suspended_billing": "La operación está suspendida por cuenta impaga.",
      "order_bill_immutable": "no puede cambiarse una vez creada la comanda",
      "order_money_frozen": "Ya hay un cobro sobre este producto: su precio, cantidad y descuento quedaron congelados.",
      "order_not_found": "No encontramos esa orden.",
      "organization_admin_access_required": "Solo los propietarios y administradores pueden cambiar los datos de la organización.",
      "organization_invite": {
        "already_member": "Esa persona ya es miembro de la organización.",
        "invalid_email": "Revisa el correo electrónico, no parece válido.",
        "invalid_role": "Ese tipo de acceso no existe.",
        "not_found": "Esa invitación ya no existe."
      },
      "organization_owner_access_required": "Solo los propietarios de la organización pueden administrar sus miembros.",
      "parent_id_required": "id is required",
      "parent_same_location": "must belong to the same location",
      "parent_self_reference": "cannot reference itself",
      "parent_type_invalid": "type is invalid",
      "parent_type_required": "type is required",
      "password_confirmation_mismatch": "Las contraseñas no coinciden.",
      "password_reset_link_invalid": "El enlace de restablecimiento de contraseña no es válido o ha expirado.",
      "payment_already_in_progress": "Ya existe un cobro en curso para esta cuenta.",
      "payment_attempt_not_pending": "Este cobro ya no está en curso.",
      "payment_permission_required": "No tienes permisos para cobrar.",
      "pending_payment_cancel": "Hay un intento de pago pendiente. Resuélvelo antes de cancelar la cuenta.",
      "pending_payment_close": "Hay un intento de pago pendiente. Resuélvelo antes de cerrar la cuenta.",
      "pending_payment_reopen": "Hay un intento de pago pendiente. Resuélvelo antes de reabrir la cuenta.",
      "pickup_digital_payment_requires_availability": "El restaurante debe confirmar disponibilidad y ETA antes del pago digital de pickup.",
      "pickup_eta_required": "debe establecerse para pickup cuando la comanda está lista",
      "pickup_registered_account_required": "Pickup requiere una cuenta registrada.",
      "pickup_split_not_supported": "Pickup no soporta split bill en MVP.",
      "pickup_status_only": "solo aplica para comandas pickup",
      "pickup_tip_not_supported": "Pickup no soporta propina en MVP.",
      "pickup_unavailable": "Este restaurante no está tomando pedidos para llevar.",
      "promotion_dates_ordered": "La fecha de fin no puede ser anterior a la de inicio.",
      "promotion_delete_failed": "Esta promoción ya aplicó descuentos en cuentas reales, así que no se puede borrar. Archívala para que deje de aplicarse.",
      "promotion_other_location": "Esa promoción es de otra sucursal.",
      "promotion_percentage_ceiling": "El porcentaje no puede pasar de %{max}.",
      "promotion_target_other_location": "Ese platillo o categoría es de otra sucursal.",
      "promotion_target_type_invalid": "Una promoción solo puede apuntar a platillos o categorías.",
      "promotion_targets_update_failed": "No pudimos guardar los platillos o categorías de esta promoción.",
      "provider_in_use_for_location": "ya está en uso para esta sucursal",
      "purchase_already_received": "Esta compra ya se había recibido. El inventario no se movió otra vez.",
      "purchase_cancelled_cannot_receive": "Esta compra está cancelada, así que ya no se puede recibir.",
      "purchase_empty": "Esta compra no tiene insumos: no hay nada que recibir.",
      "purchase_invalid_cancel_reason": "Elige un motivo de cancelación de la lista.",
      "purchase_line_location_mismatch": "debe ser un insumo de la misma sucursal que la compra",
      "purchase_lines_required": "Agrega al menos un insumo a la compra.",
      "purchase_not_cancellable": "Solo se puede cancelar una compra en borrador. Si ya la recibiste, registra el movimiento en el inventario.",
      "purchase_other_location": "Esa compra es de otra sucursal.",
      "purchase_supply_other_location": "Uno de los insumos de la compra es de otra sucursal.",
      "recipe_line_component_missing": "Elige un platillo o un extra para la receta.",
      "recipe_line_location_mismatch": "El producto, el extra y el insumo deben ser de la misma sucursal",
      "recipe_line_one_component": "Una línea de receta pertenece a un producto o a un extra, no a los dos",
      "recipe_line_other_location": "Esa línea de receta es de otra sucursal.",
      "recipe_line_quantity_positive": "La cantidad de la receta tiene que ser mayor a cero.",
      "recipe_line_save_failed": "No se pudo guardar la línea de receta.",
      "refund_already_fully_refunded": "Ese cobro ya se devolvió completo.",
      "refund_amount_invalid": "Escribe un monto válido, por ejemplo 250.00.",
      "refund_amount_not_positive": "El monto del reembolso tiene que ser mayor a cero.",
      "refund_exceeds_charge": "No puedes devolver más de lo que queda de ese cobro.",
      "refund_missing_movement": "Un reembolso en efectivo tiene que quedar registrado como salida de caja.",
      "refund_needs_open_shift": "Abre la caja antes de devolver efectivo: el dinero sale del cajón de hoy.",
      "refund_not_refundable": "Ese cobro ya no admite reembolso.",
      "refund_other_location": "Ese cobro es de otra sucursal.",
      "refund_permission_required": "No tienes permisos para hacer reembolsos.",
      "refund_provider_missing": "Ese cobro digital no tiene un cargo en Stripe que podamos revertir.",
      "refund_reason_invalid": "Ese motivo de reembolso no existe.",
      "registered_diners_only": "Crea tu cuenta para usar esta sección.",
      "reopen_reason_invalid": "Ese motivo de reapertura no existe.",
      "reservation_double_booked": "Esa mesa ya está apartada a esa hora.",
      "reservation_ends_before_it_starts": "La reserva no puede terminar antes de empezar.",
      "reservation_not_seatable": "Esa reserva ya no se puede sentar.",
      "reservation_other_location": "Esa reserva no pertenece a este restaurante.",
      "reservation_reason_required": "Dinos por qué se cancela la reserva.",
      "reservation_table_other_location": "Esa mesa no pertenece a este restaurante.",
      "schedule_period_times_equal": "debe ser diferente de la hora de inicio",
      "select_one_item_to_charge": "Selecciona al menos un producto para cobrar.",
      "selected_order_ids_array": "must be an array",
      "service_fee_percentage_number": "debe ser un número válido",
      "service_fee_percentage_range": "debe estar entre 0 y 100",
      "share_carries_no_items": "una parte de la cuenta dividida no lleva productos",
      "shift_actor_not_staff": "Esa persona no forma parte del personal de esta sucursal.",
      "shift_already_open": "Ya hay un turno abierto en esta sucursal.",
      "shift_closed": "El turno ya está cerrado.",
      "shift_closed_is_final": "Un turno cerrado ya no se puede modificar.",
      "shift_has_open_bills": {
        "one": "No puedes cerrar la caja con %{count} cuenta sin liquidar.",
        "other": "No puedes cerrar la caja con %{count} cuentas sin liquidar."
      },
      "shift_other_location": "Ese turno es de otra sucursal.",
      "shift_stock_count_duplicated": "Ese platillo viene contado dos veces. Recarga la pantalla e intenta de nuevo.",
      "shift_stock_count_invalid": "Escribe una existencia válida, un número entero de 0 o más.",
      "shift_stock_count_unknown": "Ese platillo no está en la lista de existencias de esta sucursal.",
      "shift_stock_counts_incomplete": "Confirma la existencia de cada platillo antes de abrir la caja.",
      "shift_stock_update_needs_open_shift": "Abre la caja antes de corregir existencias durante el servicio.",
      "split_cancel_staff_only": "Solo el personal puede cancelar una división que ya tiene pagos.",
      "split_fully_claimed": "Esta división ya está cubierta.",
      "split_not_active": "Esta división ya no está activa.",
      "split_payer_count_too_low": "La cuenta debe dividirse entre al menos 2 personas.",
      "staff_member_delete_failed": "No se pudo eliminar el miembro del personal.",
      "static_invite_never_expires": "debe estar vacío en una invitación estática",
      "stock_adjustment_count_matches_balance": "Tu conteo coincide con lo que ya teníamos, así que no hay nada que corregir.",
      "stock_adjustment_note_required": "Este motivo necesita una nota que explique qué pasó.",
      "stock_adjustment_quantity_invalid": "Escribe la cantidad con números.",
      "stock_adjustment_quantity_negative": "La cantidad no puede ser negativa.",
      "stock_adjustment_quantity_not_positive": "La cantidad tiene que ser mayor a cero.",
      "stock_adjustment_unknown_reason": "Elige un motivo de la lista.",
      "stripe_not_ready_for_location": "Stripe Connect no está listo para cobrar en esta sucursal.",
      "stripe_signature_invalid": "Firma inválida.",
      "stripe_webhook_secret_missing": "Stripe webhook secret no configurado.",
      "subscription_already_active": "Esta cuenta ya tiene una suscripción activa.",
      "supplier_delete_failed": "Este proveedor ya tiene compras registradas, así que no se puede borrar. Desactívalo para que deje de aparecer al capturar una compra.",
      "supplier_other_location": "Ese proveedor es de otra sucursal.",
      "supply_delete_failed": "Este insumo ya tiene movimientos o lo usa alguna receta, así que no se puede borrar. Quítalo de las recetas si ya no lo ocupas.",
      "supply_other_location": "Ese insumo es de otra sucursal.",
      "supply_unit_locked": "La unidad ya no se puede cambiar porque este insumo tiene movimientos: cambiarla reinterpretaría todo su historial.",
      "supply_update_failed": "No se pudo actualizar el insumo.",
      "table_action_invalid": "La acción de mesa no es válida.",
      "table_action_unavailable": "La acción no está disponible para esta mesa.",
      "table_already_has_open_bill": "La mesa ya tiene una cuenta abierta. Ciérrala antes de reabrir esta.",
      "table_available": "La mesa ya está disponible.",
      "table_available_create_new_bill": "La mesa ya está disponible. Debes crear una nueva cuenta.",
      "table_context_required_for_menu": "Necesitas estar en una mesa para ver el menú.",
      "table_delete_failed": "No se puede eliminar una mesa con cuentas pendientes de liquidar. Libera la mesa primero.",
      "table_required": "debe existir",
      "table_same_location": "debe pertenecer a la misma sucursal",
      "tip_amount_invalid": "El monto de propina no puede ser negativo.",
      "too_many_verification_codes": "Pediste demasiados códigos. Intenta de nuevo más tarde.",
      "try_again_later": "Intenta de nuevo más tarde.",
      "user_already_in_location": "ya pertenece a la sucursal actual",
      "user_blank": "no puede estar vacío",
      "user_has_active_bill": "Ya tienes una cuenta activa en esta sucursal.",
      "verification_code_already_used": "Ese código ya se usó. Pide uno nuevo.",
      "verification_code_expired": "El código expiró. Pide uno nuevo.",
      "verification_code_invalid": "El código no es correcto. Revísalo e intenta de nuevo.",
      "verification_code_locked": "Demasiados intentos. Pide un código nuevo.",
      "verification_code_not_found": "No encontramos un código para ese correo. Pide uno nuevo.",
      "visit_required": "Necesitas estar en un restaurante para ver esto.",
      "waiter_call_requires_table": "Necesitas estar en una mesa para llamar al mesero.",
      "waiter_call_unavailable": "Este restaurante no recibe llamados al mesero desde la app."
    },
    "extras": {
      "rule_at_least": "Elige al menos %{min}",
      "rule_exact": "Elige %{count}",
      "rule_optional": "Opcional",
      "rule_optional_up_to": "Opcional, hasta %{max}",
      "rule_range": "Elige entre %{min} y %{max}"
    },
    "flashes": {
      "admin_created": "Acceso de administrador otorgado exitosamente.",
      "admin_location_created": "Sucursal creada exitosamente.",
      "admin_location_deleted": "Sucursal eliminada.",
      "admin_location_feature_updated": "Disponibilidad de la función actualizada.",
      "admin_location_updated": "Sucursal actualizada exitosamente.",
      "admin_revoked": "Acceso de administrador revocado exitosamente.",
      "anonymous_session_started": "Sesión iniciada.",
      "bill_cancelled": "Cuenta #%{id} cancelada.",
      "bill_closed": "Cuenta #%{id} cerrada. Total: %{total}.",
      "bill_reopened": "Cuenta #%{id} reabierta.",
      "bill_split_cancelled": "Se canceló la división de la cuenta.",
      "bill_split_opened": "Listo, la cuenta se va a dividir.",
      "business_hours_updated": "Horario de atención actualizado.",
      "cash_movement_recorded": "Movimiento de efectivo registrado.",
      "category_created": "Categoría creada exitosamente.",
      "category_deleted": "Categoría eliminada exitosamente.",
      "category_updated": "Categoría actualizada exitosamente.",
      "central_item_created": "Platillo agregado al menú central.",
      "central_item_deleted": "Platillo quitado del menú central. Las sucursales lo conservan.",
      "central_item_updated": "Platillo central actualizado.",
      "central_price_applied": "Precio aplicado en %{updated} sucursales. %{skipped} lo tienen fijado y no cambiaron.",
      "channel_connected": "Canal conectado.",
      "channel_disconnected": "Canal desconectado. Los pedidos que ya llegaron se conservan.",
      "coupon_created": "Cupón creado.",
      "coupon_deleted": "Cupón eliminado.",
      "coupon_revoked": "Cupón revocado. Ya no se puede usar.",
      "coupon_updated": "Cupón actualizado.",
      "courier_created": "Repartidor agregado.",
      "courier_deleted": "Repartidor eliminado.",
      "courier_updated": "Repartidor actualizado.",
      "customer_created": "Cliente agregado.",
      "customer_points_updated": "Puntos actualizados.",
      "delivery_assigned": "Entrega asignada.",
      "delivery_failed": "Entrega marcada como fallida.",
      "delivery_updated": "Entrega actualizada.",
      "discount_applied": "Descuento aplicado.",
      "discount_authorized": "Descuento autorizado.",
      "discount_pending_authorization": "Descuento registrado. Un gerente tiene que autorizarlo para que se aplique.",
      "discount_rejected": "Descuento rechazado. La cuenta queda al precio completo.",
      "discount_voided": "Descuento quitado.",
      "entry_request_approved": "Entrada autorizada.",
      "entry_request_cleared": "Solicitud despejada. Puede volver a pedir entrar.",
      "entry_request_rejected": "Entrada rechazada.",
      "extra_created": "Complemento creado exitosamente.",
      "extra_deleted": "Complemento eliminado exitosamente.",
      "extra_group_created": "Grupo de complementos creado exitosamente.",
      "extra_group_deleted": "Grupo de complementos eliminado exitosamente.",
      "extra_group_updated": "Grupo de complementos actualizado exitosamente.",
      "extra_updated": "Complemento actualizado exitosamente.",
      "extras_reordered": "Orden de complementos actualizado.",
      "guest_session_already_active": "Ya tienes una sesión registrada activa.",
      "guest_session_started": "Sesión de invitado iniciada.",
      "invite_created": "Invitación creada exitosamente.",
      "invite_declined": "Invitación rechazada.",
      "invite_reused": "Invitación activa reutilizada.",
      "invite_revoked": "Invitación revocada.",
      "invoice_cancellation_requested": "Le pedimos a tu cliente que acepte la cancelación. Te avisamos en cuanto responda.",
      "invoice_cancelled": "Factura cancelada.",
      "invoice_requested": "Factura solicitada. Te avisamos en cuanto el SAT la timbre.",
      "item_created": "Producto creado exitosamente.",
      "item_deleted": "Producto eliminado exitosamente.",
      "item_marked_sold_out": "Producto marcado como agotado.",
      "item_reactivated": "Producto reactivado.",
      "item_stock_created": "Empezaste a contar este platillo.",
      "item_stock_deleted": "Dejaste de contar este platillo.",
      "item_stock_updated": "Existencias actualizadas.",
      "item_updated": "Producto actualizado exitosamente.",
      "locale_updated": {
        "description": "Tu preferencia de idioma se ha guardado.",
        "header": "Idioma actualizado"
      },
      "location_configuration_updated": "Configuración actualizada.",
      "location_created": "Sucursal creada exitosamente.",
      "location_feature_updated": "Función actualizada.",
      "location_joined": "Te uniste a la sucursal exitosamente.",
      "location_launched": "Sucursal en producción.",
      "location_public_menu_slug_updated": "Enlace del menú público actualizado.",
      "location_taxes_updated": "Impuestos actualizados.",
      "location_tips_updated": "Propinas actualizadas.",
      "location_updated": "Sucursal actualizada exitosamente.",
      "order_sent": "Enviamos tu orden a la cocina.",
      "order_updated": "Comanda actualizada exitosamente.",
      "orders_created": "Comandas creadas exitosamente.",
      "organization_created": "Organización creada. Ahora dale su primera sucursal.",
      "organization_invite_accepted": "Ya eres parte de la organización.",
      "organization_invite_declined": "Rechazaste la invitación.",
      "organization_invite_revoked": "Invitación cancelada.",
      "organization_invite_sent": "Invitación enviada.",
      "organization_settings_updated": "Datos de la organización actualizados.",
      "password_created": "Listo, ya tienes contraseña propia. Puedes seguir entrando con Google o usarla desde ahora.",
      "password_link_sent": {
        "create_description": "Te enviamos a %{email} el enlace para crear tu contraseña.",
        "header": "Revisa tu correo",
        "reset_description": "Te enviamos a %{email} el enlace para cambiar tu contraseña."
      },
      "password_reset_done": "La contraseña ha sido restablecida.",
      "password_reset_instructions_sent": "Se han enviado instrucciones para restablecer la contraseña (si existe un usuario con esa dirección de correo electrónico).",
      "password_updated": {
        "description": "Tu contraseña ha sido cambiada exitosamente.",
        "header": "Contraseña actualizada"
      },
      "payment_attempt_created": "Intento de pago creado.",
      "payment_attempt_reused": "Intento de pago reutilizado por idempotencia.",
      "payment_attempt_updated": "Cobro actualizado.",
      "pickup_created": "Pickup creado exitosamente.",
      "profile_updated": {
        "description": "Se ha actualizado el perfil de %{name}.",
        "header": "Perfil actualizado"
      },
      "promotion_created": "Promoción creada.",
      "promotion_deleted": "Promoción eliminada.",
      "promotion_updated": "Promoción actualizada.",
      "promotion_window_updated": "Horario de la promoción actualizado.",
      "purchase_cancelled": "Compra cancelada.",
      "purchase_created": "Compra registrada en borrador. Recíbela cuando llegue la mercancía.",
      "purchase_received": "Compra recibida: el inventario y el costo promedio ya se actualizaron.",
      "recipe_line_created": "Insumo agregado a la receta.",
      "recipe_line_deleted": "Insumo quitado de la receta.",
      "recipe_line_updated": "Cantidad de la receta actualizada.",
      "refund_issued": "Reembolso registrado.",
      "reservation_cancelled": "Reserva cancelada. La mesa queda libre a esa hora.",
      "reservation_created": "Reserva apartada.",
      "reservation_seated": "Reserva sentada.",
      "settings_updated": {
        "description": "Tus preferencias se han guardado.",
        "header": "Preferencias actualizadas"
      },
      "shift_closed": "Caja cerrada. Ya puedes revisar el corte Z.",
      "shift_opened": "Caja abierta.",
      "staff_member_created": "Miembro del personal creado exitosamente.",
      "staff_member_deleted": "Miembro del personal eliminado exitosamente.",
      "staff_member_updated": "Miembro del personal actualizado exitosamente.",
      "staff_registration_created": "Cuenta creada exitosamente. Continúa con el registro de tu restaurante.",
      "static_invite_created": "QR impreso generado.",
      "static_invite_reused": "El QR impreso ya existía.",
      "static_invite_revoked": "QR impreso revocado. Imprime uno nuevo antes de usar la mesa.",
      "stock_adjustment_recorded": "Movimiento registrado en el inventario.",
      "supplier_created": "Proveedor creado.",
      "supplier_deleted": "Proveedor eliminado.",
      "supplier_updated": "Proveedor actualizado.",
      "supply_created": "Insumo creado.",
      "supply_deleted": "Insumo eliminado.",
      "supply_updated": "Insumo actualizado.",
      "table_created": "Mesa creada exitosamente.",
      "table_deleted": "Mesa eliminada exitosamente.",
      "table_disabled": "Mesa deshabilitada.",
      "table_form_updated": "Mesa actualizada exitosamente.",
      "table_occupied": "Mesa ocupada.",
      "table_released": "Mesa liberada.",
      "table_reserved": "Mesa reservada.",
      "table_updated": "Mesa actualizada.",
      "tax_profile_updated": "Datos fiscales guardados.",
      "user_account_completed": "Cuenta completada exitosamente. Bienvenido a tu panel de control.",
      "user_account_created": "Cuenta creada exitosamente. Bienvenido a tu panel de control.",
      "waiter_already_called": "Ya habíamos avisado. Un mesero va en camino.",
      "waiter_call_acknowledged": "Llamado atendido.",
      "waiter_call_cancelled": "Listo, cancelamos el llamado.",
      "waiter_call_not_pending": "Ese llamado ya no estaba activo.",
      "waiter_called": "Listo, ya avisamos. Un mesero va para tu mesa."
    },
    "forms": {
      "labels": {
        "current_password": "Contraseña Actual",
        "email": "Correo electrónico",
        "email_title": "Correo Electrónico",
        "name": "Nombre",
        "new_password": "Nueva Contraseña",
        "password": "Contraseña",
        "password_confirmation": "Confirmar Contraseña",
        "password_confirmation_lower": "Confirmación de contraseña"
      },
      "placeholders": {
        "person_name": "Juan Pérez",
        "staff_person_name": "María López"
      }
    },
    "landing": {
      "capabilities": {
        "groups": {
          "core": "De fábrica",
          "expansion": "Más de una sucursal",
          "finance": "Dinero",
          "operation": "Operación",
          "service": "Servicio"
        },
        "items": {
          "audit_log": {
            "description": "Cada escritura deja un evento con actor, momento y estado anterior. Las transiciones ilegales se bloquean y se registran.",
            "title": "Bitácora que no se puede editar"
          },
          "cash_register": {
            "description": "Turnos, entradas y salidas de efectivo, y el reporte de cierre con métodos de pago, reembolsos, descuentos y cancelaciones.",
            "title": "Corte de caja"
          },
          "discounts": {
            "description": "Por producto o por cuenta, con catálogo de motivos y autorización en dos niveles. Nadie regala nada sin firma.",
            "title": "Descuentos y cortesías"
          },
          "dynamic_invites": {
            "description": "Cuando el mesero prefiere darle un código corto y de vida breve a un grupo, en vez de apuntarlos al papel de la mesa.",
            "title": "QR temporal para walk-ins"
          },
          "hybrid_orders": {
            "description": "El mesero desde su teléfono y el comensal desde el suyo cargan a la misma cuenta. Sin comandas repetidas.",
            "title": "Pedido híbrido"
          },
          "item_split": {
            "description": "Cada quien elige lo suyo, o dividen en partes iguales entre los que decidan. Lo pagado se bloquea al instante.",
            "title": "División por producto"
          },
          "item_stock": {
            "description": "Capturas cuántos salen hoy. Al llegar a cero el platillo deja de venderse y el equipo se entera antes de que se acabe.",
            "title": "Conteo por platillo"
          },
          "kds": {
            "description": "Para la barra o la línea. Un mostrador sin pantalla no la necesita, así que llega apagada.",
            "title": "Pantalla de cocina por estación"
          },
          "multi_location": {
            "description": "El precio central baja a las sucursales que no fijaron el suyo, y cada una se mide contra el promedio de la organización, no solo se suma.",
            "title": "Menú central y comparativa de organización"
          },
          "payment_methods": {
            "description": "El cobro digital corre por Stripe Connect a nombre de tu restaurante, con protección contra el doble cargo.",
            "title": "Efectivo, terminal y pago digital"
          },
          "pickup": {
            "description": "Con tiempo estimado que tú pones al confirmar, estados de listo y recogido, y manejo de quien no llegó.",
            "title": "Pedidos para llevar"
          },
          "public_menu": {
            "description": "Publicar tus precios al internet abierto es decisión tuya. Nada sale hasta que lo pides.",
            "title": "Dirección pública para tu menú"
          },
          "refunds": {
            "description": "Defines quién puede emitir uno y hasta qué monto, y cada reembolso queda con nombre y razón.",
            "title": "Reembolsos con motivo"
          },
          "reports": {
            "description": "Venta por periodo que cuadra con la suma de tus cortes, más el reporte de control: descuentos, cancelaciones y reembolsos con nombre y motivo.",
            "title": "Reportes de venta y mix de productos"
          },
          "roles": {
            "description": "Todo el equipo trabaja las comandas; solo el gerente toca menú, mesas, usuarios, cobranza y configuración.",
            "title": "Roles con límites reales"
          },
          "shared_bill": {
            "description": "El QR impreso vive pegado a la mesa. Quien llega pide entrar y alguien de tu equipo, o quien ya está sentado, aprueba.",
            "title": "Cuenta compartida por QR de mesa"
          },
          "taxes": {
            "description": "Eliges tu régimen y tus tasas. El desglose se congela en el cobro, así que el recibo dice lo que se cobró ese día.",
            "title": "Impuestos por régimen"
          },
          "tips": {
            "description": "El comensal puede dejar propina en cualquier restaurante, y el 0% siempre se ofrece sin nada preseleccionado.",
            "title": "Propina que no presiona"
          },
          "waiter_call": {
            "description": "El comensal levanta la mano desde su teléfono y la mesa sube en la lista de atención del piso.",
            "title": "Llamado al mesero"
          }
        },
        "label": "Qué incluye",
        "legend_optional": "Lo prendes cuando lo necesites",
        "legend_shipped": "Funciona desde el primer día",
        "title": "Todo esto viene en el plan. Prendes lo que uses."
      },
      "closing": {
        "description": "Configuras a tu ritmo, sin prisa y sin tarjeta. El pago es el último paso de la lista, y es justo el que abre las puertas.",
        "primary": "Crea tu restaurante",
        "secondary": "Ya tengo cuenta",
        "title": "Arma tu menú, tus mesas y tus formas de cobro.",
        "trust": {
          "charges": {
            "description": "Idempotencia en la creación y en el reintento del cobro digital, y bloqueo inmediato de lo ya pagado.",
            "title": "Nunca cobres dos veces"
          },
          "isolation": {
            "description": "Cada dato vive amarrado a su sucursal, y los tres dominios están separados por host, no por un permiso que alguien puede olvidar.",
            "title": "Nadie ve lo que no le toca"
          },
          "orders": {
            "description": "Si el internet flaquea, la operación sigue. Una pantalla atrasada se aguanta; una comanda perdida no.",
            "title": "Nunca pierdas una comanda"
          }
        }
      },
      "footer": {
        "diners": "Soy comensal",
        "directory": "Directorio",
        "staff": "Entrar a mi restaurante",
        "tagline": "Servicio de mesa, cobro y control para restaurantes con servicio en mesa."
      },
      "hero": {
        "badge": "Software para restaurantes",
        "description_after": ", desde el celular, la tablet o la computadora.",
        "description_before": "El comensal pide y paga desde su teléfono, y el pedido llega directo a la estación que lo prepara. Tu mesero deja de transcribir comandas y atiende lo que sí necesita una persona. ",
        "description_highlight": "Todo en el navegador",
        "note": "Configuras a tu ritmo. Tu sucursal abre sola en cuanto entra el primer pago.",
        "primary_cta": "Crea tu restaurante",
        "secondary_cta": "Ver qué incluye",
        "title": "Nadie espera para pedir. Nadie espera la cuenta."
      },
      "hero_bill": {
        "chip": {
          "subtitle": "sin llamar al mesero",
          "title": "Ana pidió desde su mesa"
        },
        "entry_note": "2 comensales en esta cuenta · Luis pidió entrar",
        "items": {
          "aguachile": {
            "amount": "210.00",
            "name": "Aguachile de camarón",
            "quantity": "1",
            "who": "Luis"
          },
          "beer": {
            "amount": "65.00",
            "name": "Cerveza clara",
            "quantity": "1",
            "who": "Ana · pagado y bloqueado"
          },
          "jamaica": {
            "amount": "70.00",
            "name": "Agua de jamaica",
            "quantity": "2",
            "who": "Luis · en cocina"
          },
          "pastor": {
            "amount": "96.00",
            "name": "Tacos al pastor",
            "quantity": "2",
            "who": "Ana"
          }
        },
        "live": "En servicio",
        "status_label": "Cuenta abierta",
        "table": "Mesa 12",
        "totals": {
          "due_label": "Falta por cobrar",
          "due_value": "$376.00",
          "paid_label": "Ya pagado",
          "paid_value": "− 65.00",
          "subtotal_label": "Cuenta de la mesa",
          "subtotal_value": "441.00"
        }
      },
      "meta": {
        "description": "Autoservicio en la mesa, cocina conectada y control de tu negocio. 100% web, sin papel y con indicadores reales. Desde $1,200 al mes por sucursal.",
        "og_image_alt": "Un comensal pidiendo desde su teléfono en la mesa, con la cuenta de la mesa a la vista.",
        "title": "Menny — el sistema que corre todo el turno de tu restaurante"
      },
      "nav": {
        "audience": "Para quién",
        "pricing": "Precio",
        "product": "Qué incluye",
        "self_service": "Autoservicio",
        "sign_in": "Entrar",
        "start": "Crea tu restaurante"
      },
      "pillars": {
        "insights": {
          "description": "Venta por periodo que cuadra con la suma de tus cortes, mix de productos con clasificación ABC, y el reporte de control: descuentos, cancelaciones y reembolsos, cada uno con nombre y motivo. Exportable a CSV.",
          "title": "Indicadores de tu negocio"
        },
        "paperless": {
          "description": "Comanda digital a la cocina y ticket digital al comensal, con su historial de cuentas cerradas. Nada que se borre en un rollo térmico ni que se pierda entre dos turnos.",
          "title": "Sin papel"
        },
        "web": {
          "description": "Se abre en el navegador del celular, de la tablet o de la computadora. Nada que instalar, nada que actualizar, ningún equipo que comprar. El mesero usa el teléfono que ya trae en la bolsa.",
          "title": "100% web"
        }
      },
      "pricing": {
        "annual": {
          "amount": "$10,080",
          "badge": "Ahorras 30%",
          "label": "Anual",
          "note_after": " al mes.",
          "note_amount": "$840",
          "note_before": "Por sucursal, más IVA. Equivale a ",
          "unit": "MXN / año"
        },
        "cta": "Crea tu restaurante",
        "description": "Sin módulos que se cobran aparte y sin escalones que se desbloquean más caro. Lo que ves en la lista de arriba viene en el plan; cada restaurante prende lo que usa.",
        "label": "Precio",
        "monthly": {
          "amount": "$1,200",
          "label": "Mensual",
          "note": "Por sucursal, más IVA. Sin plazo forzoso.",
          "unit": "MXN / mes"
        },
        "notes": {
          "commission_after": " si se pagan en el mostrador.",
          "commission_before": "Las comandas para llevar llevan comisión de servicio: ",
          "commission_middle": " si se pagan en línea y ",
          "commission_online": "7%",
          "commission_physical": "1%",
          "invoice": "Un solo recibo para toda la organización, tengas una sucursal o cinco. Agregas otra y se cobra al momento.",
          "suspension": "Si un cargo falla nunca te cortamos a media operación: la suspensión ocurre de madrugada, en el horario de tu propio restaurante."
        },
        "title": "Un precio al mes, con todo el producto adentro."
      },
      "self_service": {
        "body_first": "El pedido entra desde el teléfono del comensal y llega directo a la estación que lo prepara. El mesero deja de ser el intermediario que camina, apunta y vuelve a capturar: atiende lo que de verdad pide una persona — alguien esperando entrar, una mesa que llamó, una comanda lista que lleva seis minutos sin salir.",
        "body_second": "Y cuando el mesero sí toma el pedido, lo carga a la misma cuenta. No hay dos sistemas, ni dos comandas, ni una libreta que después alguien tiene que transcribir.",
        "kitchen": {
          "description": "Cada producto llega a su estación con estados explícitos. Sin letra ajena que descifrar ni comandas repetidas.",
          "title": "Menos ruido en la cocina"
        },
        "label": "Autoservicio",
        "title": "El comensal pide solo. Tu equipo hace lo que sí necesita una persona.",
        "waiter": {
          "description": "No camina para tomar la comanda ni para llevarla a cocina. Camina cuando la lista de atención lo llama.",
          "title": "Menos vueltas del mesero"
        }
      },
      "shift": {
        "description": "Cuando la cuenta es el centro, nada se pierde entre el pedido y el cobro: el salón, la cocina y la caja están mirando el mismo objeto.",
        "label": "El turno",
        "steps": {
          "close": {
            "description": "Con su historial completo. Al final del turno el corte cuadra con lo que el reporte de venta dice.",
            "stage": "Cierra",
            "title": "La mesa se libera y todo queda escrito"
          },
          "order": {
            "description": "El mesero puede corregir la selección de un comensal antes de que se envíe. Una mesa puede llevar varias cuentas a la vez.",
            "stage": "Piden",
            "title": "Comensal y mesero, una sola cuenta"
          },
          "pay": {
            "description": "Por producto o en partes iguales. Los totales se congelan al primer intento y lo pagado se bloquea para todos.",
            "stage": "Pagan",
            "title": "Cada quien lo suyo"
          },
          "prepare": {
            "description": "Estados explícitos, sin saltos ilegales. Si el tiempo real se degrada, el sistema consulta en vez de bloquear el servicio.",
            "stage": "Se prepara",
            "title": "Cocina ve producto y estación"
          },
          "seated": {
            "description": "Sin instalar nada. Piden entrar y alguien aprueba; la mesa avisa aunque todavía no haya nadie sentado.",
            "stage": "Se sientan",
            "title": "Escanean el QR de la mesa"
          }
        },
        "title": "La vida de una cuenta, de principio a fin."
      },
      "surfaces": {
        "attention": {
          "count": "3 pendientes",
          "rows": {
            "call": {
              "action": "Voy",
              "age": "4 min",
              "detail": "Sin atender",
              "title": "Mesa 9 · llamó al mesero"
            },
            "entry": {
              "action": "Aprobar",
              "age": "2 min",
              "detail": "Escaneó el QR de la mesa",
              "title": "Mesa 4 · alguien espera entrar"
            },
            "ready": {
              "action": "Ver mesa",
              "age": "6 min",
              "detail": "Aguachile, 2 aguas",
              "title": "Mesa 2 · comanda lista sin servir"
            }
          },
          "title": "Necesita atención"
        },
        "bill": {
          "due_label": "Tu parte",
          "due_value": "$280.00",
          "items": {
            "aguachile": {
              "amount": "210.00",
              "name": "Aguachile de camarón"
            },
            "jamaica": {
              "amount": "70.00",
              "name": "2 Agua de jamaica"
            },
            "other": {
              "amount": "96.00",
              "name": "2 Tacos al pastor · Ana"
            }
          },
          "mine": "Lo mío",
          "pay": "Pagar mi parte",
          "title": "Cuenta de la mesa"
        },
        "label": "Para quién",
        "staff": {
          "description": "El piso ya no es un tablero que hay que interpretar: es una lista de lo que necesita atención, ordenada por urgencia y con la edad de cada pendiente. Abajo de eso, comandas, cuentas, menú, equipo, caja y reportes de cada sucursal.",
          "host": "staff.menny.app",
          "title": "Tu restaurante"
        },
        "title": "Tu equipo y tus comensales, cada uno en su lugar.",
        "user": {
          "description": "Llegan por el QR de la mesa, o te encuentran en el directorio si piden para llevar. Piden, ven la cuenta compartida y pagan desde su teléfono, sin instalar nada.",
          "host": "menny.app",
          "title": "Tus comensales"
        }
      }
    },
    "menu": {
      "add_to_order": "Agregar a la comanda",
      "available_item": {
        "one": "producto disponible",
        "other": "productos disponibles"
      },
      "item_fallback": "Producto",
      "item_sold_out": "Producto agotado",
      "no_category": "Sin categoría",
      "no_description": "Sin descripción",
      "no_items_available": "No hay productos disponibles en el menú.",
      "no_items_for_order": "No hay productos disponibles para ordenar.",
      "no_items_for_table": "No hay productos disponibles para agregar en esta mesa.",
      "no_parent_item": "Sin producto padre"
    },
    "navigation": {
      "account_menu": "Menú de cuenta",
      "back_to_floor": "Volver al piso",
      "billing": "Cobranza",
      "branch": "Sucursal",
      "central_items": "Menú central",
      "channels": "Canales",
      "close_menu": "Cerrar menú",
      "collapse_sidebar": "Colapsar barra lateral",
      "couriers": "Repartidores",
      "customers": "Clientes",
      "dark_theme": "Tema oscuro",
      "dashboard": "Actividad",
      "deliveries": "Entregas",
      "events": "Eventos",
      "expand_sidebar": "Expandir barra lateral",
      "go_to_management": "Ir a gestión",
      "group_business": "Negocio",
      "group_catalog": "Catálogo",
      "group_inventory": "Inventario y compras",
      "group_service": "Servicio",
      "home": "Inicio",
      "item_stocks": "Existencias",
      "jobs": "Jobs",
      "light_theme": "Tema claro",
      "locations": "Sucursales",
      "management": "Administración",
      "menu": "Menú",
      "monitoring": "Monitoreo",
      "navigation_menu": "Menú de navegación",
      "new_location": "Nueva sucursal",
      "new_organization": "Nueva organización",
      "no_new_notifications": "No tienes notificaciones nuevas",
      "notifications": "Notificaciones",
      "notifications_unread": "Notificaciones, %{count} sin leer",
      "open_menu": "Abrir menú",
      "open_menu_unread": "Abrir menú, %{count} notificaciones sin leer",
      "operation": "Operación",
      "organization": "Sucursales",
      "payment_methods": "Métodos",
      "payments": "Pagos",
      "profile": "Perfil",
      "promotions": "Promociones",
      "purchases": "Compras",
      "realtime": "Tiempo real",
      "recipes": "Recetas",
      "resilient_mode": "Modo resiliente (polling)",
      "services": "Servicios",
      "staff": "Personal",
      "suppliers": "Proveedores",
      "supplies": "Inventario",
      "tables": "Mesas",
      "tax_profile": "Datos fiscales",
      "transactions": "Transacciones",
      "users": "Usuarios"
    },
    "orders": {
      "created_at": "Creada: %{date}",
      "empty_order": "La comanda está vacía",
      "no_current_orders": "Sin comandas actuales.",
      "order_detail": "Detalle de comandas",
      "start_preparation": "Iniciar preparación"
    },
    "payments": {
      "methods": {
        "long": {
          "cash": "Efectivo",
          "digital_in_app": "Pago digital",
          "physical_card_terminal": "Terminal"
        },
        "short": {
          "cash": "Efectivo",
          "digital_in_app": "Pago digital",
          "physical_card_terminal": "Terminal"
        }
      },
      "stripe_checkout_product_name": "Cuenta #%{bill_id} · %{location_name}"
    },
    "react": {
      "components": {
        "features": {
          "menu": {
            "manage_menu_grid": {
              "category": "Sin categoría",
              "image": "Sin imagen",
              "soldout": "Agotado"
            },
            "menu_grid": {
              "category": "Sin categoría",
              "image": "Sin imagen",
              "soldout": "Agotado",
              "unavailable": "No disponible"
            }
          },
          "profiles": {
            "guest": {
              "hint": "Regístrate para guardar tu historial y pedir para llevar.",
              "name_hint": "Tu nombre aparece en la cuenta para que tu mesa sepa quién pidió qué.",
              "name_label": "Tu nombre",
              "register": "Crear cuenta",
              "title": "Estás como invitado"
            },
            "locale_selector": {
              "description": "Elige el idioma que quieres usar en toda la aplicación.",
              "label": "Idioma",
              "save": "Guardar",
              "saved": "Idioma actualizado"
            },
            "password_form": {
              "cancel": "Cancelar",
              "change_password": "Cambiar Contraseña",
              "confirm_password": "Confirmar Contraseña",
              "enter_password_current_new": "Ingresa tu contraseña actual y la nueva contraseña",
              "new_password": "Nueva Contraseña",
              "password_current": "Contraseña Actual"
            },
            "profile_form": {
              "cancel": "Cancelar",
              "email": "Correo Electrónico",
              "information_staff": "Información Personal",
              "name": "Nombre",
              "save_changes": "Guardar Cambios",
              "update_name_email": "Actualiza tu nombre y correo electrónico"
            },
            "profile_sidebar": {
              "account": "Cuenta",
              "change_password": "Cambiar contraseña",
              "close_session": "Cerrar Sesión",
              "configuration": "Configuración",
              "current_orders": "Pedidos de esta visita",
              "edit_profile": "Editar perfil",
              "payment_methods": "Métodos de pago",
              "receipts": "Recibos"
            },
            "security_card": {
              "create_password": "Crear contraseña",
              "description": "Cómo entras a tu cuenta.",
              "no_password": "Tu cuenta no tiene contraseña propia.",
              "sending": "Enviando…",
              "signs_in_with": "Inicias sesión con %{providers}",
              "title": "Seguridad"
            },
            "settings": {
              "appearance": "Apariencia",
              "description": "Administra las preferencias de tu cuenta.",
              "theme_dark": "Oscuro",
              "theme_light": "Claro",
              "theme_system": "Sistema",
              "title": "Configuración"
            },
            "time_zone_selector": {
              "description": "Elige la zona horaria que se usará para mostrar fechas y horas.",
              "label": "Zona horaria"
            }
          },
          "schedule": {
            "business_hours_form": {
              "closed": "Cerrado",
              "enable": "Habilitar",
              "enable_hint": "Activa o desactiva rápidamente el horario de atención",
              "from": "Desde",
              "save": "Guardar",
              "timezone": "Zona horaria",
              "timezone_hint": "Configura tu zona horaria",
              "to": "Hasta"
            }
          },
          "staff": {
            "manage_users": {
              "user_form": {
                "cancel": "Cancelar",
                "confirmation_password": "Confirmación de contraseña",
                "email": "Correo electrónico",
                "mary_smith": "María López",
                "name": "Nombre",
                "role": "Rol",
                "staff_example_com": "staff@example.com"
              }
            }
          }
        },
        "layouts": {
          "staff_context_switcher": {
            "current_context": "Dónde estás",
            "locations": "Sucursales",
            "manage_location": "Configurar esta sucursal",
            "no_locations": "No trabajas en ninguna sucursal de esta organización.",
            "switch_context": "Cambiar de sucursal u organización"
          },
          "staff_layout": {
            "bills": "Cuentas",
            "change_theme": "Cambiar tema",
            "deliveries": "Entregas",
            "go_profile": "Ir a perfil",
            "kds": "Cocina",
            "new_order": "Nueva comanda",
            "no_tienes_notifications_new": "No tienes notificaciones nuevas",
            "orders": "Comandas",
            "reports": "Reportes",
            "reservations": "Reservas",
            "tables": "Mesas",
            "till": "Caja"
          },
          "staff_location_switcher": {
            "location_current": "Sucursal actual",
            "locations": "Sucursales"
          },
          "staff_onboarding_progress": {
            "launch": "Lanzar local",
            "next_step": "Siguiente paso: %{step}",
            "open_menu": "Ver progreso de configuración",
            "pending_setup": "Configuración pendiente",
            "steps_completed": "%{completed} de %{total} pasos completados",
            "title": "Configuración del local"
          },
          "user_layout": {
            "footer_tagline": "Pide, comparte y paga sin filas.",
            "no_tienes_notifications_new": "No tienes notificaciones nuevas"
          }
        },
        "ui": {
          "breadcrumb": {
            "breadcrumb": "ruta de navegación",
            "more": "Más"
          },
          "data_table": {
            "back_pages": "Retroceder 5 páginas",
            "boolean_false": "No",
            "boolean_true": "Sí",
            "clear_filter": "Quitar filtro",
            "clear_search": "Limpiar búsqueda",
            "clear_sort": "Quitar orden",
            "columns": "Columnas",
            "date_from": "Desde",
            "date_to": "Hasta",
            "filter_column": "Filtrar por %{column}",
            "filters": "Filtros",
            "forward_pages": "Avanzar 5 páginas",
            "go_first_page": "Ir a primera página",
            "go_last_page": "Ir a última página",
            "go_page_anterior": "Ir a página anterior",
            "go_page_next": "Ir a página siguiente",
            "loading": "Cargando resultados",
            "next": "Siguiente",
            "no_results": "Sin resultados.",
            "page": "Por página",
            "page_of": "Página %{page} de %{total}",
            "previous": "Anterior",
            "results_page": "Resultados por página",
            "rows_selected": "%{selected} de %{total} fila(s) seleccionada(s)",
            "search": "Buscar...",
            "sort_ascending": "Ordenar ascendente",
            "sort_descending": "Ordenar descendente"
          },
          "dialog": {
            "close": "Cerrar"
          },
          "file_input": {
            "drop_image_here": "Arrastra tu imagen aquí",
            "mb": "MB)",
            "remove_image": "Quitar imagen",
            "select_image": "Seleccionar imagen",
            "single_image_uploader_max_size": "Cargador de imagen única con tamaño máximo (área de arrastre + botón) ∙",
            "svg_png_jpg_gif_max": "SVG, PNG, JPG o GIF (máx.",
            "upload_image_file": "Subir archivo de imagen"
          },
          "headers": {
            "back": "Volver"
          },
          "inline_update": {
            "cancel": "Cancelar",
            "save": "Guardar",
            "update_failed": "No se pudo guardar el cambio",
            "updated": "Cambio guardado"
          },
          "quantity_stepper": {
            "decrease": "Quitar uno",
            "increase": "Agregar uno"
          },
          "sheet": {
            "close": "Cerrar"
          },
          "sidebar": {
            "displays_mobile_sidebar": "Muestra la barra lateral móvil.",
            "sidebar": "Barra lateral",
            "toggle_sidebar": "Alternar barra lateral"
          }
        }
      },
      "features": {
        "entry_requests": {
          "approve": "Autorizar",
          "reject": "Rechazar",
          "staff": {
            "approve": "Abrir la mesa",
            "approve_hint": "Confírmalo solo si ves a la persona en la mesa."
          }
        },
        "staff": {
          "bill_detail_drawer": {
            "bill": "Cuenta",
            "bill_empty": "Esta cuenta todavía no tiene comandas.",
            "bill_paid_manual_release": "La cuenta ya quedó pagada. Ahora la mesa se libera manualmente desde Mesas, una vez que el staff termine la limpieza.",
            "charge_cash": "Cobrar efectivo",
            "charge_terminal": "Cobrar terminal",
            "close_bill": "Cerrar cuenta",
            "confirm_payment": "Confirmar pago",
            "detail_orders": "Detalle de comandas",
            "digital_payment_auto_confirmed": "Este cobro digital se confirma automáticamente vía Stripe. La UI se actualizará cuando llegue el webhook.",
            "items_pay": "Productos sin pagar",
            "mark_failure": "Marcar fallo",
            "note": "Nota:",
            "orders": "Comandas",
            "payment_progress": "Cobro en curso",
            "status_operational_payment_line": "Estado operativo y estado de pago por línea.",
            "subtotal": "Subtotal",
            "text": "por",
            "tip": "Propina",
            "total": "Total",
            "updated": "Actualizada",
            "x": "x"
          },
          "cancellations": {
            "cancel": "Cancelar",
            "confirm": "Confirmar cancelación",
            "description": "Elige el motivo y confirma. La cancelación queda registrada con tu nombre.",
            "reason_label": "Motivo de cancelación",
            "reason_placeholder": "Elige un motivo",
            "submitting": "Cancelando…",
            "title": "Cancelar"
          },
          "cash_drawer": {
            "closed_orders": "Ábrela para tomar comandas y cobrar cuentas.",
            "closed_title": "La caja está cerrada",
            "open_register": "Abrir caja"
          },
          "counter_order_workspace": {
            "customer": "Comensal",
            "customer_hint": "El nombre es lo que se grita cuando la comanda está lista. El teléfono es opcional y sirve para avisar.",
            "customer_locked_hint": "La comanda ya está abierta a nombre de esta persona. Para otro comensal, empieza una comanda nueva.",
            "customer_name": "Nombre",
            "customer_name_placeholder": "¿A nombre de quién?",
            "customer_phone": "Teléfono",
            "customer_phone_placeholder": "Opcional",
            "name_required": "Escribe el nombre del comensal antes de agregar productos.",
            "new_ticket": "Nueva comanda",
            "title": "Comanda para llevar"
          },
          "discounts": {
            "applies_immediately": "El descuento se aplica al confirmar y el total baja de inmediato.",
            "approve": "Autorizar",
            "bill_discount_total": "Descuentos",
            "blocked_already_discounted": "Este producto ya tiene un descuento.",
            "blocked_bill_cancelled": "Esta cuenta está cancelada.",
            "blocked_bill_not_open": "Esta cuenta ya no está abierta.",
            "blocked_exceeds_line": "El descuento es mayor al precio.",
            "blocked_generic": "Este producto no admite descuentos ahora.",
            "blocked_invalid_kind": "Ese tipo de descuento no existe.",
            "blocked_invalid_reason": "Ese motivo no existe.",
            "blocked_line_cancelled": "Este producto está cancelado.",
            "blocked_line_locked": "Este producto está apartado por un cobro.",
            "blocked_line_paid": "Este producto ya se pagó.",
            "blocked_non_positive": "El descuento tiene que ser mayor a cero.",
            "blocked_nothing_to_discount": "No queda nada por descontar.",
            "blocked_payment_in_flight": "Hay un cobro en curso en esta cuenta.",
            "blocked_split_settling": "Esta cuenta ya se está dividiendo y alguien pagó su parte.",
            "cancel": "Cancelar",
            "confirm": "Aplicar descuento",
            "courtesy_notice": "Una cortesía va completa: el producto queda en cero y no cuenta como venta.",
            "description": "Elige el tipo y el motivo. El descuento queda registrado con tu nombre y con el precio original a la vista.",
            "kind_label": "Tipo de descuento",
            "kind_placeholder": "Elige un tipo",
            "line_discount": "Descuento",
            "line_promotion": "Promoción",
            "open": "Descontar",
            "open_bill": "Descontar la cuenta",
            "original_price": "Precio original",
            "pending_bill_scope": "toda la cuenta",
            "pending_empty": "No hay descuentos esperando autorización.",
            "pending_line": "%{actor} pidió %{detail}",
            "pending_title": "Descuentos por autorizar",
            "reason_hint": "El motivo queda en la bitácora de la sucursal y es lo que se cuenta después para saber por qué se deja de cobrar.",
            "reason_label": "Motivo del descuento",
            "reason_placeholder": "Elige un motivo",
            "reject": "Rechazar",
            "requires_authorization": "Este descuento necesita que lo autorice un gerente. Se registra ahora y no cambia el total hasta que alguien lo apruebe.",
            "submitting": "Aplicando…",
            "supersede_amount_label": "Descuento que pierde la mesa",
            "supersede_line_wholesale": "La promoción %{names} cubre toda la cuenta. Al aplicar este descuento se quita de TODOS los productos de la mesa, no solo de este.",
            "supersede_lines": "Al aplicar este descuento se quita la promoción %{names} de este producto.",
            "supersede_title": "Esto quita una promoción",
            "supersede_unnamed": "sin nombre",
            "supersede_wholesale": "Al aplicar este descuento se quita la promoción %{names} de toda la cuenta.",
            "title": "Aplicar un descuento",
            "title_bill": "Descontar toda la cuenta",
            "unknown_actor": "Sin registrar",
            "value_label_fixed": "Monto a descontar",
            "value_label_percentage": "Porcentaje a descontar",
            "value_placeholder": "0.00",
            "void": "Quitar descuento"
          },
          "entry_request_panel": {
            "minutes_waiting": {
              "one": "%{count} min esperando",
              "other": "%{count} min esperando"
            },
            "rejected": "Rechazada",
            "title": "Esperando para entrar",
            "undo": "Deshacer"
          },
          "inventory": {
            "actions_label": "Acciones",
            "adjust_cancel": "Cancelar",
            "adjust_confirm": "Registrar",
            "adjust_description": "Queda un renglón nuevo con tu nombre. Nada se reescribe.",
            "adjust_note_label": "Nota",
            "adjust_note_placeholder": "Qué pasó",
            "adjust_note_required": "Este motivo necesita una nota.",
            "adjust_open": "Registrar movimiento",
            "adjust_quantity_counted_hint": "Lo que hay en la repisa ahorita. Registramos la diferencia contra lo que teníamos (%{balance}).",
            "adjust_quantity_counted_label": "Cuánto contaste",
            "adjust_quantity_removed_hint": "Cuánto se fue, en positivo. Nosotros lo restamos.",
            "adjust_quantity_removed_label": "Cuánto salió",
            "adjust_reason_label": "Motivo",
            "adjust_reason_placeholder": "Elige un motivo",
            "adjust_submitting": "Registrando…",
            "adjust_title": "Registrar movimiento",
            "back": "Volver al inventario",
            "cancel": "Cancelar",
            "coverage_hint": "Los faltantes de abajo solo cuentan lo que consumen los platillos que ya tienen receta.",
            "coverage_label": "Cobertura de recetas",
            "coverage_value": "%{covered} de %{total} platillos tienen receta",
            "create": "Crear insumo",
            "creating": "Creando…",
            "delete": "Eliminar",
            "delete_blocked": "Este insumo ya tiene historial o lo usa una receta, así que no se puede borrar.",
            "delete_confirm": "Eliminar",
            "delete_description": "Se borra el insumo. Si ya tiene movimientos o alguna receta lo usa, no se puede borrar.",
            "delete_title": "Eliminar insumo",
            "empty_action": "Crear el primer insumo",
            "empty_hint": "Un insumo es lo que la cocina consume. Captura los que quieras seguir, y después escribe las recetas que los usan.",
            "empty_title": "Todavía no hay insumos",
            "form_description": "El nombre y la unidad van juntos porque la unidad se queda fija en cuanto el insumo tenga su primer movimiento.",
            "ledger_actor": "Quién",
            "ledger_balance": "Existencia después",
            "ledger_description": "Todo lo que movió la existencia de este insumo, en orden.",
            "ledger_empty": "Este insumo todavía no tiene movimientos.",
            "ledger_immutable": "Un movimiento no se edita ni se borra: si algo quedó mal, registra un ajuste por conteo y los dos renglones quedan a la vista.",
            "ledger_note": "Nota",
            "ledger_open": "Ver movimientos",
            "ledger_open_full": "Abrir la ficha del insumo",
            "ledger_quantity": "Cantidad",
            "ledger_quantity_in": "Cantidad (%{unit})",
            "ledger_reason": "Motivo",
            "ledger_system": "El sistema",
            "ledger_title": "Movimientos",
            "ledger_when": "Cuándo",
            "low_badge": "Bajo el punto de reorden",
            "name_label": "Nombre",
            "name_placeholder": "Jitomate",
            "new": "Nuevo insumo",
            "new_title": "Nuevo insumo",
            "pending_purchases_action": "Ver compras",
            "pending_purchases_hint": "La existencia sube cuando marcas la compra como recibida, no cuando la capturas.",
            "pending_purchases_title": {
              "one": "Tienes 1 compra en borrador",
              "other": "Tienes %{count} compras en borrador"
            },
            "recipe_add": "Agregar",
            "recipe_add_ons_empty": "Este restaurante todavía no tiene extras.",
            "recipe_add_ons_hint": "Los extras llevan su propia receta. La comanda guarda cuáles eligió el comensal, así que sin esto el queso y el guacamole nunca se descuentan.",
            "recipe_add_ons_title": "Extras",
            "recipe_dishes_title": "Platillos",
            "recipe_lines_count": "%{count} insumos",
            "recipe_no_dishes_action": "Ir al menú",
            "recipe_no_dishes_hint": "Las recetas cuelgan de los platillos y de los extras del menú.",
            "recipe_no_dishes_title": "Todavía no hay platillos en el menú",
            "recipe_no_lines": "Sin receta",
            "recipe_no_supplies_action": "Ir al inventario",
            "recipe_no_supplies_hint": "Una receta dice cuánto de cada insumo lleva un platillo, así que primero necesitas los insumos.",
            "recipe_no_supplies_title": "Primero captura tus insumos",
            "recipe_quantity_placeholder": "Cantidad",
            "recipe_quantity_updated": "Cantidad actualizada.",
            "recipe_remove": "Quitar",
            "recipe_supply_placeholder": "Elige un insumo",
            "reorder_point_hint": "Cuando la existencia llegue a esta cantidad te lo marcamos. Déjalo vacío si no quieres aviso.",
            "reorder_point_label": "Punto de reorden",
            "reorder_point_placeholder": "Sin aviso",
            "setup_action": "Escribir recetas",
            "setup_hint": "Sin recetas nadie descuenta el inventario, así que la existencia solo puede subir. Cualquier faltante que te mostráramos ahorita sería un error de captura, no un insumo que se acabó.",
            "setup_title": "Todavía no podemos decirte qué te falta",
            "short_badge": "En negativo",
            "shortage_empty": "Ningún insumo está en negativo ni bajo su punto de reorden.",
            "shortage_title": "Insumos por revisar",
            "stock_label": "Existencia",
            "supply_updated": "Insumo actualizado.",
            "unit_hint": "Todo se mide en esta unidad. Compras, recetas y conteos usan la misma, porque el sistema no convierte de kilos a gramos.",
            "unit_label": "Unidad",
            "unit_locked": "Este insumo ya tiene movimientos, así que su unidad ya no se puede cambiar.",
            "unit_placeholder": "Elige la unidad"
          },
          "invoices": {
            "bill_not_paid": "Vas a poder facturar esta cuenta cuando esté pagada.",
            "cancel": "Cancelar",
            "cancel_confirm": "Cancelar factura",
            "cancel_description": "La cancelación se manda al SAT y queda registrada con tu nombre. El motivo sale del catálogo del SAT.",
            "cancel_open": "Cancelar factura",
            "cancel_reason_label": "Motivo de cancelación",
            "cancel_reason_placeholder": "Elige un motivo",
            "cancel_title": "Cancelar la factura",
            "cancellation_pending_notice": "Tu cliente todavía no acepta la cancelación.",
            "confirm": "Emitir factura",
            "error_label": "Qué pasó",
            "exhausted_notice": "Ya no lo volvemos a intentar solos. Contacta a soporte para revisarlo contigo.",
            "folio_label": "Folio fiscal",
            "folio_pending": "Todavía sin folio",
            "issue_description": "Copia los datos tal como te los dio tu cliente. La factura se emite a nombre de quien los dio.",
            "issue_open": "Facturar",
            "issue_title": "Facturar la cuenta",
            "issued_at_label": "Timbrada",
            "legal_name_label": "Razón social",
            "legal_name_placeholder": "Como aparece en su constancia",
            "no_permission": "Solo un gerente puede facturar.",
            "not_configured": "Carga los datos fiscales del restaurante para poder facturar esta cuenta.",
            "not_configured_link": "Ir a datos fiscales",
            "postal_code_label": "Código postal",
            "postal_code_placeholder": "06000",
            "receiver_label": "Receptor",
            "rfc_label": "RFC del cliente",
            "rfc_placeholder": "XAXX010101000",
            "status_pending": "Pedimos el timbre al SAT. El folio aparece aquí en cuanto responda.",
            "submitting": "Enviando…",
            "substitute_hint": "El SAT lo exige cuando cancelas por sustitución.",
            "substitute_label": "Folio que la reemplaza",
            "substitute_placeholder": "UUID de la factura correcta",
            "tax_regime_label": "Régimen fiscal",
            "tax_regime_placeholder": "Elige el régimen de tu cliente",
            "title": "Factura",
            "usage_label": "Uso del CFDI",
            "usage_placeholder": "Elige el uso"
          },
          "item_stocks": {
            "cancel": "Cancelar",
            "create": "Empezar a contar",
            "creating": "Guardando…",
            "delete": "Dejar de contar",
            "delete_confirm": "Dejar de contar",
            "delete_description": "El platillo vuelve a depender solo de si está activo o no, sin límite de existencias.",
            "delete_title": "Dejar de contar este platillo",
            "empty_action": "Contar el primer platillo",
            "empty_hint": "Elige los platillos que quieres controlar por existencia y el sistema deja de venderlos en cuanto se acaben.",
            "empty_title": "Todavía no cuentas ningún platillo",
            "item_label": "Platillo",
            "item_placeholder": "Elige un platillo",
            "low_threshold_hint": "Cuando la existencia llegue a esta cantidad te avisamos. Déjalo en 0 si solo quieres saber cuándo se acaba.",
            "low_threshold_label": "Avisarme desde",
            "low_threshold_placeholder": "0",
            "new": "Contar un platillo",
            "new_title": "Empezar a contar un platillo",
            "quantity_label": "Existencia",
            "quantity_placeholder": "0",
            "status_available": "Disponible",
            "status_depleted": "Agotado",
            "status_low": "Se está acabando",
            "table_actions": "Acciones",
            "table_item": "Platillo",
            "table_quantity": "Existencia",
            "table_status": "Estado",
            "table_threshold": "Aviso desde",
            "title": "Existencias"
          },
          "menu_item_detail_drawer": {
            "modifiers_available": "Extras disponibles",
            "soldout": "Agotado"
          },
          "new_order_form": {
            "add_less_item_order": "Agrega al menos un producto a la comanda.",
            "bill": "Cuenta:",
            "bill_2": "Cuenta",
            "cancel": "Cancelar",
            "create_new_bill_table": "Se creará una nueva cuenta para esta mesa.",
            "decrease_quantity": "Reducir cantidad",
            "extras": "Extras",
            "increase_quantity": "Aumentar cantidad",
            "no_item_selected": "No hay producto seleccionado.",
            "no_items_available": "No hay productos disponibles para ordenar.",
            "notes": "Notas",
            "notes_placeholder": "Sin cebolla, bien cocido, salsa aparte…",
            "order_empty": "La comanda está vacía",
            "quantity": "Cantidad",
            "select_bill": "Selecciona una cuenta",
            "select_bill_table": "Selecciona una cuenta para la mesa.",
            "select_table": "Selecciona una mesa",
            "select_table_before_order": "Selecciona una mesa antes de crear la comanda.",
            "table": "Mesa",
            "type_service": "Tipo de servicio",
            "view_order": "Ver comanda"
          },
          "order_detail_drawer": {
            "bill": "Cuenta",
            "customer": "Cliente",
            "eta_pickup": "ETA pickup",
            "eta_pickup_minutes": "ETA para recoger (minutos)",
            "example_10": "Ej. 10",
            "extras": "Extras",
            "min": "min",
            "notes": "Notas",
            "placed_at": "Recibida",
            "price": "Precio",
            "quantity": "Cantidad",
            "station": "Estación",
            "table": "Mesa"
          },
          "orders_board": {
            "all_stations": "Todas",
            "bill": "Cuenta %{id}",
            "column_empty": "Sin comandas",
            "delayed": "Demorada",
            "description": "Comandas activas. Arriba, la que más lleva esperando.",
            "empty_hint": "Cuando entre una comanda aparecerá aquí, con la que más lleva esperando arriba.",
            "empty_title": "Sin comandas activas",
            "eta": "ETA: %{count} min",
            "just_placed": "recién",
            "minutes_short": "%{count} min",
            "new_order": "Nueva comanda",
            "no_matches_hint": "Cambia de estación o quita el filtro de demoradas.",
            "no_matches_title": "Ninguna comanda coincide",
            "note": "Nota: %{note}",
            "only_delayed": "Solo demoradas",
            "open_detail": "Ver detalle de la comanda",
            "quantity": "Cantidad",
            "service_type_description": "Elige cómo se va a servir. Cada una abre la pantalla donde se toma.",
            "service_type_dine_in": "Para comer aquí",
            "service_type_dine_in_hint": "Elige la mesa y toma la comanda desde ahí.",
            "service_type_title": "¿Para dónde es la comanda?",
            "service_type_to_go": "Para llevar",
            "service_type_to_go_hint": "Captura al comensal y arma la comanda de mostrador.",
            "station_filter": "Filtrar por estación",
            "status_filter": "Filtrar por estado",
            "title": "Comandas",
            "waiting_time": "Tiempo de espera"
          },
          "promotions": {
            "cancel": "Cancelar",
            "coupon_cancel": "Cancelar",
            "coupon_code_label": "Código",
            "coupon_code_placeholder": "VERANO25",
            "coupon_create": "Crear cupón",
            "coupon_delete": "Eliminar",
            "coupon_delete_confirm": "Eliminar",
            "coupon_delete_description": "Solo se puede eliminar un cupón que nadie usó.",
            "coupon_delete_title": "Eliminar cupón",
            "coupon_expires_hint": "Déjalo vacío si no quieres que venza.",
            "coupon_expires_label": "Vence",
            "coupon_expires_never": "No vence",
            "coupon_expires_on": "Vence el %{date}",
            "coupon_max_label": "Usos permitidos",
            "coupon_new": "Nuevo cupón",
            "coupon_revoke": "Revocar",
            "coupon_revoke_confirm": "Revocar cupón",
            "coupon_revoke_description": "El código deja de funcionar de inmediato. Las veces que ya se usó siguen registradas.",
            "coupon_revoke_reason_label": "Motivo",
            "coupon_revoke_reason_placeholder": "Se filtró en redes",
            "coupon_revoke_title": "Revocar cupón",
            "coupon_revoked_reason": "Motivo: %{reason}",
            "coupon_used_hint": "Ya se usó, así que no se puede eliminar. Revócalo para que deje de funcionar.",
            "coupon_uses": "%{used} de %{max} usos",
            "coupons_description": "Códigos que el comensal escribe para disparar esta misma promoción.",
            "coupons_empty": "Esta promoción no tiene cupones.",
            "coupons_open": "Cupones (%{count})",
            "coupons_title": "Cupones de esta promoción",
            "create": "Crear promoción",
            "dates_always": "Sin fechas límite",
            "dates_from": "Desde %{date}",
            "dates_range": "%{from} — %{to}",
            "dates_until": "Hasta %{date}",
            "delete": "Eliminar",
            "delete_confirm": "Eliminar",
            "delete_description": "Se elimina la regla y los cupones que dependen de ella. Una promoción que ya descontó cuentas reales no se puede eliminar: archívala.",
            "delete_title": "Eliminar promoción",
            "edit": "Editar",
            "edit_title": "Editar promoción",
            "empty_action": "Crear la primera promoción",
            "empty_hint": "Una promoción es una regla que descuenta sola, sin que nadie esté ahí. Crea la primera y actívala cuando la hayas revisado.",
            "empty_title": "Todavía no hay promociones",
            "ends_on_label": "Termina",
            "form_description": "Define qué descuenta, a qué alcanza y entre qué fechas. Se crea en borrador y no cambia ningún precio hasta que la actives.",
            "kind_label": "Tipo de descuento",
            "live_now": "Aplicando ahora",
            "max_discount_hint": "Lo máximo que puede descontar cada vez que se aplica. Déjalo vacío si no quieres tope.",
            "max_discount_label": "Tope por aplicación",
            "max_discount_placeholder": "Sin tope",
            "name_label": "Nombre",
            "name_placeholder": "Happy hour de cervezas",
            "new": "Nueva promoción",
            "new_title": "Nueva promoción",
            "not_live_now": "Fuera de horario",
            "priority_hint": "Cuando dos promociones alcanzan el mismo platillo, gana la de prioridad más alta.",
            "priority_label": "Prioridad",
            "priority_summary": "Prioridad %{value}",
            "reach_bill": "Toda la cuenta",
            "reach_categories": "%{count} categorías",
            "reach_items": "%{count} platillos",
            "save": "Guardar cambios",
            "scope_label": "Alcance",
            "starts_on_label": "Empieza",
            "status_label": "Estado",
            "status_updated": "Estado de la promoción actualizado.",
            "targets_categories_empty": "Todavía no tienes categorías en el menú.",
            "targets_categories_label": "Categorías que alcanza",
            "targets_items_empty": "Todavía no tienes platillos en el menú.",
            "targets_items_label": "Platillos que alcanza",
            "targets_selected": "%{count} seleccionados",
            "value_label_fixed": "Monto a descontar",
            "value_label_percentage": "Porcentaje a descontar",
            "window_description": "Los días y las horas en que esta regla aplica.",
            "window_enable": "Aplicar solo en este horario",
            "window_enable_hint": "Si lo dejas apagado, la promoción aplica a toda hora dentro de sus fechas.",
            "window_open": "Horario",
            "window_time_zone": "El horario se lee en la zona horaria del restaurante (%{zone}).",
            "window_title": "Horario de la promoción"
          },
          "purchasing": {
            "back_to_purchases": "Volver a compras",
            "blocked_go_suppliers": "Ir a proveedores",
            "blocked_no_suppliers_hint": "Una compra siempre es a alguien. Crea al proveedor y regresa aquí.",
            "blocked_no_suppliers_title": "Primero registra un proveedor",
            "blocked_no_supplies_hint": "Una compra suma cantidades a insumos que ya existen. Créalos en Insumos, con la unidad en la que los vas a contar.",
            "blocked_no_supplies_title": "Primero registra tus insumos",
            "cancel": "Cancelar",
            "cancelled_by": "Cancelada por %{name} el %{at} · %{reason}",
            "created_at_label": "Capturada",
            "drafts_empty": "No tienes compras esperando mercancía.",
            "history_capped": "Mostrando las %{shown} más recientes de %{total}.",
            "history_empty": "Todavía no recibes ni cancelas ninguna compra.",
            "line_add": "Agregar insumo",
            "line_pack_hint": "Sacamos la cantidad y el costo por %{unit}. El paquete no se guarda: el inventario solo entiende la unidad del insumo.",
            "line_pack_mode": "Lo compré por paquete",
            "line_pack_price_label": "Precio del paquete",
            "line_packs_label": "Paquetes",
            "line_quantity_label": "Cantidad",
            "line_remove": "Quitar insumo",
            "line_supply_label": "Insumo",
            "line_supply_placeholder": "Elige un insumo",
            "line_total_label": "Total",
            "line_unit_cost_label": "Costo por %{unit}",
            "line_unit_cost_short": "Costo unitario",
            "line_unit_unknown": "unidad",
            "line_units_per_pack_label": "Contenido por paquete (%{unit})",
            "lines_title": "Insumos de la compra",
            "purchase_cancel": "Cancelar compra",
            "purchase_create": "Guardar compra",
            "purchase_draft_hint": "Se guarda en borrador. El inventario no se mueve hasta que la recibas.",
            "purchase_invoice_hint": "Opcional. Queda anotado en cada movimiento de inventario que genere esta compra.",
            "purchase_invoice_label": "Factura o remisión",
            "purchase_invoice_placeholder": "A-1234",
            "purchase_new": "Nueva compra",
            "purchase_receive": "Recibir",
            "purchase_supplier_label": "Proveedor",
            "purchase_supplier_placeholder": "Elige a quién le compraste",
            "purchase_total_label": "Total de la compra",
            "purchases_empty_hint": "Captura lo que le pediste a tu proveedor. Cuando llegue la mercancía la recibes y el inventario se mueve solo.",
            "purchases_empty_title": "Todavía no registras compras",
            "receive_confirm": "Recibir compra",
            "receive_description": "Al recibir se suma todo al inventario y se actualiza el costo promedio de cada insumo. Esto no se puede deshacer.",
            "receive_submitting": "Recibiendo…",
            "receive_title": "¿Ya llegó la mercancía?",
            "received_at_label": "Recibida",
            "received_by": "Recibida por %{name} el %{at}",
            "received_note": "Esta compra ya movió el inventario y el costo promedio, así que no se puede cancelar. Si algo regresó con el proveedor, regístralo como un movimiento de inventario.",
            "row_invoice": "Factura %{invoice}",
            "row_lines": "%{count} insumos",
            "row_lines_label": "Insumos",
            "row_no_invoice": "Sin factura",
            "section_drafts": "Pendientes de recibir",
            "section_history": "Historial",
            "supplier_active": "Activo",
            "supplier_contact_label": "Contacto",
            "supplier_contact_placeholder": "Nombre de quien te atiende",
            "supplier_create": "Crear proveedor",
            "supplier_delete": "Eliminar",
            "supplier_delete_confirm": "Eliminar",
            "supplier_delete_description": "Solo se puede eliminar un proveedor que nunca surtió nada.",
            "supplier_delete_title": "Eliminar proveedor",
            "supplier_form_description": "Con el nombre basta. El contacto y el teléfono los puedes agregar después.",
            "supplier_has_purchases": "Tiene %{count} compras registradas, así que ya no se puede eliminar. Desactívalo para que deje de aparecer al capturar una compra.",
            "supplier_inactive": "Inactivo",
            "supplier_name_label": "Nombre",
            "supplier_name_placeholder": "Abarrotes del Centro",
            "supplier_new": "Nuevo proveedor",
            "supplier_new_title": "Nuevo proveedor",
            "supplier_phone_label": "Teléfono",
            "supplier_phone_placeholder": "55 1234 5678",
            "supplier_updated": "Proveedor actualizado.",
            "suppliers_empty_hint": "Un proveedor es quien te surte. Lo vas a necesitar para registrar tu primera compra.",
            "suppliers_empty_title": "Todavía no tienes proveedores",
            "unknown_actor": "Sin registrar"
          },
          "receipt_share": {
            "downloaded": "Recibo descargado.",
            "failed": "No se pudo generar el recibo. Vuelve a intentarlo.",
            "share": "Compartir recibo",
            "sharing": "Generando…",
            "text": "Tu recibo de la cuenta #%{id}.",
            "title": "Recibo"
          },
          "refunds": {
            "amount_label": "Monto a devolver",
            "blocked_fully_refunded": "Este cobro ya se devolvió completo.",
            "blocked_generic": "Este cobro no admite reembolso.",
            "blocked_not_settled": "Este cobro todavía no se liquida.",
            "cancel": "Cancelar",
            "confirm": "Confirmar reembolso",
            "description": "Elige el motivo y confirma. El reembolso queda registrado con tu nombre.",
            "drawer_no_shift": "Abre la caja para devolver efectivo: el dinero sale del cajón de hoy y tiene que quedar registrado en el turno.",
            "drawer_notice": "Vas a entregar %{amount} en efectivo del cajón de hoy. Cuenta el dinero antes de confirmar: el arqueo del turno ya descuenta esta salida.",
            "issued_failed": "Falló",
            "issued_pending": "En proceso",
            "issued_succeeded": "Devuelto",
            "issued_title": "Reembolsos de este cobro",
            "open": "Reembolsar",
            "provider_notice": "El dinero regresa a la tarjeta del comensal. Stripe procesa la devolución y puede tardar varios días en aparecer en su estado de cuenta.",
            "reason_hint": "El motivo queda en la bitácora de la sucursal y es lo que se cuenta después para saber por qué se devuelve dinero.",
            "reason_label": "Motivo del reembolso",
            "reason_placeholder": "Elige un motivo",
            "submitting": "Reembolsando…",
            "title": "Reembolsar cobro",
            "unknown_actor": "Sin registrar"
          },
          "table_detail_workspace": {
            "account": "Cuenta",
            "add_order": "Agregar a la comanda",
            "add_something_else": "Agregar algo más",
            "adjust_search_select_other_category": "Ajusta la búsqueda o selecciona otra categoría.",
            "all": "Todo",
            "amount_outstanding": "Falta",
            "amount_paid": "Pagado",
            "amount_to_charge": "Monto a cobrar",
            "bill": "En cuenta",
            "bill_views": "Vistas de cuentas",
            "cancel": "Cancelar",
            "cancel_attempt": "Devolver productos",
            "cancel_split": "Cancelar división",
            "category": "Sin categoría",
            "charge": "Cobrar ·",
            "charge_2": "Cobrar",
            "charge_cash": "Cobrar efectivo",
            "charge_terminal": "Cobrar terminal",
            "choose_item_menu_start": "Elige un producto del menú para empezar a construir la cuenta.",
            "closed_bills_placeholder": "Las cuentas cerradas aparecerán aquí.",
            "confirm_payment": "Confirmar pago",
            "decrease_quantity": "Reducir cantidad",
            "digital_payment_auto_confirmed": "Este cobro digital se confirma automáticamente vía Stripe.",
            "diners": "Comensales",
            "dining_room": "Salón",
            "disabled_table_add_items": "La mesa está deshabilitada. Reactivala antes de agregar nuevos productos.",
            "disabled_table_open_bill": "La mesa está deshabilitada. Reactivala antes de abrir una cuenta.",
            "dish_count_one": "%{count} platillo",
            "dish_count_other": "%{count} platillos",
            "expire_checkout": "Expirar sesión",
            "extra_open_bills": "Esta mesa tiene más de una cuenta abierta",
            "extra_open_bills_hint": "Cobra o cierra las cuentas de abajo para poder liberar la mesa.",
            "extras": "Extras",
            "grid": "Cuadrícula",
            "history": "Historial",
            "history_2": "Sin historial",
            "increase_quantity": "Aumentar cantidad",
            "invite": "Invitar",
            "invite_link": "Liga de invitación",
            "item": "producto",
            "k": "⌘K",
            "list": "Lista",
            "mark_failure": "Marcar fallo",
            "menu": "Menú",
            "menu_categories": "Categorías del menú",
            "no_active_bill": "Todavía no hay cuenta activa",
            "no_linked_diners": "Todavía no hay comensales vinculados. Usa %{invite} para compartir el QR de esta mesa.",
            "no_linked_diners_static": "Todavía no hay comensales vinculados.",
            "no_payments_in_flight": "Nadie está pagando ahora.",
            "no_settled_payments": "Todavía no se cobró nada.",
            "notes": "Notas",
            "notes_placeholder": "Sin cebolla, salsa aparte…",
            "open": "Abiertas",
            "open_without_reservation": "Abrir sin reserva",
            "orders": "Comandas",
            "payment_progress": "Cobro en curso",
            "payments_in_flight": "En curso",
            "payments_settled": "Cobrados",
            "quantity": "Cantidad",
            "ready": "Lista",
            "reopen": "Reabrir",
            "reopening": "Reabriendo…",
            "reservation_arriving": "Están por llegar",
            "reservation_booked": "Reservada",
            "reservation_conflict_warning": "Esta mesa está apartada para las %{time}. Si la abres sin reserva, %{guest} llega a una mesa ocupada.",
            "reservation_party": {
              "one": "%{count} persona",
              "other": "%{count} personas"
            },
            "reservation_seat": "Sentar",
            "results": "Sin resultados",
            "search_dish_drink_ingredient": "Buscar platillo, bebida, ingrediente…",
            "seats": "Asientos",
            "select_item_menu": "Selecciona un producto del menú.",
            "select_line_to_charge": "Seleccionar %{name} para cobrar",
            "selected_lines": {
              "one": "1 producto seleccionado",
              "other": "%{count} productos seleccionados"
            },
            "share_of_split": "Parte de la división",
            "soldout": "Agotado",
            "someone_pays": "%{name} está pagando",
            "split_outstanding": "Falta cobrar",
            "split_progress": "Dividida entre %{count}",
            "start_bill": "Empieza la cuenta",
            "status_table": "Estado de la mesa",
            "subtotal": "Subtotal",
            "tables": "Mesas",
            "tap_dish_menu_add": "Toca un platillo del menú para agregarlo a la cuenta.",
            "text": "por",
            "total": "Total",
            "unavailable": "No disponible",
            "unoccupied_actions_note": "%{open} ocupa la mesa y abre su primera cuenta. %{invite} solo comparte la invitación: la cuenta nace cuando el comensal entra.",
            "unoccupied_disabled_hint": "Esta mesa no puede recibir comandas. Abre Estado de la mesa arriba y usa Liberar para volver a ponerla disponible.",
            "unoccupied_disabled_pending_hint": "Esta mesa no puede recibir comandas y todavía tiene una cuenta por cobrar. Cóbrala o cancélala y después libera la mesa.",
            "unoccupied_disabled_title": "Mesa deshabilitada",
            "unoccupied_free_hint": "Abre la mesa para empezar a tomar la comanda. El menú y la cuenta aparecen en cuanto esté ocupada.",
            "unoccupied_free_title": "Mesa libre",
            "unoccupied_invite": "Abrir con QR",
            "unoccupied_reserved_hint": "Ábrela cuando lleguen los comensales para empezar a tomar la comanda.",
            "unoccupied_reserved_title": "Mesa reservada",
            "waiting_for": "hace %{minutes} min",
            "workspace_sections": "Secciones de la mesa",
            "zone": "Zona"
          },
          "tables_overview": {
            "acknowledge_waiter_call": "Atender",
            "actions_quick": "Acciones rápidas",
            "adjust_filters_search_view": "Ajusta los filtros o la búsqueda para ver más mesas.",
            "all": "Todas",
            "attention": "Atención (",
            "attention_count": {
              "one": "%{count} con atención",
              "other": "%{count} con atención"
            },
            "awaiting_release": "Lista para liberar",
            "bill": "cuenta",
            "bills": "Cuentas",
            "bills_pending": "Cuentas pendientes",
            "bills_pending_count": {
              "one": "%{count} cuenta pendiente",
              "other": "%{count} cuentas pendientes"
            },
            "capacity": "Capacidad",
            "charge": "Por cobrar",
            "close": "Cerrar",
            "diners_count": {
              "one": "%{count} comensal",
              "other": "%{count} comensales"
            },
            "dining_room": "Salón",
            "dish_ready": "Platillo listo",
            "free": "Libre",
            "free_2": "Libres",
            "go_to_table": "Ir a la mesa",
            "grid": "Cuadrícula",
            "item": "producto",
            "items_ticket": "Productos en comanda",
            "kitchen": "Cocina",
            "last_event": "Último evento",
            "list": "Lista",
            "live": "En vivo",
            "need_attention_now": "Necesitan atención ahora",
            "no_diners": "Sin comensales",
            "no_matches": "Sin coincidencias",
            "no_matches_hint": "Ajusta los filtros o la búsqueda para ver más mesas.",
            "no_recent_updates": "Sin actualizaciones recientes.",
            "no_tables": "No hay mesas configuradas",
            "no_tables_manager_hint": "Configura mesas para empezar a operar el salón.",
            "no_tables_staff_hint": "Pídele a un gerente que configure las mesas del salón.",
            "occupancy": "%{percent}% ocupado",
            "occupied": "Ocupada",
            "occupied_2": "Ocupadas",
            "open": "abierta",
            "open_bills_count": {
              "one": "%{count} abierta",
              "other": "%{count} abiertas"
            },
            "open_table": "Abrir mesa",
            "payment": "Cobro",
            "people": "Personas",
            "people_of": "%{count} de %{total}",
            "ready": "Lista",
            "ready_occupy": "Lista para ocupar",
            "ready_serve": "Listo para servir",
            "ready_serve_2": "Listo servir",
            "recent_updates": "Actualizaciones recientes",
            "require_attention": "Requieren atención",
            "requires_attention": "Requiere atención",
            "sales_pending": "Ventas pendientes",
            "search_table_status_event": "Buscar mesa, estado o evento…",
            "seats": "asientos",
            "seats_2": "lugares",
            "seats_count": {
              "one": "%{count} asiento",
              "other": "%{count} asientos"
            },
            "serve": "Servir",
            "status": "Estado",
            "status_disabled": "Deshabilitadas",
            "status_reserved": "Reservadas",
            "subtotal": "Subtotal",
            "summary": "Resumen",
            "table": "Mesa",
            "table_2": "Mesa ·",
            "table_3": "Mesa con",
            "tables": "Mesas",
            "taking_order": "Tomando comanda",
            "ticket_kitchen": "Comanda en cocina",
            "total": "Total",
            "view_mode": "Modo de vista",
            "view_qr": "Ver QR"
          }
        },
        "user": {
          "cart_screen": {
            "add": "Sumar",
            "bill": "Cuenta",
            "bill_empty_back_menu": "La cuenta está vacía. Vuelve al menú para agregar platos.",
            "consumed_total": "Total consumido",
            "item": "producto",
            "subtract": "Restar",
            "tip": "Propina",
            "total_table": "Total mesa"
          },
          "category_chips": {
            "all": "Todo"
          },
          "coupon_field": {
            "apply": "Aplicar",
            "applying": "Revisando…",
            "empty": "Escribe tu código.",
            "generic": "Ese código no se puede usar.",
            "label": "¿Tienes un código?",
            "network_error": "No pudimos revisar el código. Intenta de nuevo.",
            "placeholder": "CODIGO",
            "rate_limited": "Demasiados intentos. Espera un momento antes de probar otro código.",
            "remove": "Quitar el código"
          },
          "create_order": {
            "add_order": "Agregar Pedido",
            "cancel": "Cancelar",
            "create_new_order_table": "Crea una nueva orden para tu mesa.",
            "order": "Ordenar"
          },
          "create_order_form": {
            "add_order": "Agregar Pedido",
            "adding_order": "Agregando pedido...",
            "example_onion_well_cooked_etc": "Ej: Sin cebolla, bien cocido, etc.",
            "information_additional_order_optional": "Información adicional para el pedido (opcional)",
            "notes": "Notas",
            "quantity": "Cantidad",
            "quantity_products_ask": "La cantidad de productos a pedir",
            "type_service": "Tipo de Servicio",
            "type_service_order": "El tipo de servicio para el pedido"
          },
          "directory": {
            "closed": "Cerrado",
            "distance_km": "%{value} km",
            "empty": "Busca un restaurante para pedir para recoger.",
            "locating": "Ubicándote…",
            "location_denied": "No pudimos obtener tu ubicación.",
            "near_me": "Cerca de mí",
            "no_results": "No encontramos restaurantes para \"%{query}\".",
            "open": "Abierto",
            "pickup_unavailable": "No toma pedidos para llevar",
            "search_placeholder": "Buscar restaurantes",
            "sorted_by_distance": "Ordenado por cercanía",
            "title": "Restaurantes"
          },
          "dish_detail": {
            "15_min": "15 min",
            "add": "Sumar",
            "back": "Volver",
            "cilantro_allergies_etc": "Sin cilantro, alergias, etc.",
            "customize_order": "Personaliza tu pedido",
            "dish_payer": "Quién paga este plato",
            "eat_in": "Comer aquí",
            "favorite": "Favorito",
            "notes_kitchen": "Notas para la cocina",
            "only": "Solo para mí",
            "optional": "Opcional",
            "recipe_house": "Receta de la casa",
            "select_want_add": "Selecciona lo que quieras agregar",
            "service_type_question": "¿Cómo lo quieres?",
            "subtract": "Restar",
            "table": "Para la mesa",
            "take_out": "Para llevar",
            "who": "¿Para quién?"
          },
          "dish_list_item": {
            "add": "Agregar %{name}"
          },
          "dish_price": {
            "original": "Precio normal:",
            "promoted": "Precio con promoción:"
          },
          "farewell_screen": {
            "bill_closed_at": "Cerramos tu cuenta en %{name}.",
            "bill_closed_generic": "Tu cuenta quedó cerrada.",
            "go_home": "Ir a inicio",
            "table_closed": "La mesa %{name} quedó libre. Vuelve pronto.",
            "thanks_for_visit": "¡Gracias por tu visita!",
            "view_bill": "Ver mi cuenta"
          },
          "featured_card": {
            "15_min": "15 min",
            "favorite": "Favorito",
            "recommended": "Recomendado"
          },
          "home_screen": {
            "active_now": "Activa ahora",
            "categories": "Categorías",
            "clear_search": "Limpiar búsqueda",
            "continue_ordering": "Continuar tu pedido",
            "dishes": "platos",
            "featured_house": "Destacados de la casa",
            "greeting": "Hola, %{name}",
            "hello": "Hola",
            "home": "Domicilio",
            "more": "Más",
            "no_products_in_category": "No hay productos disponibles en esta categoría.",
            "no_results": "No encontramos platos para \"%{query}\".",
            "no_visits": "Aún no tienes visitas. Escanea el código QR de tu mesa para empezar.",
            "notifications": "Notificaciones",
            "order_pickup": "Pedir para llevar",
            "pickup": "Recoger",
            "pickup_context": "Para recoger",
            "results": "Resultados",
            "scan_qr": "Escanear QR",
            "search_dish_ingredient": "Busca un platillo o ingrediente…",
            "search_restaurants": "Buscar restaurantes",
            "subtitle": "¿Qué se te antoja hoy?",
            "table": "En mesa",
            "text": "Estás en",
            "view_menu": "Ver menú",
            "view_receipt": "Ver recibo",
            "your_visits": "Tus visitas"
          },
          "order_line": {
            "discount": "Descuento"
          },
          "pay_sheet": {
            "already_paid": "Pagado",
            "back": "Volver",
            "cancel_split": "Cancelar la división",
            "cash_subtitle": "El staff confirma el efectivo al recibirlo.",
            "choose_items": "Elige los productos",
            "choose_method_payment": "Elige tu método de pago.",
            "choose_scope_tip_method": "Elige qué cubres, la propina y cómo pagas.",
            "confirm_divide": "Dividir entre %{count}",
            "continue_to_checkout": "Continuar al checkout",
            "custom_tip_field_label": "Monto de la propina",
            "custom_tip_label": "Otro monto",
            "custom_tip_short": "Otro",
            "digital_checkout_subtitle": "Redirige a Stripe Checkout seguro.",
            "divide_locked": "La mesa ya está dividiendo. No se pueden pagar productos por separado.",
            "method": "Método",
            "mode_divide": "Dividir la cuenta",
            "mode_divide_hint": "El total se parte en partes iguales.",
            "mode_items": "Cada quien lo suyo",
            "mode_items_hint": "Eliges los productos que cubres.",
            "network_error": "No pudimos iniciar el cobro. Reintenta en unos segundos.",
            "no_payment_methods": "Este restaurante todavía no habilitó métodos de pago para comensales.",
            "nothing_mine": "Sin productos tuyos",
            "nothing_selected": "Elige al menos un producto.",
            "offline_payment_pending": "El cobro quedó pendiente para que el staff lo confirme.",
            "only_mine": "Solo lo mío",
            "opening_split": "Abriendo…",
            "pay": "Pagar",
            "payers_left": "Faltan %{count} por pagar",
            "people_paying": "¿Entre cuántos?",
            "processing": "Procesando…",
            "request_staff_charge": "Solicitar cobro",
            "reserved_by_other": "En otro cobro",
            "select_all": "Toda la cuenta",
            "select_mine": "Solo lo mío",
            "settle_hint": "Es lo que la mesa decide una sola vez.",
            "settle_question": "¿Cómo pagan?",
            "share_below_minimum": "Con ese número las partes quedan muy chicas para pagar con tarjeta en la app.",
            "subtotal": "Subtotal",
            "terminal_subtitle": "Pagar con terminal en el lugar",
            "tip": "Propina",
            "total_payable": "Total a cobrar",
            "what_you_pay": "¿Qué pagas?",
            "whole_bill": "Toda la cuenta",
            "your_share": "Te toca"
          },
          "pickup_cart": {
            "added": "Agregado a tu pedido",
            "back_to_menu": "Ver el menú",
            "empty": "Todavía no agregas nada.",
            "network_error": "No pudimos conectarnos. Intenta de nuevo.",
            "opening_payment": "Abriendo el pago...",
            "pay": "Pagar",
            "refusal_changed": "Algo cambió en el menú: %{items}. Revisa tu pedido antes de pagar.",
            "refusal_changed_generic": "Algo cambió en el menú. Revisa tu pedido antes de pagar.",
            "refusal_empty": "Tu pedido quedó vacío.",
            "refusal_location_closed": "Este restaurante está cerrado en este momento.",
            "refusal_location_unavailable": "Este restaurante ya no está tomando pedidos para llevar.",
            "refusal_payment_unavailable": "No pudimos abrir el pago. Intenta más tarde.",
            "refusal_rate_limited": "Demasiados intentos. Espera un momento antes de volver a pagar.",
            "refusal_registration_required": "Necesitas una cuenta registrada para pagar.",
            "register_to_pay": "Crea tu cuenta para pagar",
            "remove": "Quitar del pedido",
            "service_fee": "Cuota de servicio (%{percentage}%%)",
            "subtotal": "Subtotal",
            "title": "Tu pedido",
            "total": "Total"
          },
          "pickup_closed": {
            "cannot_order": "No se puede ordenar",
            "opens_at": "Abre el %{date}",
            "title": "Cerrado ahora"
          },
          "receipt_screen": {
            "net_total": "Total después de reembolsos",
            "paid_on": "Pagado el %{date}",
            "payment_method": "Método de pago",
            "refunds": "Reembolsos",
            "request_invoice": "Facturar este consumo",
            "service_fee": "Cuota de servicio",
            "subtotal": "Subtotal",
            "tax_line": "%{name} (%{rate}%)",
            "taxes_included": "Impuestos incluidos en lo que pagaste",
            "title": "Recibo",
            "total": "Total"
          },
          "screen_header": {
            "back": "Volver",
            "more_actions": "Más acciones"
          },
          "self_invoice_form": {
            "constancia_hint": "Todos estos datos están en tu constancia de situación fiscal. Si no coinciden, el SAT rechaza la factura.",
            "legal_name": "Razón social",
            "legal_name_hint": "Tal como aparece en tu constancia de situación fiscal, sin el régimen societario abreviado.",
            "paid_on": "Pagado el %{date}",
            "postal_code": "Código postal fiscal",
            "rfc": "RFC",
            "submit": "Generar mi factura",
            "tax_regime": "Régimen fiscal",
            "tax_regime_placeholder": "Elige tu régimen",
            "total": "Total del consumo",
            "usage": "Uso de la factura",
            "usage_placeholder": "Elige el uso"
          },
          "tab_bar": {
            "bill": "Cuenta",
            "home": "Inicio",
            "menu": "Menú",
            "orders": "Pedidos",
            "receipts": "Recibos"
          },
          "tracking_screen": {
            "approx": "aproximados",
            "ask_water_something_more": "Pedir agua, algo más",
            "back": "Volver",
            "back_menu": "Volver al menú",
            "call_waiter": "Llamar mesero",
            "changes_allergies": "Cambios o alergias",
            "minutes": "minutos",
            "notes_kitchen": "Notas a cocina",
            "order_mny": "Pedido #MNY-"
          }
        }
      },
      "pages": {
        "admin": {
          "dashboards": {
            "index": {
              "actions": "Acciones",
              "amount": "Monto",
              "cancel": "Cancelar",
              "days_owed": "Días de deuda",
              "forgive": "Condonar",
              "forgive_description": "Los $%{amount} de %{name} se dan por perdidos y no se pueden volver a cobrar. El motivo es lo único que va a quedar para explicarlo.",
              "forgive_title": "¿Condonar esta deuda?",
              "last_failure": "Último rechazo",
              "location": "Restaurante",
              "no_attempts": "Sin intentos",
              "period": "Periodo",
              "reason": "Motivo",
              "reason_placeholder": "Qué pasó y qué se acordó.",
              "search": "Buscar por restaurante",
              "showing": "Mostrando %{count} de %{total} facturas",
              "status": "Estado",
              "suspend": "Suspender",
              "suspend_description": "%{name} deja de operar hasta ponerse al corriente. Puede pagar los $%{amount} en cualquier momento y se reactiva sola.",
              "suspend_title": "¿Suspender la operación?",
              "title": "Comisiones por cobrar"
            },
            "show": {
              "location_col": "Sucursal",
              "new_locations": "Sucursales nuevas",
              "new_users": "Usuarios nuevos",
              "no_sales": "Sin ventas en este periodo",
              "period_day": "Diario",
              "period_month": "Mensual",
              "period_year": "Anual",
              "sales_col": "Ventas",
              "service_fee_col": "Cuota de servicio",
              "service_fees": "Cuotas de servicio",
              "subtitle": "Resumen de negocio",
              "top_locations": "Sucursales top",
              "top_locations_subtitle": "Mayores ventas y cuotas de servicio",
              "total_sales": "Ventas totales",
              "vs_previous": "vs. periodo anterior"
            }
          },
          "events": {
            "index": {
              "events": "Eventos"
            }
          },
          "jobs": {
            "index": {
              "action": "Acción",
              "active": "Activa",
              "arg1_key_value": "{} o [\"arg1\", {\"key\": \"value\"}]",
              "arguments_json": "Argumentos JSON",
              "available": "Disponible",
              "blocked": "Bloqueado",
              "blocked_2": "Bloqueados",
              "blocked_3": "· Bloqueados:",
              "cancel": "Cancelar",
              "created": "Creado",
              "date": "Fecha",
              "definitions_active_registered_solid_queue": "Definiciones activas registradas por Solid Queue scheduler.",
              "enqueue_job": "Encolar job",
              "enqueue_job_description": "Encolando %{className} en %{queueName}",
              "errors_recent_saved_solid_queue": "Errores recientes guardados en `solid_queue_failed_executions`.",
              "exception": "Excepción",
              "execution": "En ejecución",
              "executions_pending": "Ejecuciones pendientes",
              "failed": "Fallido",
              "failed_2": "Fallidos",
              "failures": "Fallos",
              "finished": "Finalizado",
              "healthy": "Saludable",
              "heartbeat": "Sin heartbeat",
              "heartbeat_workers_dispatchers": "Heartbeat de workers/dispatchers.",
              "host": "Host",
              "job": "Tarea",
              "job_class": "Clase de tarea",
              "jobs": "Tareas",
              "jobs_created_solid_queue": "jobs creados en Solid Queue.",
              "jobs_ready_scheduled_blocked_execution": "Jobs listos, programados o bloqueados para ejecución.",
              "jobs_recent": "Trabajos recientes",
              "key": "Clave",
              "kind": "Tipo",
              "last_heartbeat": "Último heartbeat",
              "last_run": "Última corrida",
              "latest": "Últimos",
              "latest_24h": "En últimas 24h:",
              "latest_24h_2": "Últimas 24h:",
              "latest_failures": "Últimos fallos",
              "message": "Mensaje",
              "next_run": "Próxima corrida",
              "no_available": "No disponible",
              "no_could_read_tables_solid": "No se pudo leer las tablas de Solid Queue",
              "no_executable_jobs": "No se encontraron jobs ejecutables.",
              "no_failed_executions": "No hay ejecuciones fallidas.",
              "no_pending_executions": "No hay ejecuciones pendientes.",
              "no_queue_data": "No hay datos de colas.",
              "no_recent_jobs": "No hay jobs recientes.",
              "no_recurring_tasks": "No hay tareas recurrentes.",
              "no_registered_processes": "No hay procesos registrados.",
              "operation": "Operación",
              "paused": "Pausada",
              "priority": "Prioridad",
              "process": "Proceso",
              "processes_queue": "Procesos de queue",
              "queue": "En cola",
              "queue_2": "Cola",
              "queued": "Encolado",
              "queues": "Colas",
              "recurrences": "Recurrencias",
              "run": "Ejecutar",
              "run_job": "Ejecutar job",
              "run_job_manually": "Ejecutar job manualmente",
              "running": "Corriendo",
              "schedule": "Programación",
              "scheduled": "Programado",
              "scheduled_2": "Programados",
              "scheduled_3": "Programados:",
              "select_job_available_app_jobs": "Selecciona un job disponible en `app/jobs`, opcionalmente define argumentos JSON y encola la ejecución.",
              "signature_perform": "Firma perform",
              "some_tables_no_available": "Algunas tablas no están disponibles",
              "status": "Estado",
              "status_queue": "Estado por cola",
              "table": "Tabla",
              "table_role_summary": "Resumen del rol de cada tabla según `db/queue_schema.rb`.",
              "tables_solid_queue": "Tablas de Solid Queue",
              "tasks_recurring": "Tareas recurrentes",
              "total_jobs": "Total de tareas",
              "update": "Actualizar",
              "usage_operational": "Uso operativo",
              "use_object_json_keyword_args": "Usa objeto JSON para keyword args o arreglo JSON para argumentos posicionales.",
              "view_operational_backlog_execution_pauses": "Vista operativa de backlog, ejecución y pausas.",
              "workers_active": "Workers activos:"
            }
          },
          "locations": {
            "edit": {
              "description": "Metadata global, estado, cuotas y las funciones que puede usar esta sucursal.",
              "detail_address": "Dirección",
              "detail_created_at": "Creada",
              "detail_id": "ID",
              "detail_organization": "Organización",
              "detail_status": "Estado",
              "detail_time_zone": "Zona horaria",
              "detail_updated_at": "Última actualización",
              "details_title": "Información de la sucursal",
              "feature_in_use": "En uso por el restaurante",
              "feature_not_in_use": "Apagada por el restaurante",
              "features_description": "Define qué funciones puede usar esta sucursal. El restaurante decide cuáles prende.",
              "features_granted_count": "%{granted} de %{total}",
              "form_title": "Información editable",
              "tab_details": "Detalles",
              "tab_features": "Funciones",
              "title": "Editar sucursal"
            },
            "form": {
              "cancel": "Cancelar",
              "name": "Nombre",
              "pickup_diner_fee_percentage": "Cuota de pickup al comensal (%)",
              "pickup_restaurant_fee_percentage": "Cuota de pickup al restaurante (%)",
              "save": "Guardar sucursal",
              "status": "Estado",
              "time_zone": "Zona horaria"
            },
            "index": {
              "actions": "Acciones",
              "created": "Creada",
              "delete": "Eliminar",
              "delete_description": "Esta acción oculta la sucursal del admin y conserva su historial operativo. No borra cuentas, mesas ni órdenes.",
              "delete_title": "Eliminar sucursal",
              "digital": "Digital",
              "edit": "Editar",
              "locations": "Sucursales",
              "name": "Nombre",
              "new_location": "Nueva sucursal",
              "offline": "Sin conexión",
              "pickup_fees": "Cuotas de pickup (comensal / restaurante)",
              "search_locations": "Buscar sucursales...",
              "showing": "Mostrando %{count} de %{total} sucursales",
              "staff": "Personal",
              "status": "Estado",
              "tables": "Mesas"
            },
            "new": {
              "description": "Crea el registro global de una sucursal. La asignación de gerentes y operación sigue viviendo en staff.",
              "title": "Nueva sucursal"
            }
          },
          "sign_in": {
            "index": {
              "continue_with_google": "Continuar con Google",
              "sign_in_with_google_description": "Inicia sesión en el panel de administración con tu cuenta de Google.",
              "welcome_new": "Bienvenido de nuevo"
            }
          },
          "system_status": {
            "index": {
              "booted_at": "Activo desde",
              "build_title": "Build",
              "databases_title": "Bases de datos",
              "description": "Versión desplegada y salud de los servicios.",
              "environment": "Entorno",
              "generated_at": "Actualizado",
              "latency": "Latencia",
              "migration": "Migración",
              "rails": "Rails",
              "refresh": "Refrescar",
              "revision": "Commit",
              "ruby": "Ruby",
              "status_down": "Caído",
              "status_unknown": "Desconocido",
              "status_up": "Operativo",
              "title": "Estado del sistema"
            }
          },
          "transactions": {
            "index": {
              "actions": "Acciones",
              "all": "Todos",
              "amount": "Monto",
              "created_at": "Fecha",
              "diner": "Comensal",
              "location": "Restaurante",
              "no_provider": "Nunca llegó a Stripe",
              "open": "Ver detalle",
              "payment_method": "Método",
              "provider": "Proveedor",
              "search": "Buscar por restaurante, comensal o id",
              "showing": "Mostrando %{count} de %{total} intentos de pago",
              "status": "Estado",
              "title": "Transacciones"
            },
            "show": {
              "amount_charged": "Monto cobrado",
              "application_fee": "Comisión de plataforma",
              "attempt": "Intento",
              "back": "Volver",
              "bill": "Cuenta",
              "bill_split": "División",
              "charge": "Charge",
              "checkout_expires_at": "El checkout expira",
              "checkout_session": "Checkout session",
              "completed_at": "Resuelto",
              "connected_account": "Cuenta conectada",
              "context": "Contexto",
              "created_at": "Creado",
              "diner": "Comensal",
              "diner_email": "Correo",
              "failure_title": "Este cobro falló",
              "idempotency_key": "Clave de idempotencia",
              "kind": "Tipo",
              "kind_orders": "Productos seleccionados",
              "kind_pickup": "Pedido para llevar",
              "kind_share": "Parte de una cuenta dividida",
              "location": "Restaurante",
              "no_orders": "Ninguna todavía",
              "no_provider": "Este intento nunca llegó a Stripe. Un cobro en efectivo o con terminal no lo hace nunca; uno digital que llegó acá se rechazó antes de abrir la sesión.",
              "payment_intent": "Payment intent",
              "payment_method": "Método de pago",
              "provider": "Stripe",
              "provider_completed_at": "Resuelto en Stripe",
              "provider_name": "Proveedor",
              "provider_raw_status": "Estado según Stripe",
              "provider_status": "Estado",
              "refund": "Refund",
              "selected_orders": "Órdenes cobradas",
              "snapshot": "Snapshot",
              "status": "Estado",
              "subtotal": "Subtotal",
              "tip": "Propina",
              "title": "Intento de pago",
              "total": "Total"
            }
          },
          "users": {
            "index": {
              "admin": "Administrador",
              "create_admin": "Crear administrador",
              "revoke": "Revocar acceso",
              "revoke_confirm": "¿Revocar el acceso de administrador de este usuario?",
              "search_users": "Buscar usuarios...",
              "users": "Usuarios"
            },
            "new": {
              "cancel": "Cancelar",
              "create": "Otorgar acceso",
              "description": "Ingresa el correo de Google de la persona. Podrá iniciar sesión con ese correo mediante Google.",
              "email": "Correo electrónico",
              "email_placeholder": "persona@ejemplo.com",
              "title": "Nuevo administrador"
            }
          }
        },
        "staff": {
          "location": {
            "bills": {
              "index": {
                "bill": "Cuenta",
                "bills": "Cuentas",
                "search_bill_status": "Buscar por cuenta o estado..."
              }
            },
            "dashboards": {
              "show": {
                "action_acknowledge": "Atendido",
                "action_open_table": "Ver mesa",
                "action_release": "Liberar",
                "attention_empty_hint": "El piso está al día. Cuando una mesa llame, un platillo se enfríe o un cobro se trabe, aparece aquí.",
                "attention_empty_title": "Nada pendiente",
                "attention_filtered_hint": {
                  "one": "Queda %{count} pendiente en otras categorías.",
                  "other": "Quedan %{count} pendientes en otras categorías."
                },
                "attention_filtered_title": "Nada en %{group}",
                "attention_subtitle": "Lo que necesita a una persona ahora, de lo más urgente a lo que puede esperar.",
                "attention_title": "Requieren atención",
                "collected_today": {
                  "one": "Cobrado hoy · %{count} cuenta",
                  "other": "Cobrado hoy · %{count} cuentas"
                },
                "dining_room": "Salón",
                "group_all": "Todo",
                "group_door": "Puerta",
                "group_payment": "Cobro",
                "group_service": "Servicio",
                "group_tables": "Mesas",
                "kitchen": "Cocina",
                "no_tables": "Sin mesas configuradas",
                "occupancy": "%{percent}% ocupado",
                "oldest_open_bill": "la más vieja abrió %{age}",
                "open_bills": {
                  "one": "%{count} cuenta abierta",
                  "other": "%{count} cuentas abiertas"
                },
                "overview": "Vista general de la sucursal",
                "pipeline_hint": "La edad es la de la comanda más antigua en cada etapa. Pasados %{minutes} minutos en Listas, la mesa entra a la lista de arriba.",
                "stage_empty": "sin cola",
                "stage_in_progress": "En preparación",
                "stage_oldest": "la más vieja, %{age}",
                "stage_pending": "Pendientes",
                "stage_ready": "Listas",
                "status_available": "Disponibles",
                "status_disabled": "Deshabilitadas",
                "status_occupied": "Ocupadas",
                "status_reserved": "Reservadas",
                "tables_count": {
                  "one": "%{count} mesa",
                  "other": "%{count} mesas"
                },
                "tips_today": "%{amount} en propinas",
                "title": "Actividad",
                "to_collect": "Por cobrar",
                "todays_till": "Caja del día",
                "view_bills": "Ver cuentas",
                "view_orders": "Ver comandas",
                "view_tables": "Ver mesas"
              }
            },
            "deliveries": {
              "index": {
                "assign_placeholder": "Asignar a",
                "deliver": "Entregó",
                "empty": "No hay entregas en curso.",
                "fail": "No se pudo",
                "fail_cancel": "Volver",
                "fail_confirm": "Marcar como fallida",
                "fail_description": "Elige el motivo. Queda en el historial y el repartidor vuelve a quedar disponible.",
                "fail_reason_label": "Motivo",
                "fail_reason_placeholder": "Elige un motivo",
                "fail_submitting": "Guardando...",
                "fail_title": "¿Qué pasó con la entrega?",
                "no_courier": "Nadie en turno",
                "page_description": "Lo que está en la calle ahora mismo.",
                "page_title": "Entregas",
                "pick_up": "Recogió",
                "row_meta": "Envío %{fee}",
                "row_meta_courier": "%{courier} · envío %{fee}",
                "title": "En reparto"
              }
            },
            "kds": {
              "show": {
                "advance_to_in_progress": "Empezar",
                "advance_to_ready": "Marcar listo",
                "degraded": "Sin conexión en vivo",
                "empty": "No hay nada pendiente en esta estación.",
                "late": "Tarde",
                "live": "En vivo",
                "minutes_waiting": "%{count} min esperando",
                "no_table": "Sin mesa",
                "ready": "Listo",
                "refreshed": "Actualizado",
                "station": "Estación",
                "title": "Estación",
                "undo": "Deshacer",
                "warning": "Demorado"
              }
            },
            "manage": {
              "billing": {
                "settings": {
                  "activation_hint": "Completa estos pasos para empezar a cobrar en línea.",
                  "activation_step_connected": "Stripe conectado",
                  "activation_step_methods": "Métodos de pago elegidos",
                  "activation_step_profile": "Perfil de negocio completo",
                  "activation_step_ready": "Listo para cobrar en línea",
                  "activation_title": "Activar cobros",
                  "address_stripe": "Dirección para Stripe",
                  "applies_payments_cash_terminal": "Se aplica a pagos en efectivo y terminal física.",
                  "back_to_summary": "Volver al resumen",
                  "bill_connected": "Cuenta conectada",
                  "business_description": "Descripción del negocio",
                  "cancel": "Cancelar",
                  "city": "Ciudad",
                  "code_postal": "Código postal",
                  "company": "Empresa",
                  "configuration_visible_payment_daily_location": "Configuración visible para el cobro diario del location.",
                  "confirmed_visible_methods": "Confirmé métodos diner-visibles antes de go-live",
                  "connect_stripe": "Conectar Stripe",
                  "continue_onboarding": "Continuar onboarding",
                  "country": "País",
                  "default_recommended_connect_zero_freezes": "Default recomendado para Connect: 1.00%. Se congela por intento de pago.",
                  "email": "Email",
                  "email_support": "Email de soporte",
                  "extra": "Complemento",
                  "field_required_continue_stripe": "Campo requerido para continuar con Stripe.",
                  "information_use_prefillear_stripe_connect": "Esta información se usa para prefillear Stripe Connect y reducir al máximo la captura manual.",
                  "last_name": "Apellido",
                  "legal_name": "Razón social / nombre legal",
                  "location_suspended_missing_payment": "La sucursal está suspendida por cuenta impaga. Ponte al corriente para desbloquearla.",
                  "max_22_characters_see": "Máximo 22 caracteres. Es lo que verá el cliente en el estado de cuenta.",
                  "method_cash_hint": "El cliente paga en efectivo directamente al personal.",
                  "method_digital_hint": "El cliente paga desde la app con su tarjeta.",
                  "method_terminal_hint": "Cobras con tu terminal de tarjeta física en el local.",
                  "methods_payment_enabled": "Métodos de cobro habilitados",
                  "name": "Nombre",
                  "name_business": "Nombre comercial",
                  "person_physical": "Persona física",
                  "phone": "Teléfono",
                  "phone_support": "Teléfono de soporte",
                  "profile_payment": "Perfil de cobro",
                  "refresh_status": "Actualizar estado",
                  "representative": "Representante",
                  "requires_stripe_connection": "Conecta Stripe para habilitar el pago digital.",
                  "restaurant_casual_mexican_consumption_table": "Restaurante casual mexicano con consumo en mesa.",
                  "restriction": "Restricción:",
                  "save_before_stripe": "Guarda este perfil antes de abrir Stripe para evitar capturar datos dos veces.",
                  "save_continue_stripe": "Guardar y continuar con Stripe",
                  "save_profile_payment_once_time": "Guarda el perfil de cobro una sola vez y deja a Stripe pedir solo lo que falte.",
                  "save_settings": "Guardar ajustes",
                  "settings_billing": "Ajustes de cobranza",
                  "site_web": "Sitio web",
                  "some_data_additional_completed_directly": "Algunos datos adicionales se completan directamente en Stripe durante el onboarding.",
                  "statement_descriptor": "Descriptor de extracto",
                  "status": "Estado",
                  "street_number": "Calle y número",
                  "subscription": {
                    "add_seat_cta": "Pagar esta sucursal",
                    "branches": "Desglose por sucursal",
                    "current_cta": "Activar suscripción",
                    "current_description": "Tu suscripción está al corriente.",
                    "delinquent_cta": "Reactivar suscripción",
                    "delinquent_description": "No pudimos cobrar tu suscripción y las sucursales dejaron de recibir comensales. Actualiza tu método de pago para reactivarlas.",
                    "last_charge": "Último cargo",
                    "paused_cta": "Activar suscripción",
                    "paused_description": "Tu suscripción está en pausa. Las sucursales siguen operando.",
                    "pending_cta": "Activar suscripción",
                    "pending_description": "Estamos esperando la confirmación de tu pago. En cuanto llegue, la sucursal abre sola.",
                    "renews_at": "Próxima renovación",
                    "title": "Suscripción a Menny",
                    "unbilled_cta": "Activar suscripción",
                    "unbilled_description": "Esta sucursal todavía no puede abrir. Activa la suscripción para ponerla en operación."
                  },
                  "support_phone_edit_link": "Editar en configuración operativa",
                  "support_phone_managed_operational": "El número de soporte se configura en la configuración operativa.",
                  "type_business": "Tipo de negocio",
                  "use_address_structured_text_free": "Usa dirección estructurada; el texto libre operativo no alcanza para prefillear bien el onboarding.",
                  "yes_company_use_data_prefillear": "Si es empresa, usamos estos datos para prefillear al representante. Si es persona física, aplican al titular."
                },
                "show": {
                  "alertas": "· Alertas",
                  "billing": "Cobranza y facturación",
                  "cash_terminal_physical": "Efectivo y terminal física.",
                  "confirmation_diner_visible": "Confirmación diner-visible",
                  "expires": "Vence",
                  "frozen_attempt_payment": "Congelada por intento de pago.",
                  "issued": "Emisión",
                  "latest_cycles_generated_location": "Últimos ciclos generados para la sucursal.",
                  "manage_settings": "Administrar ajustes",
                  "methods_enabled": "Métodos habilitados",
                  "methods_visible": "Métodos visibles",
                  "no_invoices": "Aún no hay facturas generadas.",
                  "pay_invoice": "Pagar ahora",
                  "pay_invoice_hint": "Te llevamos a la pasarela de Stripe para que pagues con la tarjeta que quieras.",
                  "payment_in_progress": "Cobro en curso",
                  "period": "Periodo",
                  "reminders": "· Recordatorios",
                  "settings": "Ajustes",
                  "signals_quick_operate_open_settings": "Señales rápidas para operar sin abrir ajustes.",
                  "status_financial_payment_location": "Estado financiero y de cobro de esta sucursal.",
                  "status_payment": "Estado de cobro"
                }
              },
              "business_hours": {
                "show": {
                  "back": "Sucursal",
                  "description": "Controla en qué horarios opera esta sucursal cada día.",
                  "disabled": "Deshabilitado",
                  "enabled": "Habilitado",
                  "title": "Horario de atención"
                }
              },
              "categories": {
                "edit": {
                  "back_menu": "Volver al menú",
                  "edit_category": "Editar categoría",
                  "name": "Nombre",
                  "starters": "Entradas",
                  "update_name_category": "Actualiza el nombre de la categoría."
                },
                "new": {
                  "cancel": "Cancelar",
                  "create_category": "Crear categoría",
                  "create_category_organize_items": "Crea una categoría para organizar tus productos.",
                  "name": "Nombre",
                  "new_category": "Nueva categoría",
                  "starters": "Entradas"
                }
              },
              "central_items": {
                "index": {
                  "add": "Agregar",
                  "empty": "Tu organización todavía no tiene platillos centrales. Agrega el primero y aparecerá en cada sucursal que lo adopte.",
                  "name_label": "Platillo",
                  "page_title": "Menú central",
                  "price_label": "Precio",
                  "reach": "Llega a %{following} sucursales",
                  "reach_with_overrides": "Llega a %{following} · %{overriding} con precio propio",
                  "remove": "Quitar %{name} del menú central",
                  "subtitle": "Lo que escribas aquí llega a %{branches} sucursales.",
                  "title": "Platillos de la organización"
                }
              },
              "channels": {
                "index": {
                  "all_healthy": "Todos los canales están respondiendo.",
                  "connect": "Conectar",
                  "connect_title": "Conectar un canal",
                  "credential_key_hint": "Es la referencia a la credencial, no la credencial. El token nunca se guarda aquí.",
                  "credential_key_label": "Referencia de credencial",
                  "disconnect": "Desconectar %{platform}",
                  "empty": "Todavía no conectas ningún canal.",
                  "healthy": "Al día",
                  "last_failure": "%{reason} · %{at}",
                  "last_sync": "Última señal %{at}",
                  "never_synced": "Nunca ha reportado. Todavía no sabemos si funciona.",
                  "not_in_reports": "Los pedidos de estos canales no aparecen en el mix de productos ni descuentan inventario, porque no generan líneas de comanda.",
                  "orders_title": "Pedidos de canales",
                  "page_description": "Uber Eats, Rappi y DiDi Food.",
                  "page_title": "Canales",
                  "platform_label": "Plataforma",
                  "store_id_label": "ID de tienda",
                  "title": "Estado de los canales",
                  "unhealthy": "Con problemas",
                  "unhealthy_count": "%{count} canal(es) con problemas",
                  "unknown_time": "sin fecha",
                  "unresolved": "%{count} pedido(s) sin resolver"
                }
              },
              "couriers": {
                "index": {
                  "add": "Agregar",
                  "available_count": "%{count} disponible(s) para tomar una entrega",
                  "couriers_title": "Repartidores",
                  "empty": "Todavía no agregas repartidores.",
                  "end_shift": "Terminar turno",
                  "name_label": "Nombre",
                  "page_description": "Tu propio equipo de reparto y las zonas que cubre.",
                  "page_title": "Repartidores",
                  "phone_label": "Teléfono",
                  "remove": "Eliminar a %{name}",
                  "start_shift": "Iniciar turno",
                  "zone_meta": "%{radius} m · envío %{fee} · mínimo %{minimum}",
                  "zones_empty": "Todavía no defines zonas. Sin zona no hay costo de envío calculado.",
                  "zones_subtitle": "Hasta dónde llegas y cuánto cobras",
                  "zones_title": "Zonas de reparto"
                }
              },
              "customers": {
                "index": {
                  "add": "Agregar",
                  "balance": "%{points} puntos",
                  "earn": "Acumular",
                  "empty": "Todavía no registras clientes.",
                  "ledger_empty": "Todavía no hay movimientos.",
                  "ledger_subtitle": "Lo último que se acumuló o se canjeó",
                  "ledger_title": "Movimientos de puntos",
                  "linked": "con cuenta",
                  "name_label": "Nombre",
                  "outstanding": "%{points} puntos pendientes de canjear",
                  "page_description": "Los clientes de este restaurante y los puntos que tienen aquí.",
                  "page_title": "Clientes",
                  "phone_label": "Teléfono",
                  "points_label": "Puntos para %{name}",
                  "points_placeholder": "Puntos",
                  "redeem": "Canjear",
                  "title": "Clientes"
                }
              },
              "dashboard": {
                "show": {
                  "created": "Creada:",
                  "customer": "Cliente",
                  "dashboard_management": "Dashboard de gestión",
                  "distribution_current_tables": "Distribución actual de mesas.",
                  "latest_orders_active_registered": "Últimas comandas activas registradas.",
                  "load_station": "Carga por estación",
                  "no_recent_active_orders": "No hay comandas activas recientes.",
                  "orders_active_assigned_station": "Comandas activas asignadas por estación.",
                  "orders_recent": "Comandas recientes",
                  "orders_status": "Comandas por estado",
                  "status_current_flow_operational": "Estado actual del flujo operativo.",
                  "tables_status": "Mesas por estado",
                  "visibility_quick_operation_restaurant": "Visibilidad rápida de la operación del restaurante."
                }
              },
              "events": {
                "index": {
                  "events_location": "Eventos de la sucursal",
                  "header_date": "Fecha",
                  "header_event": "Evento",
                  "header_id": "ID",
                  "showing_events": "Mostrando %{count} de %{total} eventos (más recientes primero)"
                }
              },
              "items": {
                "edit": {
                  "cancel": "Cancelar",
                  "category": "Categoría",
                  "category_2": "Sin categoría",
                  "currency": "Moneda",
                  "description": "Descripción",
                  "edit_item": "Editar producto",
                  "item_parent": "Sin producto padre",
                  "item_parent_modifier": "Producto padre (modificador)",
                  "name": "Nombre",
                  "photo_item": "Foto del producto",
                  "price": "Precio",
                  "save_changes": "Guardar cambios",
                  "station_primary": "Estación principal",
                  "status": "Estado",
                  "taco_pastor": "Taco al pastor",
                  "tortilla_corn_meat_marinada_pineapple": "Tortilla de maíz con carne marinada y piña",
                  "update_information_item": "Actualiza la información del producto.",
                  "view_preview_item": "Vista previa del producto"
                },
                "new": {
                  "cancel": "Cancelar",
                  "category": "Categoría",
                  "category_2": "Sin categoría",
                  "create_item": "Crear producto",
                  "create_item_menu": "Crea un producto para el menú de la sucursal actual.",
                  "currency": "Moneda",
                  "description": "Descripción",
                  "emoji": "Emoji",
                  "emoji_hint": "Se muestra en el menú del comensal cuando el producto no tiene foto.",
                  "extra_groups": "Grupos de extras",
                  "name": "Nombre",
                  "new_item": "Nuevo producto",
                  "photo_item": "Foto del producto",
                  "price": "Precio",
                  "station_primary": "Estación principal",
                  "status": "Estado",
                  "taco_pastor": "Taco al pastor",
                  "tortilla_corn_meat_marinada_pineapple": "Tortilla de maíz con carne marinada y piña",
                  "view_preview_item": "Vista previa del producto"
                },
                "show": {
                  "action_delete_item_menu_can": "Esta acción eliminará el producto del menú. Puedes continuar o cancelar.",
                  "back_menu": "Volver al menú",
                  "cancel": "Cancelar",
                  "category": "Categoría",
                  "delete": "Eliminar",
                  "delete_item": "Eliminar producto",
                  "description": "Descripción",
                  "detail_item_menu": "Detalle del producto del menú.",
                  "edit": "Editar",
                  "image": "Sin imagen",
                  "item_parent": "Producto padre",
                  "price": "Precio",
                  "station": "Estación",
                  "status": "Estado"
                }
              },
              "location": {
                "sections": {
                  "address": "Dirección",
                  "address_line1": "Calle y número",
                  "address_line1_placeholder": "Av. Álvaro Obregón 123",
                  "address_line2": "Interior o referencia",
                  "address_line2_placeholder": "Piso 2, local B",
                  "all_ready_launch": "Todo listo para lanzar.",
                  "avenue_juarez_cdmx": "Av. Juárez 123, CDMX",
                  "billing_separate_operations": "La cobranza y facturación se administran aparte para no mezclar operación con finanzas.",
                  "business_hours": "Horario de atención",
                  "business_hours_description": "Horario semanal estructurado de esta sucursal.",
                  "business_hours_disabled": "Deshabilitado",
                  "business_hours_enabled": "Habilitado",
                  "checklist_launch": "Checklist de salida",
                  "city": "Ciudad",
                  "city_placeholder": "Ciudad de México",
                  "configuration_operational": "Configuración operativa",
                  "configure_business_hours": "Configurar",
                  "coordinates": "Coordenadas",
                  "coordinates_hint": "Ubicación exacta para búsquedas por cercanía. Opcional.",
                  "country": "País",
                  "country_placeholder": "MX",
                  "define_data_operational_minimum_launch": "Define los datos operativos mínimos para salir a producción.",
                  "description": "Descripción",
                  "description_hint": "Aparece en la página pública de tu menú y ayuda a que te encuentren en Google. Opcional.",
                  "description_placeholder": "Cuéntales a tus comensales qué hace especial a tu restaurante.",
                  "directory_profile_description": "Estos datos aparecen cuando los comensales buscan tu restaurante para recoger.",
                  "directory_profile_title": "Perfil del directorio",
                  "feature_blocked_missing_slug": "Elige la dirección de tu menú más abajo para empezar a recibir pedidos para llevar.",
                  "features_description": "Prende o apaga lo que tu restaurante le ofrece a los comensales.",
                  "features_empty": "Todavía no hay funciones disponibles para tu restaurante.",
                  "features_title": "Funciones",
                  "go_billing": "Ir a cobranza",
                  "last_launch": "Último lanzamiento:",
                  "latitude": "Latitud",
                  "launch_location": "Lanzar sucursal",
                  "logo": "Logo",
                  "logo_hint": "Se muestra en el directorio público. PNG, JPG o WEBP.",
                  "logo_updated": "Logo actualizado.",
                  "longitude": "Longitud",
                  "postal_code": "Código postal",
                  "postal_code_placeholder": "06700",
                  "preview_label": "Así te ven tus comensales",
                  "preview_no_description": "Sin descripción todavía — solo van a ver el nombre y la dirección.",
                  "public_menu_description": "La versión de tu menú que cualquier persona puede ver en internet, sin iniciar sesión.",
                  "public_menu_slug_change_confirm": "Cambiar dirección",
                  "public_menu_slug_change_description": "La dirección anterior va a seguir llevando a tu menú, así que ningún enlace que ya compartiste se rompe. A partir de ahora, comparte la nueva.",
                  "public_menu_slug_change_title": "¿Cambiar la dirección de tu menú?",
                  "public_menu_slug_label": "Dirección de tu menú",
                  "public_menu_state_pending": "Pendiente",
                  "public_menu_state_published": "Publicado",
                  "public_menu_state_unpublished": "Sin publicar",
                  "public_menu_switch_description": "Muestra tu menú en la dirección de abajo. Actívalo cuando quieras que la gente lo vea.",
                  "public_menu_switch_label": "Publicar menú",
                  "public_menu_title": "Menú público",
                  "public_menu_url_empty": "Elige una dirección para tu menú público.",
                  "save_configuration": "Guardar configuración",
                  "save_logo": "Guardar logo",
                  "state": "Estado",
                  "state_placeholder": "CDMX",
                  "support_phone": "Número de soporte",
                  "support_phone_hint": "Aparece en la página pública de tu menú y es el teléfono que verán tus comensales; también lo usamos como número de soporte en Stripe.",
                  "support_phone_placeholder": "+52 55 1234 5678",
                  "taxes_description": "El régimen bajo el que operas y las tasas que se desglosan en el recibo de tus comensales.",
                  "taxes_empty_note": "Sin tasas configuradas no desglosas ningún impuesto.",
                  "taxes_prices_included": "Tus precios de menú ya incluyen el impuesto. Desglosarlo no cambia lo que paga tu comensal: el total es el mismo y el recibo solo muestra cuánto de ese total es impuesto.",
                  "taxes_rate_missing_name": "Ponle nombre a esta tasa o no se va a guardar.",
                  "taxes_rate_name": "Nombre",
                  "taxes_rate_name_placeholder": "IVA",
                  "taxes_rate_percentage": "Porcentaje",
                  "taxes_rate_percentage_placeholder": "16",
                  "taxes_rates_hint": "El nombre es lo que tu comensal lee en el recibo. Deja los dos campos vacíos para quitar una tasa.",
                  "taxes_rates_label": "Tasas",
                  "taxes_regime_label": "Régimen",
                  "taxes_submit": "Guardar impuestos",
                  "taxes_title": "Impuestos",
                  "tips_description": "Los porcentajes que le sugieres a tus comensales, y cómo se reparte lo que dejan.",
                  "tips_distribution_hint": "Tiene que sumar 100%%. El sistema calcula y reporta; la política es tuya.",
                  "tips_distribution_invalid": "Los dos valores tienen que sumar 100%%.",
                  "tips_distribution_label": "Reparto",
                  "tips_distribution_shared": "Compartido",
                  "tips_distribution_shared_hint": "Barra, cocina, cajeros y host.",
                  "tips_distribution_waiters": "Meseros",
                  "tips_preview_label": "Tus comensales van a ver",
                  "tips_submit": "Guardar propinas",
                  "tips_suggestions_hint": "Deja un campo vacío para quitar esa sugerencia.",
                  "tips_suggestions_label": "Porcentajes sugeridos",
                  "tips_title": "Propinas",
                  "tips_zero_note": "El 0%% siempre aparece y no se puede quitar. La propina es voluntaria.",
                  "view_status_billing": "Ver estado de cobranza"
                },
                "show": {
                  "closed_now": "Cerrada",
                  "coordinates_present": "Definidas",
                  "copied": "Enlace copiado.",
                  "copy": "Copiar",
                  "edit": "Editar",
                  "edit_branch": "Editar sucursal",
                  "features_disabled": "Apagadas · %{count}",
                  "features_empty": "Todavía no hay funciones disponibles para tu restaurante.",
                  "features_enabled": "Activas · %{count}",
                  "hours_closed": "Cerrado",
                  "hours_disabled_note": "El horario está deshabilitado, así que se pueden hacer pedidos a cualquier hora.",
                  "hours_empty": "Todavía no defines el horario de esta sucursal.",
                  "logo_missing": "Sin subir",
                  "logo_present": "Cargado",
                  "no_description": "Todavía no le cuentas nada a tus comensales sobre tu restaurante.",
                  "no_schedule": "Sin horario",
                  "not_set": "Sin definir",
                  "open_now": "Abierta ahora",
                  "opens_at": "Abre %{when}",
                  "page_description": "Cómo está configurada esta sucursal hoy.",
                  "page_title": "Sucursal",
                  "profile_address": "Dirección",
                  "profile_city": "Ciudad",
                  "profile_coordinates": "Coordenadas",
                  "profile_description": "Descripción",
                  "profile_logo": "Logo",
                  "profile_phone": "Teléfono",
                  "profile_title": "Perfil",
                  "public_menu_no_slug": "Todavía no eliges la dirección de tu menú.",
                  "public_menu_pending": "Pendiente",
                  "public_menu_published": "Publicado",
                  "public_menu_unpublished": "Sin publicar",
                  "public_menu_view": "Ver menú",
                  "suspended": "Esta sucursal está suspendida operativamente. Los comensales no pueden pedir.",
                  "taxes_added": "El impuesto se suma a tus precios de menú.",
                  "taxes_configure": "Configurar tasas",
                  "taxes_included": "Tus precios de menú ya incluyen el impuesto.",
                  "taxes_none": "Sin tasas configuradas",
                  "taxes_none_hint": "Sin tasas no desglosas ningún impuesto: el total que paga tu comensal no cambia, pero el recibo no dice cuánto de ese total es impuesto.",
                  "tips_diner_sees": "Lo que ve tu comensal al pagar",
                  "tips_no_tip": "Sin propina",
                  "tips_shared": "Compartido",
                  "tips_waiters": "Meseros"
                }
              },
              "menu": {
                "index": {
                  "actions_category": "Acciones de categoría",
                  "add_category": "Agregar categoría",
                  "add_category_placeholder": "Nueva categoría",
                  "add_extra": "Agregar extra",
                  "add_extra_group": "Nuevo grupo",
                  "add_item": "Agregar producto",
                  "all_products": "Todos",
                  "categories_items_organized_section": "Organiza tu carta por categorías y productos.",
                  "categories_title": "Categorías",
                  "category_emoji": "Emoji de categoría",
                  "create_extra_group": "Crear grupo",
                  "delete_category": "Eliminar categoría",
                  "delete_extra": "Eliminar extra",
                  "delete_extra_confirm": "Se eliminará este extra del grupo. Puedes continuar o cancelar.",
                  "delete_extra_group": "Eliminar grupo",
                  "delete_extra_group_confirm": "Se eliminará este grupo y sus extras. Puedes continuar o cancelar.",
                  "delete_item": "Eliminar producto",
                  "delete_item_confirm": "Se eliminará este producto del menú. Puedes continuar o cancelar.",
                  "dish_count_one": "%{count} platillo",
                  "dish_count_other": "%{count} platillos",
                  "edit_category": "Editar categoría",
                  "edit_extra_group_title": "Editar grupo",
                  "edit_item": "Editar producto",
                  "edit_item_title": "Editar producto",
                  "empty_category": "Esta categoría no tiene productos todavía. Agrega el primero.",
                  "extra_group_max_select": "Selecciones máximas (vacío = sin límite)",
                  "extra_group_min_select": "Selecciones mínimas",
                  "extra_group_min_select_warning": "Un mínimo de %{min} requiere al menos esa cantidad de extras activos — este grupo tiene %{count}. Los comensales verán los ítems como no disponibles hasta que agregues más.",
                  "extra_group_name": "Nombre",
                  "extra_group_no_selection": "Ninguno",
                  "extra_group_status": "Estado",
                  "extra_group_status_active": "Activo",
                  "extra_group_status_inactive": "Inactivo",
                  "extra_name_placeholder": "p. ej. Salsa verde",
                  "extra_price": "Precio",
                  "extras_description": "Grupos de extras que los clientes pueden agregar a los productos (p. ej. salsas, queso, toppings).",
                  "extras_title": "Extras",
                  "filter_sold_out": "Agotados",
                  "filter_without_description": "Sin descripción",
                  "filter_without_photo": "Sin foto",
                  "item_created": "Producto creado.",
                  "item_updated": "Producto actualizado.",
                  "jump_to_new_category": "Nueva categoría",
                  "management_menu": "Gestión de menú",
                  "no_category": "Sin categoría",
                  "no_extra_groups_yet": "Aún no hay grupos de extras. Crea el primero para empezar a ofrecer extras.",
                  "no_extras_yet": "Aún no hay extras.",
                  "no_menu_items": "No hay productos en el menú. Crea una categoría o agrega un producto para comenzar.",
                  "no_results_hint": "Ajusta la búsqueda o elige otra categoría.",
                  "no_results_title": "Sin resultados",
                  "rename_category": "Renombrar categoría",
                  "search_placeholder": "Buscar platillo o categoría",
                  "sold_out_count_one": "%{count} agotado",
                  "sold_out_count_other": "%{count} agotados"
                }
              },
              "promotions": {
                "index": {
                  "description": "Reglas de precio que el sistema aplica solo, y los códigos que las disparan.",
                  "title": "Promociones y cupones"
                }
              },
              "purchases": {
                "index": {
                  "description": "Lo que le pediste a tus proveedores. El inventario se mueve cuando recibes.",
                  "title": "Compras"
                },
                "new": {
                  "description": "Captura los insumos como te los facturaron. Las cantidades van en la unidad de cada insumo.",
                  "title": "Nueva compra"
                }
              },
              "recipes": {
                "index": {
                  "description": "Cuánto insumo lleva cada platillo y cada extra. Sin esto nadie descuenta el inventario.",
                  "title": "Recetas"
                }
              },
              "suppliers": {
                "index": {
                  "description": "A quién le compras. Un proveedor que ya surtió algo se desactiva, no se borra.",
                  "title": "Proveedores"
                }
              },
              "supplies": {
                "index": {
                  "description": "Lo que la cocina consume, cuánto hay y qué lo movió.",
                  "title": "Inventario"
                },
                "show": {
                  "description": "Todo lo que movió la existencia de este insumo, con su motivo y quién lo registró."
                }
              },
              "tables": {
                "edit": {
                  "back_tables": "Volver a mesas",
                  "edit_table": "Editar mesa",
                  "name": "Nombre",
                  "seats": "Asientos",
                  "table": "Mesa 1",
                  "update_configuration_table": "Actualiza la configuración de la mesa."
                },
                "index": {
                  "add_table": "Agregar mesa",
                  "invite": "Invitación",
                  "manage_tables_available_restaurant": "Administra las mesas disponibles de tu restaurante.",
                  "management_tables": "Gestión de mesas",
                  "no_tables": "No hay mesas registradas. Crea una mesa para comenzar.",
                  "printed_qr": "QR impreso",
                  "seats": "Asientos",
                  "table_restaurant": "Mesa de restaurante",
                  "tap_view_detail_table": "Toca para ver el detalle de la mesa"
                },
                "new": {
                  "cancel": "Cancelar",
                  "create_table": "Crear mesa",
                  "name": "Nombre",
                  "new_table": "Nueva mesa",
                  "register_table_location_current": "Registra una mesa para la sucursal actual.",
                  "seats": "Asientos",
                  "status": "Estado",
                  "table": "Mesa 1"
                },
                "show": {
                  "action_delete_table_location": "Esta acción eliminará la mesa de la sucursal actual. Puedes continuar o cancelar.",
                  "back_tables": "Volver a mesas",
                  "bills_active": "Cuentas activas",
                  "cancel": "Cancelar",
                  "delete": "Eliminar",
                  "delete_table": "Eliminar mesa",
                  "detail_operational_table": "Detalle operativo de la mesa",
                  "download_qr": "Descargar QR",
                  "download_qr_failed": "No pudimos generar la imagen. Recarga la pantalla e intenta de nuevo.",
                  "download_qr_jpg": "JPG",
                  "download_qr_png": "PNG",
                  "download_qr_svg": "SVG (vectorial, para imprimir a cualquier tamaño)",
                  "edit": "Editar",
                  "expires": "Expira",
                  "generate_invite": "Generar invitación",
                  "generate_printed_qr": "Generar QR impreso",
                  "invite_dynamic": "Invitación dinámica",
                  "manage_access_qr_temporary_table": "Gestiona el acceso QR temporal para esta mesa.",
                  "no_active_invite": "No hay una invitación activa para esta mesa.",
                  "no_printed_qr": "Esta mesa todavía no tiene un QR impreso.",
                  "printed_qr": "QR impreso de la mesa",
                  "printed_qr_help": "Descárgalo, imprímelo y pégalo en la mesa. No caduca: sirve hasta que lo revoques.",
                  "reuse_invite": "Reutilizar invitación",
                  "revoke_invite": "Revocar invitación",
                  "revoke_printed_qr": "Revocar QR impreso",
                  "revoke_printed_qr_warning": "Al revocarlo, el papel que está en la mesa deja de funcionar. Vas a tener que imprimir uno nuevo.",
                  "seats": "Asientos",
                  "status": "Estado",
                  "table_restaurant": "Mesa de restaurante",
                  "url_active": "URL activa",
                  "uses": "Usos"
                }
              },
              "tax_profile": {
                "show": {
                  "badge_incomplete": "Falta información",
                  "badge_ready": "Listo para facturar",
                  "defaults_description": "Opcionales. Son respuestas de tu contador y viajan en cada factura.",
                  "defaults_title": "Valores por omisión",
                  "description": "Con qué RFC emite facturas tu restaurante y con qué proveedor las timbra.",
                  "empty_notice": "Todavía no cargas tus datos fiscales. Sin ellos no se puede emitir ninguna factura.",
                  "identity_description": "Tal como aparece en tu constancia de situación fiscal. Si algo no coincide, el SAT rechaza la factura.",
                  "identity_title": "Identidad fiscal",
                  "legal_name_hint": "Sin el régimen de capital. En CFDI 4.0 va sin S.A. de C.V.",
                  "legal_name_label": "Razón social",
                  "pac_description": "Menny nunca guarda tu certificado de sello. El sello lo pone tu PAC, así que aquí solo va la llave con la que lo contactamos.",
                  "pac_environment_hint": "Deja pruebas hasta que tu contador confirme los datos.",
                  "pac_environment_label": "Ambiente",
                  "pac_key_configured": "Llave configurada",
                  "pac_key_hint": "Se guarda cifrada y no la volvemos a mostrar. Si lo dejas vacío, la llave actual no se toca.",
                  "pac_key_label": "Llave del PAC",
                  "pac_key_missing": "Sin llave todavía, así que no se puede timbrar.",
                  "pac_key_placeholder_configured": "Déjalo vacío para conservar la llave que ya guardaste",
                  "pac_key_placeholder_empty": "Pega la llave que te dio tu proveedor",
                  "pac_provider_label": "Proveedor",
                  "pac_provider_note": "Hoy solo está el proveedor simulado, para que pruebes el flujo completo sin gastar timbres.",
                  "pac_title": "Proveedor de timbrado",
                  "postal_code_hint": "El de tu domicilio fiscal. Es el lugar de expedición de cada factura.",
                  "postal_code_label": "Código postal",
                  "product_code_hint": "ClaveProdServ. Sin ella usamos 01010101, la clave genérica del SAT.",
                  "product_code_label": "Clave de producto o servicio",
                  "rfc_hint": "12 caracteres si eres persona moral, 13 si eres persona física.",
                  "rfc_label": "RFC",
                  "series_hint": "Tu propia numeración, si usas una.",
                  "series_label": "Serie",
                  "submit": "Guardar datos fiscales",
                  "submitting": "Guardando…",
                  "tax_regime_label": "Régimen fiscal",
                  "tax_regime_placeholder": "Elige tu régimen",
                  "title": "Datos fiscales",
                  "unit_code_hint": "ClaveUnidad. Sin ella usamos ACT, la unidad genérica del SAT.",
                  "unit_code_label": "Clave de unidad"
                }
              },
              "users": {
                "edit": {
                  "edit_staff_member": "Editar miembro del personal",
                  "update_identity_role_credentials_staff": "Actualiza identidad, rol y credenciales del colaborador."
                },
                "index": {
                  "action_remove_access_staff_member": "Esta acción quitará el acceso del colaborador a la sucursal actual.",
                  "actions": "Acciones",
                  "active_access_description": "Cada registro representa un acceso activo a esta sucursal.",
                  "add_staff": "Agregar personal",
                  "cancel": "Cancelar",
                  "delete": "Eliminar",
                  "delete_staff_member": "Eliminar miembro del personal",
                  "edit": "Editar",
                  "email": "Correo",
                  "manage_staff_members_assigned_location": "Administra colaboradores asignados a la sucursal actual.",
                  "name": "Nombre",
                  "no_users": "No hay usuarios asignados. Agrega el primer miembro del personal para comenzar.",
                  "role": "Rol",
                  "staff": "Personal",
                  "team_current": "Equipo actual"
                },
                "new": {
                  "create_access_staff_location_current": "Crea un acceso staff para la sucursal actual.",
                  "new_bill_staff": "Nueva cuenta de personal"
                }
              }
            },
            "organization": {
              "branches": {
                "page_title": "Sucursales"
              },
              "members": {
                "page_title": "Miembros"
              },
              "nav": {
                "branches": "Sucursales",
                "label": "Secciones de la organización",
                "members": "Miembros",
                "overview": "Vista general",
                "settings": "Datos de la organización"
              },
              "settings": {
                "address_title": "Dirección",
                "contact_title": "Contacto",
                "fields": {
                  "address_line1": "Calle y número",
                  "address_line2": "Interior, colonia",
                  "city": "Ciudad",
                  "country": "País",
                  "legal_business_name": "Razón social",
                  "name": "Nombre de la organización",
                  "postal_code": "Código postal",
                  "rfc": "RFC",
                  "state": "Estado",
                  "support_email": "Correo de contacto",
                  "support_phone": "Teléfono de contacto",
                  "tax_regime": "Régimen fiscal"
                },
                "fiscal_note": "Estos datos identifican a la organización. No se usan para timbrar: cada sucursal timbra con su propio RFC, que se configura en su pantalla de datos fiscales.",
                "fiscal_title": "Datos fiscales",
                "identity_title": "Identidad",
                "page_title": "Datos de la organización",
                "save": "Guardar cambios",
                "tax_regime_placeholder": "Elige un régimen"
              },
              "show": {
                "average_hint": "Contra esto se mide el índice de cada sucursal.",
                "average_label": "Promedio por sucursal",
                "branches_label": "Sucursales",
                "branches_title": "Sucursal por sucursal",
                "consolidated_label": "Consolidado",
                "current_branch": "aquí estás",
                "did_not_trade": "No abrió en el periodo",
                "index_value": "%{index}x el promedio",
                "members": {
                  "email_label": "Correo electrónico",
                  "email_placeholder": "socio@ejemplo.com",
                  "expires_on": "Vence el %{date}",
                  "invite": "Invitar",
                  "pending_title": "Invitaciones pendientes",
                  "revoke": "Cancelar la invitación de %{email}",
                  "role_label": "Acceso",
                  "title": "Miembros de la organización",
                  "you": "tú"
                },
                "not_comparable": "Todavía no hay con qué comparar. Cuando dos o más sucursales vendan en el periodo, aquí ves cómo se comparan entre sí.",
                "page_title": "Vista general",
                "roster": {
                  "add_branch": "Nueva sucursal",
                  "branch_count": {
                    "one": "%{count} sucursal",
                    "other": "%{count} sucursales"
                  },
                  "current": "aquí estás",
                  "member_count": {
                    "one": "%{count} miembro",
                    "other": "%{count} miembros"
                  },
                  "open": "Abrir",
                  "staff_count": {
                    "one": "%{count} en el equipo",
                    "other": "%{count} en el equipo"
                  },
                  "title": "Sucursales de la organización"
                },
                "row_meta": "%{transactions} cobros · %{shifts} turnos",
                "title": "Comparativo de la organización",
                "to_branch_report": "Ver el reporte de esta sucursal"
              }
            },
            "reports": {
              "show": {
                "actor_unknown": "Sin registrar",
                "average_per_shift_label": "Promedio por turno",
                "average_ticket_label": "Ticket promedio",
                "bill_cancellations_title": "Cuentas canceladas",
                "busiest_hour_label": "Hora pico",
                "by_day_chart_label": "Ventas por día de servicio",
                "by_day_title": "Por día",
                "by_hour_chart_label": "Ventas por hora del reloj del restaurante",
                "by_hour_hint": "Son las horas del reloj de tu restaurante.",
                "by_hour_title": "Por hora",
                "by_method_title": "Por método de pago",
                "cancellations_count_label": "Cancelaciones",
                "cancellations_system_hint": "Líneas que quedaron pendientes al cerrar la cuenta. No las canceló nadie.",
                "cancellations_system_label": "Del sistema",
                "cancellations_value_hint": "A precio de menú.",
                "cancellations_value_label": "Valor cancelado",
                "capture_items_count": {
                  "one": "%{count} pieza",
                  "other": "%{count} piezas"
                },
                "capture_role_unknown": "Sin rol",
                "capture_self_service_meta": {
                  "one": "%{count} comensal",
                  "other": "%{count} comensales"
                },
                "capture_title": "Capturado por",
                "chart_amount_column": "Ventas",
                "chart_bucket_column": "Periodo",
                "chart_hour_column": "Hora",
                "chart_transactions_column": "Cobros",
                "comparison_absent": "No hay un periodo anterior con el cual comparar.",
                "comparison_basis_average": "por turno, contra el periodo anterior",
                "comparison_basis_total": "contra el periodo anterior",
                "comparison_current": "Ahora %{amount} · %{shifts}",
                "comparison_new": "Nuevo",
                "comparison_previous": "Antes %{amount} · %{shifts}",
                "control_clean": "Sin descuentos, cancelaciones, reembolsos ni reaperturas en este periodo.",
                "control_scope": "Todo lo que movió dinero sin ser una venta, con quién lo autorizó y por qué.",
                "control_title": "Control",
                "description": "Ventas, mix de productos y control del periodo.",
                "discounts_count_label": "Movimientos",
                "discounts_non_revenue_hint": "No cuentan como venta.",
                "discounts_non_revenue_label": "Cortesías",
                "discounts_revenue_label": "Descuentos",
                "discounts_title": "Descuentos y cortesías",
                "empty_never_body": "El reporte se arma con los cortes de caja. En cuanto cierres tu primer turno vas a ver aquí las ventas del periodo.",
                "empty_never_title": "Todavía no hay nada que reportar",
                "empty_period_body": "El reporte se arma con los cortes de caja cerrados. Prueba con otro periodo.",
                "empty_period_title": "No hay cortes en este periodo",
                "events_count": {
                  "one": "%{count} vez",
                  "other": "%{count} veces"
                },
                "mix_class_a": "A",
                "mix_class_b": "B",
                "mix_class_c": "C",
                "mix_cost_coverage": "Costo conocido en %{costed} de %{total} piezas.",
                "mix_item_margin": "Margen %{margin}",
                "mix_item_margin_unknown": "Sin receta, todavía no hay costo",
                "mix_item_meta": "Clase %{abc} · %{share} del valor",
                "mix_items_label": "Platillos distintos",
                "mix_margin_hint": "Costo de insumos %{ratio}",
                "mix_margin_label": "Margen",
                "mix_quantity_count": {
                  "one": "%{count} pieza",
                  "other": "%{count} piezas"
                },
                "mix_quantity_label": "Piezas vendidas",
                "mix_show_all": {
                  "one": "Ver %{count} platillo más",
                  "other": "Ver %{count} platillos más"
                },
                "mix_title": "Mix de productos",
                "mix_value_hint": "No es un total de ventas.",
                "mix_value_label": "Valor de los platillos",
                "order_cancellations_title": "Líneas canceladas",
                "orders_count": {
                  "one": "%{count} comanda",
                  "other": "%{count} comandas"
                },
                "refund_rail_drawer": "Efectivo del cajón",
                "refund_rail_provider": "Reversa del proveedor",
                "refunds_count_label": "Reembolsos",
                "refunds_drawer_label": "Del cajón",
                "refunds_provider_label": "Por la terminal",
                "refunds_title": "Reembolsos",
                "reopenings_hint": "Reabrir una cuenta cerrada no mueve dinero por sí solo: quita el candado que impide moverlo.",
                "reopenings_title": "Cuentas reabiertas",
                "sales_scope": "Es la suma exacta de los cortes de caja del periodo. Cubre salón, para llevar y pickup; no incluye canales externos.",
                "sales_title": "Ventas del periodo",
                "sales_total_label": "Ventas",
                "series_best_label": "Mejor día",
                "series_worst_label": "Día más flojo",
                "shift_count": {
                  "one": "%{count} turno",
                  "other": "%{count} turnos"
                },
                "shifts_label": "Turnos",
                "tips_hint": "No son parte de las ventas.",
                "tips_label": "Propinas",
                "transactions_count": {
                  "one": "%{count} cobro",
                  "other": "%{count} cobros"
                },
                "transactions_label": "Cobros"
              }
            },
            "reservations": {
              "index": {
                "add": "Apartar",
                "cancel": "Cancelar",
                "cancel_back": "Volver",
                "cancel_confirm": "Cancelar reserva",
                "cancel_description": "La mesa queda libre a esa hora en cuanto canceles.",
                "cancel_reason_label": "Motivo",
                "cancel_reason_placeholder": "Elige un motivo",
                "cancel_submitting": "Guardando...",
                "cancel_title": "Cancelar la reserva",
                "day_label": "Día",
                "empty": "No hay reservas para este día.",
                "ends_label": "Hasta",
                "guest_label": "A nombre de",
                "holding_count": "%{count} reserva(s) apartando mesa",
                "no_table": "Sin mesa",
                "page_description": "Quién viene hoy y en qué mesa.",
                "page_title": "Reservas",
                "party_label": "Personas",
                "reason_cannot_host": "No podemos recibirlos",
                "reason_guest_called": "El cliente canceló",
                "reason_no_show": "No llegó",
                "row_meta": "%{time} · %{party} personas",
                "seat": "Sentar",
                "starts_label": "Desde",
                "table_label": "Mesa",
                "title": "El libro"
              }
            },
            "shifts": {
              "show": {
                "amount_label": "Monto",
                "blocking_bills": {
                  "one": "Hay %{count} cuenta sin liquidar. Cóbrala antes de cerrar la caja.",
                  "other": "Hay %{count} cuentas sin liquidar. Cóbralas antes de cerrar la caja."
                },
                "cancellations_bills": "Cuentas canceladas",
                "cancellations_count": {
                  "one": "%{count} cancelación",
                  "other": "%{count} cancelaciones"
                },
                "cancellations_orders": "Productos cancelados",
                "cancellations_title": "Cancelaciones",
                "cancellations_total": "Valor cancelado",
                "cash_sales": "Ventas en efectivo",
                "close_cancel": "Cancelar",
                "close_confirm": "Confirmar cierre",
                "close_description": "El cierre es definitivo: este turno no se vuelve a abrir y los cobros en efectivo y con terminal quedan bloqueados hasta que abras uno nuevo.",
                "close_open": "Cerrar caja",
                "close_title": "Cerrar la caja",
                "closed_body": "Los cobros en efectivo y con terminal necesitan un turno abierto. Los pagos que tus clientes hacen desde el QR siguen entrando y quedan registrados fuera de turno.",
                "closed_by": "Cerró %{name} el %{time}.",
                "closed_title": "La caja está cerrada",
                "declared_hint": "Cuenta el cajón completo antes de confirmar.",
                "declared_label": "Efectivo contado",
                "description": "Controla el efectivo del turno y saca el corte.",
                "difference_balanced": "Cuadra",
                "difference_label": "Diferencia",
                "difference_over": "Sobra",
                "difference_pending": "Escribe el efectivo contado para verla.",
                "difference_short": "Falta",
                "discounts_count": {
                  "one": "%{count} descuento",
                  "other": "%{count} descuentos"
                },
                "discounts_hint": "Estos montos ya vienen restados de los cobros de arriba. Aquí solo se nombran para que sepas de dónde salieron.",
                "discounts_non_revenue": "Cortesías y consumo interno",
                "discounts_revenue": "Descuentos sobre venta",
                "discounts_title": "Descuentos y cortesías",
                "duration_hours_minutes": "%{hours} h %{minutes} min",
                "duration_minutes": "%{minutes} min",
                "expected_cash": "Efectivo esperado",
                "expected_cash_hint": "Lo que debería haber en el cajón en este momento.",
                "journey_closes_in": "Cierra en %{duration}",
                "journey_configure": "Configurar horario",
                "journey_disabled_hint": "Esta sucursal opera sin horario fijo.",
                "journey_hours": "Horario de atención",
                "journey_not_configured_hint": "Nadie ha escrito el horario de esta sucursal, así que la caja no puede decirte qué jornada estás cubriendo.",
                "journey_opens_in": "Abre en %{duration}",
                "journey_status_closed_today": "Hoy no abre",
                "journey_status_disabled": "Sin horario fijo",
                "journey_status_not_configured": "Sin horario",
                "journey_status_open": "Abierto",
                "journey_status_opens_later": "Todavía no abre",
                "journey_zone_hint": "Hora de la sucursal",
                "kind_label": "Tipo",
                "movement_submit": "Registrar movimiento",
                "movements_count": {
                  "one": "%{count} movimiento",
                  "other": "%{count} movimientos"
                },
                "movements_description": "Entradas y salidas que no son ventas: caja chica, pagos a proveedor, depósitos al banco.",
                "movements_empty": "Todavía no registras movimientos en este turno.",
                "movements_empty_closed": "Este turno cerró sin movimientos de efectivo.",
                "movements_title": "Movimientos de efectivo",
                "movements_total": "Movimientos",
                "never_opened_title": "Todavía no abres la caja",
                "note_label": "Nota",
                "note_placeholder": "Opcional",
                "open_submit": "Abrir caja",
                "open_submit_with_stock": "Abrir caja y confirmar existencias",
                "open_title": "Turno abierto",
                "opened_by": "Abrió %{name}",
                "opening_float_hint": "Cuenta el efectivo con el que arranca el cajón.",
                "opening_float_label": "Fondo inicial",
                "outside_shift_hint": "Pagos que tus clientes hicieron desde el QR sin un turno abierto. No están en el cajón ni entran en los totales de arriba.",
                "outside_shift_title": "Cobrado fuera de turno",
                "payment_methods_empty": "Sin cobros registrados en este turno.",
                "payment_methods_title": "Cobros por método",
                "payments_count": {
                  "one": "%{count} cobro",
                  "other": "%{count} cobros"
                },
                "previous_close_open_report": "Ver el corte completo",
                "previous_close_report_title": "Corte del turno anterior",
                "previous_close_signed": "Cerró %{name} · %{time}",
                "previous_close_title": "Cómo quedó la caja",
                "reason_label": "Motivo",
                "refunds_count": {
                  "one": "%{count} devolución",
                  "other": "%{count} devoluciones"
                },
                "refunds_drawer": "Devueltas del cajón",
                "refunds_hint": "Lo que salió del cajón ya está en los movimientos. Aquí se nombra para que sepas por qué el efectivo no cuadra con las ventas.",
                "refunds_provider": "Devueltas por el procesador",
                "refunds_title": "Devoluciones",
                "report_scope": "Este corte cubre solo este turno, no el día completo.",
                "report_title_closed": "Corte del turno cerrado",
                "report_title_open": "Corte parcial del turno",
                "stock_alert_depleted": {
                  "one": "%{count} agotado",
                  "other": "%{count} agotados"
                },
                "stock_alert_low": {
                  "one": "%{count} se está acabando",
                  "other": "%{count} se están acabando"
                },
                "stock_closing_quantity": "Al cierre quedaron %{count}",
                "stock_confirm_all": "Confirmar todo igual",
                "stock_confirm_row": "Confirmar este platillo",
                "stock_empty": "Todavía no cuentas ningún platillo, así que no hay nada que arquear.",
                "stock_hint": "Arrancas con lo que quedó al cierre anterior. Confirma cada platillo o corrige el número si contaste otra cosa.",
                "stock_manage": "Administrar existencias",
                "stock_panel_counted": "Arqueadas por %{name} · %{time}",
                "stock_panel_edited": {
                  "one": "%{count} corregida al abrir",
                  "other": "%{count} corregidas al abrir"
                },
                "stock_panel_empty": "Esta sucursal no cuenta existencias de ningún platillo.",
                "stock_panel_hint": "Corrige aquí mismo si la cocina repuso. El cambio se guarda solo, sin cerrar el turno.",
                "stock_panel_title": "Existencias",
                "stock_panel_uncounted": "Este turno se abrió sin arqueo.",
                "stock_pending": {
                  "one": "Falta %{count} platillo por confirmar.",
                  "other": "Faltan %{count} platillos por confirmar."
                },
                "stock_progress": "%{confirmed} de %{total} platillos confirmados",
                "stock_quantity_label": "Existencia de %{name}",
                "stock_state_confirmed": "Confirmado",
                "stock_state_edited": "Editado",
                "stock_state_pending": "Pendiente",
                "stock_title": "Arqueo de existencias",
                "stock_zero_hint": "Un platillo en 0 no se vende hasta que cuentes existencias.",
                "tax_missing_breakdown": {
                  "one": "%{count} cobro sin desglose de impuestos.",
                  "other": "%{count} cobros sin desglose de impuestos."
                },
                "tax_status_forward_regime": "Este local cobra el impuesto sobre el precio de menú, así que el corte no lo desglosa por tasa.",
                "tax_status_itemized": "Sin cobros con impuesto en este turno.",
                "tax_status_not_recorded": "Hubo cobros en este turno, pero ninguno trae desglose de impuestos.",
                "taxes_title": "Impuestos",
                "title": "Caja",
                "unknown_actor": "Sin registrar"
              }
            }
          },
          "locations": {
            "index": {
              "create_location": "Crear sucursal",
              "create_location_comenzar_manage": "Crea una sucursal para comenzar a administrar tu operación.",
              "locations": "Tus sucursales",
              "new_location": "Nueva sucursal",
              "no_tienes_locations": "No tienes sucursales",
              "select_location_comenzar_work": "Selecciona una sucursal para comenzar a trabajar."
            },
            "new": {
              "create_location": "Crear sucursal",
              "create_location_team_can": "Crea una sucursal para que tu equipo pueda operar.",
              "location_center": "Sucursal Centro",
              "name_restaurant": "Nombre del restaurante",
              "new_location": "Nueva sucursal",
              "organization": "Grupo",
              "organization_hint": "Esta organización es quien paga la suscripción de la sucursal."
            }
          },
          "organization_invites": {
            "show": {
              "accept": "Aceptar invitación",
              "as_account": "Como %{email}.",
              "body": "%{inviter} te invitó a %{organization}.",
              "body_no_inviter": "Te invitaron a %{organization}.",
              "decline": "Rechazar",
              "expired": "Este enlace ya no sirve. Pídele a quien te invitó que te mande uno nuevo.",
              "grants": "Entrar a la organización te deja ver el comparativo de las sucursales donde ya trabajas. No te da acceso a una sucursal nueva; eso se otorga por separado.",
              "page_title": "Invitación a una organización",
              "role": "Acceso: %{role}",
              "sign_out": "Cerrar sesión",
              "wrong_account": "Esta invitación es para %{email}. Cierra la sesión y entra con esa cuenta para aceptarla."
            }
          },
          "organizations": {
            "new": {
              "billing_note": "Cada organización se cobra por su cuenta. Esta empieza sin suscripción, y sus sucursales no podrán abrir hasta que la contrates.",
              "description": "Una organización agrupa varias sucursales bajo una misma cuenta de cobro. Se factura por separado de tus otras organizaciones.",
              "name_label": "Nombre de la organización",
              "name_placeholder": "Grupo Costa",
              "page_title": "Nueva organización",
              "submit": "Crear organización"
            }
          },
          "passwords": {
            "edit": {
              "back_to_sign_in": "Volver a iniciar sesión",
              "choose_new_password": "Elige una nueva contraseña",
              "confirm_new_password": "Confirmar nueva contraseña",
              "enter_new_password_twice": "Escribe tu nueva contraseña dos veces para confirmarla",
              "new_password": "Nueva contraseña",
              "save_password": "Guardar contraseña"
            },
            "new": {
              "back_to_sign_in": "Volver a iniciar sesión",
              "email": "Correo Electrónico",
              "enter_email_send_instructions": "Ingresa tu correo y te enviaremos instrucciones para restablecerla",
              "forgot_password": "¿Olvidaste tu contraseña?",
              "m_ejemplo_com": "m@ejemplo.com",
              "send_instructions": "Enviar instrucciones"
            }
          },
          "registrations": {
            "new": {
              "already_tienes_bill": "¿Ya tienes una cuenta?",
              "card_description": "Tarda menos de un minuto. No pedimos tarjeta.",
              "card_title": "Tu cuenta",
              "confirm_password": "Confirmar Contraseña",
              "continue_with_google": "Continuar con Google",
              "email": "Correo Electrónico",
              "john_doe": "Juan Pérez",
              "m_ejemplo_com": "m@ejemplo.com",
              "name": "Nombre",
              "next_hint": "Siguiente: le pones nombre a tu restaurante.",
              "opens_note": "Tu sucursal abre sola en cuanto entra el primer pago.",
              "or_with_email": "o con tu correo",
              "password": "Contraseña",
              "proof_no_card_description": "Configuras a tu ritmo. El pago es el último paso de la lista, y es justo el que abre las puertas.",
              "proof_no_card_title": "Sin tarjeta para empezar",
              "proof_price_description": "Más IVA. Sin plazo forzoso, y con todo el producto adentro.",
              "proof_price_title": "%{amount} MXN al mes por sucursal",
              "proof_web_description": "Se abre en el navegador del celular, la tablet o la computadora. Ningún equipo que comprar.",
              "proof_web_title": "Nada que instalar",
              "start_session": "Iniciar sesión",
              "step_account_description": "Tu nombre, tu correo y una contraseña. Con esta cuenta entras a Menny.",
              "step_account_now": "Ahora",
              "step_account_title": "Tu cuenta",
              "step_badge": "Paso 1 de 2",
              "step_location_description": "Le pones nombre y queda creado. De ahí en adelante configuras a tu ritmo.",
              "step_location_title": "Tu restaurante",
              "submit": "Continuar a mi restaurante",
              "submit_processing": "Creando tu cuenta",
              "subtitle": "Empiezas por tu cuenta. En el siguiente paso le pones nombre a tu restaurante y ya puedes armar tu menú, tus mesas y tus formas de cobro.",
              "title": "Crea tu restaurante"
            }
          },
          "sessions": {
            "new": {
              "continue_with_google": "Continuar con Google",
              "email": "Correo Electrónico",
              "forgot_password": "¿Olvidaste tu contraseña?",
              "m_ejemplo_com": "m@ejemplo.com",
              "no_tienes_bill": "¿No tienes una cuenta?",
              "password": "Contraseña",
              "register": "Regístrate",
              "sign_session_manage_restaurants": "Inicia sesión para administrar tus restaurantes",
              "start_session": "Iniciar Sesión",
              "welcome_new": "Bienvenido de nuevo"
            }
          },
          "staff_invites": {
            "accept_btn": "Aceptar invitación y unirse",
            "decline_btn": "Ignorar y crear mi propio restaurante",
            "description": "Tienes una invitación pendiente para unirte a un restaurante.",
            "hello": "Hola %{name}, te invitaron a unirte a:",
            "title": "Invitación Recibida"
          }
        },
        "user": {
          "dashboards": {
            "show": {
              "create_bill": "Crear cuenta",
              "order_pickup": "Ordenar para recoger",
              "scan_code_qr_table": "Escanea el código QR de tu mesa para empezar a ordenar, o continúa como invitado para probar el menú.",
              "welcome_menny": "Bienvenido a Menny"
            }
          },
          "invites": {
            "ask": {
              "action": "Pedir que me abran la mesa",
              "explanation": "Tu nombre le llega al restaurante y a quienes ya están en la mesa. Aparece en la cuenta para que sepan quién pidió qué.",
              "label": "Tu nombre",
              "placeholder": "Ana María",
              "title": "¿Cómo te llamas?"
            },
            "expired": {
              "body": "Tu solicitud venció. Puedes pedirlo otra vez.",
              "title": "Nadie respondió a tiempo"
            },
            "identify": {
              "action": "Unirme a la mesa",
              "explanation": "Tu nombre aparece en la cuenta para que tu mesa sepa quién pidió qué.",
              "label": "Tu nombre",
              "placeholder": "Ana María",
              "title": "¿Cómo te llamas?"
            },
            "menu": {
              "ask_action": "Pedir que me abran la mesa",
              "ask_action_occupied": "Pedir unirme a esta mesa",
              "read_only_note": "Estás viendo el menú. Para ordenar, pide que te abran la mesa."
            },
            "refused": {
              "body": "Acércate a alguien del restaurante para que te abran la mesa.",
              "title": "No autorizaron tu entrada"
            },
            "show": {
              "bill": "Cuenta #",
              "can_pay": "Puedes pagar",
              "continue_menu": "Continuar al menú",
              "continue_payment": "Continuar pago",
              "invite_invalid": "Invitación inválida",
              "no_orders": "Todavía no hay órdenes en esta cuenta."
            },
            "waiting": {
              "body": "En cuanto alguien confirme, entras. No cierres esta pantalla.",
              "title": "Le avisamos al restaurante"
            }
          },
          "invoices": {
            "issued": {
              "delivery_note": "El XML y el PDF te los entrega el restaurante. Si los necesitas ya, muéstrales este folio.",
              "folio": "Folio fiscal (UUID)",
              "legal_name": "Razón social",
              "pending_body": "La estamos generando. Puede tardar unos minutos; no tienes que hacer nada.",
              "rfc": "RFC",
              "stamped_at": "Timbrada el",
              "stamped_body": "Ya quedó timbrada ante el SAT. Guarda el folio fiscal.",
              "title": "Tu factura"
            },
            "show": {
              "subtitle": "Con tus datos fiscales, sin crear cuenta.",
              "title": "Factura tu consumo"
            },
            "unavailable": {
              "body": "Este enlace no sirve para facturar. Puede que ya haya vencido el plazo, que la cuenta ya esté facturada o que el restaurante todavía no emita facturas. Pregúntale al restaurante.",
              "title": "No podemos facturar esto"
            }
          },
          "orders": {
            "index": {
              "not_yet_no_have_done": "Aún no has hecho pedidos",
              "orders": "Mis pedidos",
              "this_visit": "Lo que pediste en esta visita",
              "when_add_dishes_bill_appear": "Cuando agregues platos a tu cuenta, aparecerán aquí para que sigas el estado en tiempo real."
            }
          },
          "passwords": {
            "edit": {
              "description": "Escríbela dos veces para confirmarla.",
              "password": "Contraseña",
              "password_confirmation": "Confirmar contraseña",
              "submit": "Guardar contraseña",
              "title": "Elige tu contraseña"
            },
            "new": {
              "back_to_sign_in": "Volver a iniciar sesión",
              "description": "Escribe tu correo y te enviamos un enlace para crear o restablecer tu contraseña.",
              "email": "Correo electrónico",
              "email_placeholder": "m@ejemplo.com",
              "submit": "Enviar enlace",
              "title": "Recupera tu acceso"
            }
          },
          "payment_methods": {
            "index": {
              "empty_hint": "Cuando guardes una tarjeta, aparecerá aquí para que no tengas que capturarla en cada visita.",
              "empty_title": "Todavía no guardas ninguna tarjeta",
              "title": "Métodos de pago"
            }
          },
          "profiles": {
            "settings": {
              "title": "Configuración"
            }
          },
          "receipts": {
            "index": {
              "dine_in": "En el restaurante",
              "empty_hint": "Cuando cierres tu cuenta en un restaurante, el recibo de esa visita aparecerá aquí.",
              "empty_title": "Todavía no tienes recibos",
              "items": {
                "one": "1 platillo",
                "other": "%{count} platillos"
              },
              "next": "Siguientes",
              "page_of": "%{page} de %{total}",
              "pickup": "Para llevar",
              "previous": "Anteriores",
              "title": "Recibos"
            }
          },
          "registrations": {
            "new": {
              "already_tienes_bill": "¿Ya tienes una cuenta?",
              "back_dashboard": "Volver al dashboard",
              "confirm_password": "Confirmar Contraseña",
              "continue_with_google": "Continuar con Google",
              "email": "Correo Electrónico",
              "john_doe": "Juan Pérez",
              "m_ejemplo_com": "m@ejemplo.com",
              "name": "Nombre",
              "or": "o",
              "password": "Contraseña",
              "register_with_email": "Registrarme con correo",
              "start_session": "Iniciar sesión"
            }
          },
          "sessions": {
            "new": {
              "continue_as_guest": "Continuar como invitado (dine-in)",
              "continue_with_google": "Continuar con Google",
              "email": "Correo Electrónico",
              "enter_email_below_start_session": "Introduce tu correo debajo para iniciar sesión en tu cuenta",
              "flow_pickup_requires_bill_registered": "El flujo pickup requiere una cuenta registrada.",
              "forgot_password": "¿Olvidaste tu contraseña?",
              "guest_continue": "Continuar como invitado",
              "guest_name_hint": "Tu nombre aparece en la cuenta para que tu mesa sepa quién pidió qué.",
              "guest_name_label": "¿Cómo te llamas?",
              "guest_name_placeholder": "Ana María",
              "m_ejemplo_com": "m@ejemplo.com",
              "no_tienes_bill": "¿No tienes una cuenta?",
              "password": "Contraseña",
              "register": "Regístrate",
              "start_session": "Iniciar Sesión",
              "welcome_new": "Bienvenido de nuevo"
            }
          }
        }
      }
    },
    "staff": {
      "cash_register": {
        "cancellation_reason_unspecified": "Sin motivo registrado",
        "cancellation_scopes": {
          "bill": "Cuenta",
          "order": "Producto"
        },
        "movement_kinds": {
          "cash_in": "Entrada",
          "cash_out": "Salida"
        },
        "movement_reasons": {
          "bank_deposit": "Depósito bancario",
          "correction": "Corrección",
          "float_top_up": "Reposición de fondo",
          "petty_cash": "Caja chica",
          "refund": "Reembolso",
          "supplier_payment": "Pago a proveedor"
        }
      },
      "locations": {
        "available": "Sucursal disponible",
        "current": "Sucursal actual",
        "status": {
          "in_production": "En producción",
          "pending_configuration": "Configuración pendiente",
          "suspended_billing": "Suspendida por cobranza"
        },
        "use": "Usar sucursal",
        "using_current": "Usando esta sucursal"
      },
      "orders": {
        "actions": {
          "cancel": "Cancelar comanda",
          "complete": "Completar",
          "mark_ready": "Marcar como listo",
          "no_show": "No se presentó",
          "picked_up": "Recogido",
          "ready_for_pickup": "Listo para recoger",
          "start_preparation": "Iniciar preparación"
        },
        "add_to_order": "Agregar a la comanda",
        "cart_title": "Comanda · %{count} %{item_label}",
        "create_order": "Crear comanda",
        "create_order_count": "Crear comanda (%{count})",
        "tap_item_to_add": "Toca un producto del menú para agregarlo",
        "view_order": "Ver comanda",
        "view_order_count": "Ver comanda · %{count} %{item_label}"
      },
      "receipt_pdf": {
        "bill": "Cuenta #%{id}",
        "disclaimer": "Este recibo no es un comprobante fiscal. Si necesitas factura, pídesela al restaurante y te mandan el enlace para generarla con tus datos.",
        "net": "Total después de reembolsos",
        "payment_method": "Forma de pago",
        "phone": "Tel. %{number}",
        "refunds": "Reembolsos",
        "service_fee": "Servicio",
        "subtotal": "Subtotal",
        "table": "%{name}",
        "tax_id": "RFC %{rfc}",
        "tax_line": "%{name} %{rate}%%",
        "taxes_included": "Impuestos incluidos",
        "tip": "Propina",
        "title": "Recibo",
        "total": "Total"
      },
      "reports": {
        "actors": {
          "system": "Cierre automático de cuenta",
          "unattributed": "Sin responsable registrado"
        },
        "capture": {
          "self_service": "Autoservicio (QR)"
        },
        "charts": {
          "buckets": {
            "day": "por día",
            "month": "por mes",
            "week": "por semana"
          },
          "no_close": "sin cierres",
          "rolled_up": "Los días se agrupan %{bucket} para que la serie quepa en la pantalla. El desglose exacto de cada día sigue en el CSV.",
          "scope": "Cada barra es %{bucket}."
        },
        "csv": {
          "columns": {
            "abc_class": "Clase ABC",
            "actor": "Responsable",
            "amount": "Monto",
            "collected": "Cobrado",
            "concept": "Concepto",
            "cost": "Costo de insumos",
            "count": "Cantidad",
            "counts_as_revenue": "Cuenta como venta",
            "cumulative_share": "Participación acumulada",
            "date": "Fecha",
            "diner_fee": "Comisión del comensal",
            "discount": "Descuento",
            "gross": "Valor de menú",
            "hour": "Hora",
            "item": "Platillo",
            "items": "Piezas",
            "kind": "Tipo",
            "lower": "Mínimo del intervalo",
            "margin": "Margen",
            "mean": "Estimado",
            "method": "Método de pago",
            "net": "Neto",
            "orders": "Comandas",
            "quantity": "Piezas",
            "rail": "Origen",
            "reason": "Motivo",
            "role": "Rol",
            "share": "Participación",
            "subtotal": "Subtotal",
            "system": "Automático",
            "tip": "Propina",
            "upper": "Máximo del intervalo",
            "value": "Valor"
          },
          "rows": {
            "average_per_shift": "Promedio por turno",
            "average_ticket": "Ticket promedio",
            "busiest_hour": "Hora más fuerte",
            "cancellations_system": "Cancelaciones automáticas al cerrar la cuenta",
            "cancellations_total": "Total de cancelaciones",
            "capture_total": "Total capturado",
            "diner_fee": "Comisión del comensal",
            "discounts_non_revenue": "Cortesías",
            "discounts_revenue": "Descuentos que siguen siendo venta",
            "discounts_total": "Total de descuentos y cortesías",
            "ends_at": "Fin",
            "first_shift_ever": "Aviso",
            "forecast_as_of": "Calculado con información hasta",
            "forecast_attempts": "Intentos",
            "forecast_exhausted": "Sin más reintentos",
            "forecast_failed_at": "Falló el",
            "forecast_history_days": "Días de historial",
            "forecast_history_shift_count": "Turnos en el historial",
            "forecast_horizon": "Horizonte",
            "forecast_interval_width": "Ancho del intervalo",
            "forecast_method": "Método",
            "forecast_pace_projected_service_days": "Días de servicio proyectados",
            "forecast_pace_projected_subtotal": "Proyección a ritmo actual",
            "forecast_pace_remaining_days": "Días restantes",
            "forecast_pace_service_days": "Días de servicio",
            "forecast_pace_subtotal": "Ventas a la fecha",
            "forecast_stale_by_days": "Días de atraso",
            "forecast_state": "Estado",
            "growth_ratio": "Variación",
            "mix_costed": "Piezas con costo conocido",
            "mix_total": "Total del mix",
            "normalize_on_average": "Aviso",
            "per_shift_growth_ratio": "Variación por turno",
            "period": "Periodo",
            "previous_period": "Periodo anterior",
            "previous_shifts": "Turnos del periodo anterior",
            "previous_subtotal": "Ventas del periodo anterior",
            "range": "Rango pedido",
            "refunds_drawer": "Reembolsos de caja",
            "refunds_provider": "Reembolsos del proveedor",
            "refunds_total": "Total de reembolsos",
            "reopenings_total": "Total de reaperturas",
            "shifts": "Turnos",
            "starts_at": "Inicio",
            "subtotal": "Ventas",
            "time_zone": "Zona horaria",
            "tip": "Propinas",
            "transactions": "Transacciones",
            "truncated": "Aviso"
          },
          "sections": {
            "bill_cancellations": "Cancelaciones de cuenta",
            "by_day": "Ventas por día",
            "by_hour": "Ventas por hora",
            "by_method": "Ventas por método de pago",
            "capture": "Capturado por",
            "discounts": "Descuentos y cortesías",
            "forecast": "Pronóstico de ventas",
            "mix": "Mix de productos",
            "order_cancellations": "Cancelaciones de línea",
            "refunds": "Reembolsos",
            "reopenings": "Reaperturas de cuenta",
            "sales": "Ventas",
            "summary": "Resumen del periodo"
          }
        },
        "export": "Descargar CSV",
        "forecast": {
          "chart_actual_label": "Real",
          "chart_band": "Banda: %{lower} – %{upper}",
          "chart_date_column": "Fecha",
          "chart_expected_label": "Estimado",
          "chart_label": "Ventas reales y estimadas",
          "chart_lower_column": "Mínimo del intervalo",
          "chart_note": "Turnos reales a la izquierda, estimado a la derecha · basado en %{history_days} días de historial (%{shifts} turnos).",
          "chart_seam_label": "Hoy",
          "chart_upper_column": "Máximo del intervalo",
          "hero_hint": "Banda: %{lower} – %{upper}",
          "hero_label": "Estimado del horizonte",
          "horizons": {
            "day": "%{count} días",
            "week": "%{count} semanas"
          },
          "method": {
            "prophet": "modelo estadístico",
            "weekday_seasonal": "mediana por día de la semana"
          },
          "pace": {
            "hint": "%{service_days} de %{projected_service_days} días de servicio · %{remaining_days} días restantes en el periodo",
            "projected_label": "Proyección a ritmo actual",
            "subtotal_label": "Ventas a la fecha",
            "title": "Ritmo del periodo actual"
          },
          "provenance": "Estimado con %{method}, con datos hasta %{as_of} · banda de confianza del %{interval}.",
          "states": {
            "failed": {
              "one": "El pronóstico falló %{count} vez. Se reintentará automáticamente.",
              "other": "El pronóstico falló %{count} veces. Se reintentará automáticamente."
            },
            "failed_exhausted": {
              "one": "El pronóstico falló %{count} vez y no se reintentará más.",
              "other": "El pronóstico falló %{count} veces y no se reintentará más."
            },
            "pending": "Estamos calculando el pronóstico. Puede tardar unos minutos.",
            "stale": {
              "one": "El pronóstico está desactualizado: los últimos datos son del %{as_of}, hace %{count} día.",
              "other": "El pronóstico está desactualizado: los últimos datos son del %{as_of}, hace %{count} días."
            },
            "unavailable": "Todavía no hay suficiente historial para generar un pronóstico."
          },
          "title": "Pronóstico de ventas"
        },
        "notes": {
          "capture_basis": "Quién capturó la comanda, no quién la atendió. No cuadra con el total de ventas.",
          "control_not_deducted": "Estas cifras no se restan de las ventas. Las ventas ya vienen netas de descuentos.",
          "external_channels": "No incluye pedidos de Uber Eats, Rappi ni DiDi Food.",
          "first_shift_ever": "Este es el primer periodo de la sucursal, así que el arranque se cuenta desde el inicio del día del primer turno y no desde un cierre anterior.",
          "former": "Ya no trabaja aquí",
          "mix_basis": "Valor de los platillos vendidos. No cuadra con el total de ventas porque se calcula sobre las líneas de la comanda, no sobre los cobros.",
          "normalize_on_average": "Los dos periodos tienen distinto número de turnos, así que la comparación se muestra por turno."
        },
        "period": {
          "empty": "Todavía no hay turnos cerrados en este periodo",
          "notes": {
            "truncated": "Este rango tiene más de %{count} turnos cerrados. Te mostramos los %{count} más recientes; para ver el resto, parte el rango en tramos más cortos."
          },
          "shift_count": {
            "one": "%{count} turno",
            "other": "%{count} turnos"
          },
          "span": "Del cierre del %{from} al cierre del %{to} · %{shifts}",
          "span_first": "Del inicio del día del %{from} al cierre del %{to} · %{shifts}"
        },
        "presets": {
          "custom": "Personalizado",
          "last_30_shifts": "Últimos 30 turnos",
          "last_90_days": "Últimos 90 días",
          "month": "Este mes",
          "quarter": "Este trimestre",
          "today": "Hoy",
          "week": "Esta semana",
          "yesterday": "Ayer"
        },
        "range": {
          "apply": "Aplicar",
          "from": "Desde",
          "hint": "Hasta %{days} días. No puedes elegir fechas futuras.",
          "invalid": "Revisa las fechas: el fin no puede ir antes del inicio.",
          "label": "Del %{from} al %{to}",
          "title": "Rango personalizado",
          "to": "Hasta",
          "too_long": "El rango no puede pasar de %{days} días. Acorta las fechas."
        },
        "reopen_reason_unspecified": "Sin motivo registrado",
        "title": "Reportes"
      },
      "stats": {
        "bucket_field": "Rango",
        "buckets": {
          "day": "un día",
          "month": "un mes",
          "week": "una semana"
        },
        "closed_buckets": {
          "day": {
            "one": "%{count} día con cierre",
            "other": "%{count} días con cierre"
          },
          "month": {
            "one": "%{count} mes con cierre",
            "other": "%{count} meses con cierre"
          },
          "week": {
            "one": "%{count} semana con cierre",
            "other": "%{count} semanas con cierre"
          }
        },
        "description": "Cómo viene el negocio en el tiempo. El corte de cada turno sigue en Reportes.",
        "empty": {
          "no_data_body": "Prueba con un rango más largo.",
          "no_data_title": "Este rango no tiene turnos cerrados",
          "no_shifts_body": "Las estadísticas se arman con turnos cerrados. Abre y cierra la caja y en el siguiente corte aparece el primer punto.",
          "no_shifts_title": "Todavía no hay nada que graficar"
        },
        "hour_map": {
          "less": "menos",
          "more": "más",
          "no_sales": "sin ventas",
          "peak": "Hora pico",
          "peak_none": "—",
          "title": "Cuándo vende el restaurante"
        },
        "kpi": {
          "average_ticket": "Ticket promedio",
          "food_cost": "Costo de alimentos %{ratio}",
          "margin": "Margen bruto",
          "net_sales": "Ventas netas",
          "new": "nuevo",
          "normalized": "delta por turno: los dos periodos no traen la misma cantidad de turnos",
          "per_bucket": "%{amount} por punto",
          "transactions": "Comandas",
          "versus": "vs %{amount}"
        },
        "leaks": {
          "bill_cancellations": "Cuentas canceladas",
          "count": {
            "one": "%{count} evento",
            "other": "%{count} eventos"
          },
          "discounts": "Descuentos",
          "no_amount": "sin monto",
          "order_cancellations": "Comandas canceladas",
          "refunds": "Reembolsos",
          "reopenings": "Reaperturas de cuenta",
          "share": "%{share} de ventas",
          "title": "Fugas"
        },
        "mix": {
          "class_a": "Clase A",
          "class_b": "Clase B",
          "class_c": "Clase C",
          "class_count": {
            "one": "%{count} platillo",
            "other": "%{count} platillos"
          },
          "item_margin": "margen %{margin}",
          "item_margin_unknown": "sin receta, todavía no hay costo",
          "item_meta": "%{abc} · %{share} del mix",
          "quantity": {
            "one": "%{count} vendido",
            "other": "%{count} vendidos"
          },
          "share_of_value": "%{share} del valor",
          "show_all": "Ver los %{count} restantes",
          "title": "Qué platillos cargan el menú"
        },
        "notes": {
          "cost_coverage": "%{costed} de %{total} platillos vendidos tienen receta. El margen se calcula solo sobre esos.",
          "hour_map_basis": "Ventas por hora y día sobre la ventana completa. Es el mapa con el que se arman los turnos.",
          "hour_map_thin": "Una ventana corta es poca base para decidir plantilla: una quincena o un puente mueven una franja entera.",
          "leaks_basis": "El porcentaje es sobre las ventas netas de la ventana. Quién y por qué está en Reportes.",
          "mix_basis": "Clasificación ABC sobre el valor de los platillos vendidos. No cuadra con ventas netas, y no debe: esto cuenta platillos, aquello cuenta pagos.",
          "open_bucket": "El punto en curso se dibuja punteado y no entra en ninguna comparativa.",
          "same_weekday": "En días la comparativa sigue siendo contra la misma cantidad de turnos previos: 30 días ya contienen semanas enteras."
        },
        "ranges": {
          "days30": "30 días",
          "months12": "12 meses",
          "weeks12": "12 semanas",
          "weeks26": "6 meses",
          "years": "Por año"
        },
        "scope": "%{label} · %{buckets} · punto = %{bucket}",
        "series": {
          "average": "Promedio por punto",
          "best": "Mejor punto",
          "open": "en curso",
          "title": "Ventas netas por punto",
          "worst": "Punto más flojo"
        },
        "title": "Estadísticas"
      },
      "tables": {
        "active_invite": "Activa",
        "alerts": {
          "awaiting_release": "Mesa pagada, falta liberarla",
          "entry_requested": "Alguien espera entrar",
          "payment_pending": "Cobro detenido sin resolver",
          "ready_unserved": "Platillo listo sin servir",
          "waiter_requested": "El comensal pidió al mesero"
        },
        "canceling": "Cancelando…",
        "closing_bill": "Cerrando…",
        "delete_category_confirm": "¿Seguro que deseas eliminar esta categoría?",
        "no_invite": "Sin invitación",
        "no_static_invite": "Sin QR impreso",
        "order_count": "%{count} %{order_label}",
        "static_invite": "Impreso"
      },
      "users": {
        "create_member": "Crear miembro",
        "create_password_help": "La contraseña es obligatoria para cuentas nuevas y opcional si reactivas un acceso eliminado.",
        "edit_password_help": "Deja la contraseña vacía si no quieres cambiarla.",
        "manager_email_help": "Los gerentes deben tener un correo explícito para recibir acceso y recuperación de cuenta.",
        "non_manager_email_help": "Para roles que no son gerente generamos un correo interno automáticamente para cumplir las validaciones.",
        "password_label_create": "Contraseña",
        "password_label_edit": "Nueva contraseña"
      }
    },
    "tables": {
      "actions": {
        "add_order": "Agregar comanda",
        "add_order_legacy": "Añadir comanda",
        "disable": "Deshabilitar",
        "invite": "Invitar",
        "occupy": "Ocupar",
        "release": "Liberar",
        "reserve": "Reservar"
      },
      "bills_count": "%{count} cuentas",
      "sessions_count": "%{count} sesiones"
    },
    "user": {
      "ask_for_more": "Pedir agua, algo más",
      "back_to_menu": "Volver al menú",
      "call_waiter": "Llamar mesero",
      "common": {
        "me": "Yo",
        "people_count": {
          "one": "%{count} persona",
          "other": "%{count} personas"
        },
        "products_count": {
          "one": "%{count} producto",
          "other": "%{count} productos"
        },
        "table_label": "Mesa %{name}",
        "waiter": "Mesero"
      },
      "confirmations": {
        "resend": "Reenviar correo de confirmación",
        "sending": "Enviando…"
      },
      "dish": {
        "add": "Agregar",
        "free": "Gratis",
        "mine_caption": "Lo pagas tú",
        "no_active_table": "Sin mesa activa",
        "no_extra": "Ninguno",
        "required": "Obligatorio",
        "share_caption": "Se divide con todos",
        "unavailable": "No disponible",
        "unavailable_reason": "Este platillo no está disponible por ahora."
      },
      "home": {
        "all_menu": "Todo el menú",
        "at_table": "En mesa %{name}",
        "default_menu": "Menú",
        "demo_mode": "Modo demo",
        "greeting": "¡Hola! 👋",
        "self_name": "tú",
        "uncategorized": "Otros"
      },
      "invite_state": {
        "bill_closed": "La cuenta seleccionada se cerró. Puedes crear una nueva cuenta."
      },
      "invites": {
        "continue_order": "Ya puedes continuar con tu pedido.",
        "process_failed": "No se pudo procesar la invitación.",
        "welcome": "Bienvenido a %{name}"
      },
      "no_customization": "Sin personalización",
      "only_mine": "Solo lo mío",
      "pay_in_cashier": "Pagar en caja",
      "payment_received": "¡Pago recibido!",
      "registrations": {
        "complete_registration": "Completa tu registro",
        "create_account": "Crea una cuenta",
        "create_description": "Introduce tus datos para registrarte en la plataforma",
        "submit_complete": "Completar registro",
        "submit_create": "Registrarse",
        "upgrade_description": "Convierte tu sesión de invitado en una cuenta registrada."
      },
      "show_qr_to_waiter": "Muestra QR al mesero",
      "tracking": {
        "active": "En curso",
        "cancelled": "Cancelado",
        "cancelled_status": "%{name} cancelado",
        "done": "Completado",
        "pending": "Pendiente",
        "preparing_status": "%{name} en preparación",
        "ready_status": "%{name} listo"
      },
      "tracking_stages": {
        "confirmed": "Confirmado",
        "in_progress": "En preparación",
        "ready": "Listo en mesa",
        "received": "Pedido recibido"
      },
      "waiter_call": {
        "call": "Llamar al mesero",
        "calling": "Llamando…",
        "cancel_action": "Sí, cancelar",
        "cancel_body": "Le avisamos al restaurante que ya no necesitas atención.",
        "cancel_title": "¿Cancelar el llamado?",
        "cancelling": "Cancelando…",
        "confirm_action": "Sí, llamar",
        "confirm_body": "Avisamos a la mesa para que alguien venga a atenderte.",
        "confirm_title": "¿Llamamos al mesero?",
        "dismiss": "Mejor no",
        "pending_action": "Mesero en camino. Toca para cancelar el llamado."
      }
    }
  }
}
